
export default [
    {
        "id": -3,
        "shikenId": -1,
        "parentNo": 1,
        "no": 1,
        "groupId": 0,
        "answerType": 1,
        "inputType": 1,
        "question1": "次のうち、最も適切なものを選びなさい。",
        "question2": "１＋１は２である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": -2,
        "shikenId": -1,
        "parentNo": 1,
        "no": 2,
        "groupId": 0,
        "answerType": 1,
        "inputType": 1,
        "question1": "次のうち、最も適切なものを選びなさい。",
        "question2": "１＋１＝",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": -1,
        "shikenId": 0,
        "parentNo": 1,
        "no": 1,
        "groupId": 0,
        "answerType": 1,
        "inputType": 1,
        "question1": "次のうち、最も適切なものを選びなさい。",
        "question2": "１＋１は２である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 0,
        "shikenId": 0,
        "parentNo": 1,
        "no": 2,
        "groupId": 0,
        "answerType": 1,
        "inputType": 1,
        "question1": "次のうち、最も適切なものを選びなさい。",
        "question2": "１＋１＝",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1,
        "shikenId": 1,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "税理士資格を有しないファイナンシャル・プランナーが顧客からの要望により確定申告書を作成した場合、それが無償であれば税理士法に抵触しない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 2,
        "shikenId": 1,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "労働者災害補償保険（労災保険）の保険料は、労働者と事業主が折半で負担する。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 3,
        "shikenId": 1,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "公的介護保険の第２号被保険者は、市町村または特別区の区域内に住所を有する65歳以上の者である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 4,
        "shikenId": 1,
        "parentNo": 1,
        "no": 4,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "確定拠出年金（個人型）の老齢給付金を一時金で受け取った場合、当該老齢給付金は、退職所得として所得税の課税対象となる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 5,
        "shikenId": 1,
        "parentNo": 1,
        "no": 5,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "国民年金の付加保険料納付済期間を有する者が、老齢基礎年金の繰上げ支給の申出をした場合、付加年金は、老齢基礎年金と同様の減額率によって減額される。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 6,
        "shikenId": 1,
        "parentNo": 1,
        "no": 6,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "国内銀行の窓口において加入した個人年金保険は、生命保険契約者保護機構による補償の対象とならない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 7,
        "shikenId": 1,
        "parentNo": 1,
        "no": 7,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "延長保険とは、一般に、現在加入している生命保険の保険料の払込みを中止し、その時点での解約返戻金を基に、元契約の保険金額を変えずに一時払いの定期保険に変更する制度である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 8,
        "shikenId": 1,
        "parentNo": 1,
        "no": 8,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "逓減定期保険は、保険期間の経過に伴い保険料が所定の割合で減少するが、死亡保険金は保険期間を通じて一定である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 9,
        "shikenId": 1,
        "parentNo": 1,
        "no": 9,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "国内旅行傷害保険では、一般に、国内旅行中に発生した地震や津波によるケガも補償の対象としている。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10,
        "shikenId": 1,
        "parentNo": 1,
        "no": 10,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "生命保険の保険料は、純保険料および付加保険料で構成されているが、このうち純保険料は予定死亡率を用いて計算され、付加保険料は予定利率や予定事業費率を用いて計算される。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11,
        "shikenId": 1,
        "parentNo": 1,
        "no": 11,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "日経平均株価は、東京証券取引所プライム市場に上場する代表的な225銘柄を対象として算出される株価指標である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 12,
        "shikenId": 1,
        "parentNo": 1,
        "no": 12,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "国内総生産（GDP）は、一定期間内に国内で生産された財やサービスの付加価値の総額を示すものであり、海外で生産された付加価値は含まれない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 13,
        "shikenId": 1,
        "parentNo": 1,
        "no": 13,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "短期利付債と長期利付債を比較した場合、他の条件が同じであれば、一般に長期利付債のほうが金利変動に伴う債券価格の変動が大きい。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 14,
        "shikenId": 1,
        "parentNo": 1,
        "no": 14,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "証券取引所における株式の売買において、成行注文は指値注文に優先して売買が成立する。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 15,
        "shikenId": 1,
        "parentNo": 1,
        "no": 15,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "NISAの「成長投資枠」を利用して上場株式等を購入することができる限度額（非課税投資枠）は、年間240万円である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 16,
        "shikenId": 1,
        "parentNo": 1,
        "no": 16,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "税金を負担する者と税金を納める者が異なる税を間接税といい、間接税の例として、消費税や所得税などが挙げられる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 17,
        "shikenId": 1,
        "parentNo": 1,
        "no": 17,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "所得税において、2025年中に取得した建物（鉱業用減価償却資産等を除く）に係る減価償却の方法は、定率法である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 18,
        "shikenId": 1,
        "parentNo": 1,
        "no": 18,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "納税者の配偶者が青色事業専従者として給与の支払を受けている場合、当該納税者は配偶者控除の適用を受けることができない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 19,
        "shikenId": 1,
        "parentNo": 1,
        "no": 19,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "所得税において、事業的規模で行われている賃貸マンションの貸付による所得は、事業所得となる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 20,
        "shikenId": 1,
        "parentNo": 1,
        "no": 20,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "不動産の登記事項証明書の交付請求は、インターネットを利用してオンラインで行うことができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 21,
        "shikenId": 1,
        "parentNo": 1,
        "no": 21,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "不動産登記には公信力がないため、登記記録を確認し、その登記記録の内容が真実であると信じて取引した場合でも、法的に保護されるとは限らない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 22,
        "shikenId": 1,
        "parentNo": 1,
        "no": 22,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "不動産の売買契約を解除する場合、相手方が契約の履行に着手した後であっても、買主は手付金の放棄、売主はその倍額を現実に提供することにより契約を解除することができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 23,
        "shikenId": 1,
        "parentNo": 1,
        "no": 23,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "市街化調整区域において行う開発行為で、その規模が1,000㎡未満であるものは、原則として都道府県知事の許可を受ける必要はない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 24,
        "shikenId": 1,
        "parentNo": 1,
        "no": 24,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "アパートやマンションの所有者が、当該建物の賃貸を自ら業として行う場合、宅地建物取引業の免許を取得する必要はない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 25,
        "shikenId": 1,
        "parentNo": 1,
        "no": 25,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "都市計画区域内の防火地域内に耐火建築物を建築する場合、建築基準法による建蔽率および容積率の制限について緩和を受けることができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 26,
        "shikenId": 1,
        "parentNo": 1,
        "no": 26,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "書面によらない贈与契約は、その履行前であれば、各当事者は契約の解除を申し出ることができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 27,
        "shikenId": 1,
        "parentNo": 1,
        "no": 27,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "父からの贈与について相続時精算課税制度の適用を受けている子は、同一年中に母から受けた財産の贈与については、暦年課税により贈与税額を計算することができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 28,
        "shikenId": 1,
        "parentNo": 1,
        "no": 28,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "「配偶者に対する相続税額の軽減」の適用を受けた場合、被相続人の配偶者の相続税の課税価格が、相続税の課税価格の合計額に対する配偶者の法定相続分または１億6,000万円のいずれか多い額までであれば、配偶者の納付すべき相続税額は算出されない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 29,
        "shikenId": 1,
        "parentNo": 1,
        "no": 29,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "個人が法人からの贈与により財産を取得した場合、取得した財産は贈与税の課税対象となる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 30,
        "shikenId": 1,
        "parentNo": 1,
        "no": 30,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "個人間での取引において、時価と比べて著しく低い価額の対価で財産の譲渡が行われた場合、原則として、その譲渡があった時の当該財産の時価と譲渡対価の差額に相当する金額が、贈与税の課税対象となる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 31,
        "shikenId": 1,
        "parentNo": 2,
        "no": 31,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "利率（年率）３％で複利運用しながら10年後に800万円を得たい場合、必要となる元本を試算する際に目標とする額に乗じる係数は、（　　　）である。",
        "choice1": "1）現価係数",
        "choice2": "2）資本回収係数",
        "choice3": "3）減債基金係数",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 32,
        "shikenId": 1,
        "parentNo": 2,
        "no": 32,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "健康保険の被保険者が、業務外での病気やケガの治療のため、連続して（　①　）仕事を休んでいる場合に支給される傷病手当金の金額は、原則として、休業１日につき支給開始日の属する月以前12カ月間の各月の標準報酬月額の平均額を30で除した金額に、（　②　）を乗じた額である。",
        "choice1": "1）① ２日以上　② ２分の１",
        "choice2": "2）① ３日以上　② ３分の２",
        "choice3": "3）① 10日以上　② ４分の３",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 33,
        "shikenId": 1,
        "parentNo": 2,
        "no": 33,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "全国健康保険協会管掌健康保険の被保険者である会社員が退職し、資格喪失日から（　①　）以内に所定の申出をすることで、最長（　②　）、任意継続被保険者となることができる。",
        "choice1": "1）① 10日　② １年間",
        "choice2": "2）① 20日　② ２年間",
        "choice3": "3）① １カ月　② ３年間",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 34,
        "shikenId": 1,
        "parentNo": 2,
        "no": 34,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "住宅ローンの返済方法のうち、元利均等返済は、毎月の返済額が（　①　）、返済期間の経過とともに毎月の元金の返済額が（　②　）返済方法である。",
        "choice1": "1）① 減少し　② 増加する",
        "choice2": "2）① 一定で　② 減少する",
        "choice3": "3）① 一定で　② 増加する",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 35,
        "shikenId": 1,
        "parentNo": 2,
        "no": 35,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "遺族厚生年金の額は、原則として、死亡した者の厚生年金保険の被保険者期間を基礎として計算した老齢厚生年金の報酬比例部分の額の（　①　）に相当する額となる。また、死亡した者が短期要件に該当する場合、被保険者期間の月数が（　②　）に満たなければ、（　②　）として計算する。",
        "choice1": "1）① ３分の２　② 240月",
        "choice2": "2）① ４分の３　② 300月",
        "choice3": "3）① ５分の４　② 360月",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 36,
        "shikenId": 1,
        "parentNo": 2,
        "no": 36,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "定期保険特約付終身保険（更新型）の契約内容を変更せずに自動更新すると、更新後の保険料は、通常、更新前と比較して（　　　）。",
        "choice1": "1）変わらない",
        "choice2": "2）高くなる",
        "choice3": "3）安くなる",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 37,
        "shikenId": 1,
        "parentNo": 2,
        "no": 37,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "変額個人年金保険は、（　①　）の運用実績に基づいて将来受け取る年金額等が変動するが、一般に、（　②　）については最低保証がある。",
        "choice1": "1）① 特別勘定　② 死亡給付金額",
        "choice2": "2）① 特別勘定　② 解約返戻金額",
        "choice3": "3）① 一般勘定　② 解約返戻金額",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 38,
        "shikenId": 1,
        "parentNo": 2,
        "no": 38,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "自動車損害賠償責任保険から支払われる、被害者１人当たりの保険金の限度額は、死亡の場合は（　①　）、後遺障害の場合は障害の程度に応じて最高（　②　）となる。",
        "choice1": "1）① 1,000万円　② 2,500万円",
        "choice2": "2）① 3,000万円　② 4,000万円",
        "choice3": "3）① 4,000万円　② 3,000万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 39,
        "shikenId": 1,
        "parentNo": 2,
        "no": 39,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "個人賠償責任保険（特約）では、（　　　）、法律上の損害賠償責任を負うことによって被る損害は、補償の対象とはならない。",
        "choice1": "1）被保険者の子供がボール遊びをしていて、他人の家の窓ガラスを割ってしまい",
        "choice2": "2）被保険者が自転車で走行中に歩行者に衝突し、ケガをさせてしまい",
        "choice3": "3）被保険者が友人から借りていたカメラを落として壊してしまい",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 40,
        "shikenId": 1,
        "parentNo": 2,
        "no": 40,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "国内で事業を行う生命保険会社が破綻した場合、原則として、破綻した時点における（　①　）の（　②　）までの金額が生命保険契約者保護機構により補償される。",
        "choice1": "1）① 保険金額　　② 50％",
        "choice2": "2）① 解約返戻金　② 80％",
        "choice3": "3）① 責任準備金　② 90％",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 41,
        "shikenId": 1,
        "parentNo": 2,
        "no": 41,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "表面利率（クーポンレート）２％、残存期間４年の固定利付債券を額面100円当たり106円で購入した場合の最終利回り（年率・単利）は（　　　）である。なお、税金等は考慮しないものとし、計算結果は表示単位の小数点以下第３位を四捨五入している。",
        "choice1": "1）0.23％",
        "choice2": "2）0.47％",
        "choice3": "3）0.62％",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 42,
        "shikenId": 1,
        "parentNo": 2,
        "no": 42,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "異なる２資産から構成されているポートフォリオにおいて、２資産間の相関係数が（　①　）である場合、２つの資産が（　②　）値動きをするため、分散投資によるリスクの低減効果は最大となる。",
        "choice1": "1）① −１　② 反対の",
        "choice2": "2）① ０　　② 反対の",
        "choice3": "3）① １　　② 同じ",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 43,
        "shikenId": 1,
        "parentNo": 2,
        "no": 43,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "（　　　）は、預金保険制度による保護の対象とならない。",
        "choice1": "1）普通預金",
        "choice2": "2）定期預金",
        "choice3": "3）外貨預金",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 44,
        "shikenId": 1,
        "parentNo": 2,
        "no": 44,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "追加型株式投資信託を基準価格10,000円（１万口当たり）で１万口購入した後、最初の決算期に１万口当たり500円の収益分配金が支払われ、分配落ち後の基準価格が9,700円（１万口当たり）となった場合、受け取った収益分配金のうち、普通分配金は（　①　）であり、元本払戻金（特別分配金）は（　②　）である。",
        "choice1": "1）① 500円　② 0円",
        "choice2": "2）① 200円　② 300円",
        "choice3": "3）① 300円　② 200円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 45,
        "shikenId": 1,
        "parentNo": 2,
        "no": 45,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "元金1,000,000円を、年利３％（１年複利）で３年間運用した場合の元利合計金額は、税金や手数料等を考慮しない場合、（　　　）である。",
        "choice1": "1）1,009,000円",
        "choice2": "2）1,060,900円",
        "choice3": "3）1,092,727円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 46,
        "shikenId": 1,
        "parentNo": 2,
        "no": 46,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "定年退職により退職金を受け取ったことによる退職所得の金額の計算上、収入金額から控除する退職所得控除額は、勤続年数が20年以下の期間については勤続年数に（　①　）を乗じて計算し、20年を超える期間については１年につき（　②　）を乗じて計算したものを合算する。",
        "choice1": "1）① 30万円　② 60万円",
        "choice2": "2）① 40万円　② 70万円",
        "choice3": "3）① 70万円　② 100万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 47,
        "shikenId": 1,
        "parentNo": 2,
        "no": 47,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "Ａさんの2025年分の各種所得の金額が下記の場合、総所得金額は（　　　）となる。<br><br>〈Aさんの2025年分の各種所得の金額〉<br><img src='/img/47.png' width='340'>",
        "choice1": "1）270万円",
        "choice2": "2）300万円",
        "choice3": "3）570万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 48,
        "shikenId": 1,
        "parentNo": 2,
        "no": 48,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税において、2012年１月１日以後に締結した生命保険契約に係る介護医療保険料控除の控除限度額は（　①　）であり、一般の生命保険料控除と個人年金保険料控除の控除額を合わせた控除限度額は（　②　）である。",
        "choice1": "1）① ３万円　② ５万円",
        "choice2": "2）① ４万円　② 12万円",
        "choice3": "3）① ５万円　② 10万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 49,
        "shikenId": 1,
        "parentNo": 2,
        "no": 49,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "住宅ローンを利用してマンションを取得し、所得税の住宅借入金等特別控除の適用を受ける場合、借入金の償還期間は（　①　）以上でなければならない。また、取得等した家屋の床面積が50㎡以上で、かつ、その（　②　）以上に相当する部分が専ら自己の居住の用に供されるものでなければならない。",
        "choice1": "1）① 10年　② ２分の１",
        "choice2": "2）① 10年　② ３分の２",
        "choice3": "3）① 15年　② ３分の１",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 50,
        "shikenId": 1,
        "parentNo": 2,
        "no": 50,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "居住者が日本国内において支払を受ける普通預金の利子は、所得税および復興特別所得税と住民税の合計で（　　　）の税率による源泉分離課税の対象となる。",
        "choice1": "1）10.21％",
        "choice2": "2）15.315％",
        "choice3": "3）20.315％",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 51,
        "shikenId": 1,
        "parentNo": 2,
        "no": 51,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税の計算において、個人が土地や建物等を譲渡したことによる譲渡所得が長期譲渡所得に区分されるためには、当該土地や建物を譲渡した年の１月１日における所有期間が（　　　）を超えていなければならない。",
        "choice1": "1）３年",
        "choice2": "2）５年",
        "choice3": "3）10年",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 52,
        "shikenId": 1,
        "parentNo": 2,
        "no": 52,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "個人が自宅の土地および建物を譲渡し、「居住用財産を譲渡した場合の長期譲渡所得の課税の特例」（軽減税率の特例）の適用を受けた場合、当該譲渡に係る課税長期譲渡所得金額のうち、6,000万円以下の部分については、所得税（　①　）、住民税４％の税率で課税され、6,000万円を超える部分については所得税（　②　）、住民税５％の税率で課税される。なお、復興特別所得税は考慮しないものとする。",
        "choice1": "1）① ５％　② 10％",
        "choice2": "2）① 10％　② 15％",
        "choice3": "3）① 15％　② 20％",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 53,
        "shikenId": 1,
        "parentNo": 2,
        "no": 53,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "投資総額１億円で購入した賃貸用不動産の年間収入の合計額が2,500万円、年間費用の合計額が2,000万円であった場合、この賃貸用不動産の純利回り（NOI利回り）は、（　　　）である。",
        "choice1": "1）2％",
        "choice2": "2）4％",
        "choice3": "3）5％",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 54,
        "shikenId": 1,
        "parentNo": 2,
        "no": 54,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "宅地建物取引業法によると、宅地建物取引業者が依頼人と締結する宅地または建物の売買の媒介契約のうち、専任媒介契約の有効期間は最長で（　　　）である。",
        "choice1": "1）１カ月",
        "choice2": "2）３カ月",
        "choice3": "3）６カ月",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 55,
        "shikenId": 1,
        "parentNo": 2,
        "no": 55,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "区分建物（マンションなど）に係る登記記録に記載されている区分建物の床面積は、壁その他の区画の内側線で囲まれた部分の（　　　）によって算出される。",
        "choice1": "1）水平面積",
        "choice2": "2）内法面積",
        "choice3": "3）壁芯面積",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 56,
        "shikenId": 1,
        "parentNo": 2,
        "no": 56,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "下記の〈親族関係図〉において、Aさんの相続における父Ｄさんの法定相続分は（　①　）であり、妻Ｂさんの法定相続分は（　②　）である。<br><br><img src='/img/56.png' width='570'>",
        "choice1": "1）① ３分の１　② ３分の２",
        "choice2": "2）① ４分の１　② ４分の３",
        "choice3": "3）① ２分の１　② ２分の１",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 57,
        "shikenId": 1,
        "parentNo": 2,
        "no": 57,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "2025年３月15日に死亡したＡさんが所有していた上場株式Ｘを相続により取得した場合の１株当たりの相続税評価額は、下記の〈資料〉によると（　　　）である。<br><br>〈資料〉上場株式Xの価格<br><img src='/img/57.png' width='400'>",
        "choice1": "1）417円",
        "choice2": "2）420円",
        "choice3": "3）400円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 58,
        "shikenId": 1,
        "parentNo": 2,
        "no": 58,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "相続において相続人が取得した宅地が「小規模宅地等についての相続税の課税価格の計算の特例」における特定事業用宅地等に該当する場合、その宅地のうち（　①　）までを限度面積として、評価額の（　②　）相当額を減額した金額を、相続税の課税価格に算入すべき価額とすることができる。",
        "choice1": "1）① 200㎡　② 50％",
        "choice2": "2）① 330㎡　② 80％",
        "choice3": "3）① 400㎡　② 80％",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 59,
        "shikenId": 1,
        "parentNo": 2,
        "no": 59,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "相続税のいわゆる準確定申告は、原則として、相続があったことを知った日の翌日から（　　　）以内に行わなければならない。",
        "choice1": "1）３カ月",
        "choice2": "2）４カ月",
        "choice3": "3）10カ月",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 60,
        "shikenId": 1,
        "parentNo": 2,
        "no": 60,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "被相続人の（　　　）が相続により財産を取得した場合、その者は相続税額の２割加算の対象となる。",
        "choice1": "1）兄弟姉妹",
        "choice2": "2）父母",
        "choice3": "3）孫（子の代襲相続人）",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 61,
        "shikenId": 1,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Mさんは、〈Ａさんおよび妻Ｂさんに関する資料〉に基づき、Ａさんの老齢基礎年金の年金額（2025年度評価額）を試算した。Ａさんが60歳から老齢基礎年金の支給繰上げを請求する場合、受給できる金額の計算式として最も適切なものはどれか。",
        "choice1": "<img src='/img/question/61_1.png' style='margin-top: -10px;margin-bottom:35px;height:58px'>",
        "choice2": "<img src='/img/question/62_1.png' style='margin-top: -10px;margin-bottom:35px;height:58px'>",
        "choice3": "<img src='/img/question/63_1.png' style='margin-top: -10px;margin-bottom:0px;height:58px'>",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "4",
        "image": "2-1.png"
    },
    {
        "id": 62,
        "shikenId": 1,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "次に、Ｍさんは、Ａさんおよび妻Ｂさんが受給することができる公的年金制度の老齢給付について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「Ａさんには特別支給の老齢厚生年金は支給されませんが、妻のＢさんには特別支給の老齢厚生年金が支給されます」",
        "choice2": "「Ａさんが65歳から受給することができる老齢厚生年金の額には、配偶者の加給年金額は加算されません」",
        "choice3": "「妻Ｂさんが65歳から老齢基礎年金を受給する場合、老齢基礎年金の額に振替加算額が加算されます」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "2-1.png"
    },
    {
        "id": 63,
        "shikenId": 1,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "最後に、Mさんは、公的介護保険（以下、「介護保険」という）の保険給付について説明した。MさんのAさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「介護保険の保険者（運営主体）は市区町村であるため、介護保険の保険給付を受けるためには、市町村（特別区を含む）から要介護認定または要支援認定を受ける必要があります」",
        "choice2": "「介護保険の第２号被保険者であるＡさんが、介護サービスの提供を受けた場合、原則として、実際にかかった費用の２割または３割を自己負担する必要があります」",
        "choice3": "「40歳以上65歳未満の第２号被保険者は、要介護状態または要支援状態となった原因が、初老期における認知症、脳血管疾患などの加齢に伴う特定疾病である場合に限り、介護給付または予防給付を受けることができます」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "2-1.png"
    },
    {
        "id": 64,
        "shikenId": 1,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "はじめに、Mさんは、NISAの「つみたて投資枠」の概要について説明した。MさんがAさんに対して説明した以下の文章の空欄①〜③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br><br><div class='b-box'>　NISAの「つみたて投資枠」は、株式投資信託や（　①　）のうち一定の要件を満たすものが対象で、対象銘柄を指定したうえで、累積投資契約に基づく定期かつ継続的な買付けを行います。非課税投資枠は年間（　②　）、非課税期間は（　③　）です。</div>",
        "choice1": "① ETF ② 120万円 ③ 無期限",
        "choice2": "① J-REIT ② 40万円 ③ 最長10年間",
        "choice3": "① ETF ② 120万円 ③ 最長５年間",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "2-2.png"
    },
    {
        "id": 65,
        "shikenId": 1,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "次に、Mさんは、NISAを利用して購入した投資信託に係る課税関係について説明した。MさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「NISAを利用して購入した株式投資信託を解約した際に損失が生じた場合、その損失の金額は、特定口座で保有する上場株式等の譲渡益と損益通算することができません」",
        "choice2": "「NISAを利用して購入した株式投資信託の普通分配金は、非課税の対象とはらず、20.315％相当額が源泉徴収等されます」",
        "choice3": "「NISAを利用して購入した株式投資信託を、購入した年に解約した場合、当該譲渡益は非課税となります」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "2-2.png"
    },
    {
        "id": 66,
        "shikenId": 1,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "最後に、Mさんは、Ｘ社株式の投資指標について説明した。MさんのAさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「株価の相対的な割高・割安を判断する指標として、PER（株価収益率）があります。〈Ｘ社に関する資料〉から算出されるＸ社株式のPER（株価収益率）は16倍です」",
        "choice2": "「株価の相対的な割高・割安を判断する指標として、PBR（株価純資産倍率）があります。〈Ｘ社に関する資料〉から算出されるＸ社株式のPBR（株価純資産倍率）は1.6倍です」",
        "choice3": "「株価に対する１株当たりの年間配当金の割合を示す指標を配当利回りといいます。〈Ｘ社に関する資料〉から算出されるX社株式の配当利回りは４％です」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "4",
        "image": "2-2.png"
    },
    {
        "id": 67,
        "shikenId": 1,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税における医療費控除に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「Ａさんが、2025年中に支払った医療費について医療費控除の適用を受けるためには、確定申告をする必要があります」",
        "choice2": "「生命保険契約から支払われた入院給付金や健康保険から支給を受けた高額療養費がある場合、支払った医療費の総額からそれらの金額を控除する必要があります」",
        "choice3": "「Ａさんが2025年中に支払った医療費の金額の合計額が20万円を超えていない場合、医療費控除額は算出されません」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "2-3.png"
    },
    {
        "id": 68,
        "shikenId": 1,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税における総所得金額は、次のうちどれか。なお、Ａさんは青色申告者ではないものとする。",
        "choice1": "680万円",
        "choice2": "620万円",
        "choice3": "586万円<br><br><br><img src=\"/img/question/68_2.png\" width=\"500\" />",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "4",
        "image": "2-3.png"
    },
    {
        "id": 69,
        "shikenId": 1,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税における所得控除に関する以下の文章の空欄①〜③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br> <br> <div class='b-box'>ⅰ）合計所得金額1,000万円以下のＡさんが適用を受けることができる配偶者控除の控除額は、（　①　）です。<br>ⅱ）Ａさんが適用を受けることができる長男Cさんに係る扶養控除の控除額は、（　②　）です。<br>ⅲ）Ａさんが拠出した確定拠出年金の個人型年金の掛金は、その全額が（　③　）の対象となり、総所得金額から控除することができます。</div>",
        "choice1": "① 26万円 ② 38万円 ③ 社会保険料控除",
        "choice2": "① 38万円 ② 38万円 ③ 小規模企業共済等掛金控除",
        "choice3": "① 38万円 ② 63万円 ③ 社会保険料控除",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "2-3.png"
    },
    {
        "id": 70,
        "shikenId": 1,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "甲土地に耐火建築物を建築する場合の①建蔽率の上限となる建築面積と②容積率の上限となる延べ面積の組合せとして、次のうち最も適切なものはどれか。",
        "choice1": "① 400㎡ ② 2,560㎡",
        "choice2": "① 400㎡ ② 1,600㎡",
        "choice3": "① 320㎡ ② 1,280㎡",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "4",
        "image": "2-4.png"
    },
    {
        "id": 71,
        "shikenId": 1,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "事業用定期借地権方式に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「事業用定期借地権方式とは、X社が甲土地を契約で一定期間賃借し、X社が建物を建設する手法です。Aさんは土地を手放さずに安定した地代収入を得ることができ、契約期間満了時には土地が更地で返還されます」",
        "choice2": "「事業用定期借地権方式によりＡさんが甲土地をX社に賃貸した後にＡさんの相続が開始した場合、相続税の課税価格の計算上、甲土地は貸家建付地として評価されますので、相続税額の軽減効果があります」",
        "choice3": "「事業用定期借地権の設定契約は、公正証書により行わなければなりません」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "2-4.png"
    },
    {
        "id": 72,
        "shikenId": 1,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "不動産の価格に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「 《設例》の図では相続税路線価が表示されていますが、この道路に示された「200Ｄ」とは、１㎡当たりの価額が20万円、借地権割合が60％であることを示しています」",
        "choice2": "「土地の価格には、『実勢価格（取引価格）』 『公示価格』 『基準地標準価格』 『相続税路線価』 『固定資産税評価額』の５つがあるといわれ、このうち相続税路線価は公示価格の６割程度に設定されています」",
        "choice3": "「公示価格は、毎年１月１日を基準日として、国土交通省の土地鑑定委員会が判定し、３月に公表されます」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "2-4.png"
    },
    {
        "id": 73,
        "shikenId": 1,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの相続に係る課税遺産総額（課税価格の合計額－遺産に係る基礎控除額）が8,200万円であった場合の相続税の総額は、次のうちどれか。<br><br><img src=\"/img/question/73_2.png\" style=\"width: 390px\" />",
        "choice1": "905万円",
        "choice2": "1,135万円",
        "choice3": "1,435万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "2-5.png"
    },
    {
        "id": 74,
        "shikenId": 1,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "「小規模宅地等についての相続税の課税価格の計算の特例」（以下、「本特例」という）に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「妻Bさんが自宅の敷地および建物を相続により取得し、当該敷地の全部について本特例の適用を受けた場合、限度面積330㎡までの部分については、評価額を80％減額することができます」",
        "choice2": "「妻Ｂさんが自宅の敷地および建物を相続により取得した場合でも、その後相続税の申告期限まで当該建物に居住していなければ、妻Bさんは本特例の適用を受けることができません」",
        "choice3": "「長女Dさんが自宅の敷地および建物を相続により取得した場合、その後相続税の申告期限まで当該敷地を所有していれば、居住していなくても本特例の適用を受けることができます」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "4",
        "image": "2-5.png"
    },
    {
        "id": 75,
        "shikenId": 1,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの相続に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「妻Bさんが『配偶者に対する相続税額の軽減』の適用を受けた場合、妻Ｂさんの相続税の課税価格が、相続税の課税価格の合計額に対する配偶者の法定相続分相当額と１億6,000万円とのいずれか多い金額までであれば、原則として、妻Bさんが納付すべき相続税額は算出されません」",
        "choice2": "「Ａさんが2025年分の所得税および復興特別所得税について確定申告書を提出しなければならない者に該当するとき、相続人は、原則として、相続の開始があったことを知った日の翌日から10カ月以内に準確定申告書を提出しなければなりません」",
        "choice3": "「相続税の申告書は、原則として、相続人が相続の開始があったことを知った日の翌日から２年以内に被相続人であるＡさんの死亡時の住所地を所轄する税務署長に提出しなければなりません」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "2-5.png"
    },
    {
        "id": 76,
        "shikenId": 1,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "はじめに、Ｍさんは、《設例》に基づき、Ａさんが老齢基礎年金の受給を65歳から開始した場合の年金額（2025年度価額）を試算した。Mさんが試算した老齢基礎年金の年金額の計算式として、次のうち最も適切なものはどれか。",
        "choice1": "<img src='/img/question/76_1.png' style='margin-top: -10px;margin-bottom:35px;height:50px'>",
        "choice2": "<img src='/img/question/76_2.png' style='margin-top: -31px;margin-bottom:35px;height:70px'>",
        "choice3": "<img src='/img/question/76_3.png' style='margin-top: -30px;margin-bottom:0px;height:70px'>",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "4",
        "image": "3-1.png"
    },
    {
        "id": 77,
        "shikenId": 1,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "次に、Ｍさんは、公的介護保険（以下、「介護保険」という）について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「介護保険の被保険者が保険給付を受けるためには、都道府県から要介護認定または要支援認定を受ける必要があります」",
        "choice2": "「介護保険の第２号被保険者であるＡさんは、原因を問わず要介護状態または要支援状態となった場合に保険給付を受けることができます」",
        "choice3": "「介護保険の第２号被保険者が保険給付を受けた場合、原則として実際にかかった費用（食費、居住費等を除く）の１割を自己負担する必要があります」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3-1.png"
    },
    {
        "id": 78,
        "shikenId": 1,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "最後に、Ｍさんは、AさんがＸ社を退職した後、老後の年金収入を増やすことができる方法や各種制度について説明した。Ｍさんが、Ａさんに対して説明した以下の文章の空欄①〜③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br><div class='b-box'>ⅰ）「Ａさんは、国民年金基金に加入することができます。国民年金基金の月々の掛金の上限は、原則として、個人型確定拠出年金の掛金と合わせて月額（　①　）円となります」<br>ⅱ）「Ａさんが学生納付特例期間に係る保険料について追納できるのは、当該承認を受けた日に属する月前（　②　）年以内の期間に係るものに限られます」<br>ⅲ）「Ａさんは、国民年金の定額保険料に加えて付加保険料を納付することができます。仮に、Ａさんが付加保険料を180月納付し、65歳から老齢基礎年金を受け取る場合、老齢基礎年金の額に付加年金として年額（　③　）円が上乗せされます」</div>",
        "choice1": "① 72,000 ② 10 ③ 24,000",
        "choice2": "① 68,000 ② 10 ③ 36,000",
        "choice3": "① 68,000 ② 20 ③ 48,000",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3-1.png"
    },
    {
        "id": 79,
        "shikenId": 1,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "はじめに、Ｍさんは、Ａさんに対して、現在加入している生命保険の保障内容等について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「Ａさんが現時点で病気を原因として亡くなった場合、死亡保険金として3,500万円を受け取ることができます」",
        "choice2": "「遺族に必要な生活資金等の総額から遺族の収入金額等を差し引いた金額が、必要保障額として死亡保険金額を設定する目安となります。通常、必要保障額はお子様の成長とともに逓減するため、収入保障保険や逓減定期保険への加入も検討してはいかがでしょう」",
        "choice3": "「Aさんが加入している生命保険には、リビング・ニーズ特約が付加されていますので、Aさんが余命１年以内と診断された場合、生前給付金を受け取ることができます」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3-2.png"
    },
    {
        "id": 80,
        "shikenId": 1,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "次に、Ｍさんは、生命保険の見直しについて説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「現在加入している定期保険特約の契約変更を行うことで保険金額を減額させ、その分を必要性の高い介護保険などの保険料に充てることも検討事項の１つです」",
        "choice2": "「現在加入している生命保険を払済終身保険に変更した場合、死亡保険金額は減少しますが、現在付加されている入院特約は残り、月々の保険料負担は軽減されます」",
        "choice3": "「介護保障を検討する際には、公的介護保険等の社会保障制度と連動しているものか、保険金の支払事由が保険会社独自のものか、どのような場合に保険金や給付金が支払われるか、加入前に確認しておくことが重要です」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3-2.png"
    },
    {
        "id": 81,
        "shikenId": 1,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "最後に、Ｍさんは、全国健康保険協会管掌健康保険の高額療養費制度について説明した。Ｍさんが、Ａさんに対して説明した次の記述のうち最も適切なものはどれか。",
        "choice1": "「Ａさんに係る医療費の一部負担金の割合は、原則として１割となります」",
        "choice2": "「同一年内に、医療機関等に支払った医療費の一部負担金等の額が自己負担限度額を超えた場合、所定の手続により、自己負担限度額を超えた額が高額療養費として支給されます」",
        "choice3": "「一部負担金等の合計には、差額ベッド代、入院時の食事代、先進医療に係る費用等は含まれず、70歳未満の者の場合、原則として、医療機関ごとに、入院・外来、医科・歯科別に一部負担金等が21,000円以上のものが計算対象となります」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "4",
        "image": "3-2.png"
    },
    {
        "id": 82,
        "shikenId": 1,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "仮に、Ｘ社がＡさんに役員退職金7,000万円を支給した場合、Ａさんが受け取る役員退職金に係る退職所得の金額として、次のうち最も適切なものはどれか。なお、Ａさんの役員在任期間（勤続年数）を40年とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。",
        "choice1": "1,400万円",
        "choice2": "2,200万円",
        "choice3": "2,400万円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3-3.png"
    },
    {
        "id": 83,
        "shikenId": 1,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "《設例》の終身保険の第１回保険料払込時の経理処理（仕訳）として、次のうち最も適切なものはどれか。",
        "choice1": "<img src='/img/question/82_1.png' width='400'>",
        "choice2": "<img src='/img/question/82_2.png' width='400'>",
        "choice3": "<img src='/img/question/82_3.png' width='400'>",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "4",
        "image": "3-3.png"
    },
    {
        "id": 84,
        "shikenId": 1,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ｍさんは、《設例》の終身保険について説明した。ＭさんのAさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「当該終身保険は、保険料払込期間における解約返戻金額を抑えることで、低解約返戻金型ではない終身保険と比較して保険料が割安となっています」",
        "choice2": "「Ｂさんが所定の高度障害状態になった場合、高度障害保険金6,000万円がＸ社に支払われます。さらに、その後Ｂさんが死亡した場合には、死亡保険金6,000万円がＸ社に支払われます」",
        "choice3": "「急な資金需要の発生により、Ｘ社が契約者貸付制度を利用した場合、借入金として経理処理します」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3-3.png"
    },
    {
        "id": 85,
        "shikenId": 1,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "　所得税における青色申告に関する以下の文章の空欄①〜③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br><br> <div class='b-box'>ⅰ）「事業所得に係る取引を正規の簿記の原則に従い記帳し、その記帳に基づいて作成した貸借対照表、損益計算書その他の計算明細書を添付した確定申告書を法定申告期限内に提出することにより、事業所得の金額の計算上、青色申告特別控除として最高（　①　）万円を控除することができます。なお、従前の要件に加えて、e-Taxによる申告（電子申告）または電子帳簿保存を行うことで、（　②　）万円の青色申告特別控除の適用を受けることができます」<br>ⅱ）「青色申告者が適用を受けられる税務上の特典として、青色申告特別控除の適用、青色事業専従者給与の必要経費算入、翌年以後（　③　）年間の純損失の繰越控除、純損失の繰戻還付などがあります。」</div>",
        "choice1": "① 10 ② 55 ③ ５",
        "choice2": "① 55 ② 65 ③ ３",
        "choice3": "① 55 ② 65 ③ ５",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "4",
        "image": "3-4.png"
    },
    {
        "id": 86,
        "shikenId": 1,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税における所得および所得控除に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「Ａさんが解約した一時払変額個人年金保険（10年確定年金）の解約返戻金は、税務上、雑所得として所得税の課税対象になります」",
        "choice2": "「妻Ｂさんが青色事業専従者として給与の支払いを受けている場合であっても、Ａさんは、妻Ｂさんについて配偶者控除の適用を受けることができます」",
        "choice3": "「Ａさんが適用を受けることができる長男Ｃさんに係る扶養控除の額は、63万円です」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3-4.png"
    },
    {
        "id": 87,
        "shikenId": 1,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税における総所得金額は、次のうちどれか。",
        "choice1": "600万円",
        "choice2": "625万円",
        "choice3": "700万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3-4.png"
    },
    {
        "id": 88,
        "shikenId": 1,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの相続に関する以下の文章の空欄①〜③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><br> <div class='b-box'>ⅰ）「Ａさんの相続における遺産に係る基礎控除額は、（　①　）万円です」<br>ⅱ）「相続税の申告書は、原則として、相続の開始があったことを知った日の翌日から（　②　）以内に提出しなければなりません」<br>ⅲ）「長男Ｃさんが受け取る死亡保険金は、みなし相続財産として相続税の課税対象となりますが、死亡保険金の非課税金額の規定の適用を受けることで、相続税の課税価格に算入される金額は（　③　）万円となります」</div>",
        "choice1": "① 4,800 ② 10カ月 ③ 2,500",
        "choice2": "① 4,800 ② 12カ月 ③ 2,500",
        "choice3": "① 5,400 ② 12カ月 ③ 2,000",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "3-5.png"
    },
    {
        "id": 89,
        "shikenId": 1,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの相続に関する次の記述うち、最も不適切なものはどれか。",
        "choice1": "「妻Ｂさんが自宅の敷地を相続により取得し、『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けた場合、自宅の敷地（相続税評価額9,000万円）について、相続税の課税価格に算入すべき価額を1,800万円とすることができます」",
        "choice2": "「自筆証書遺言は、所定の手続により、法務局（遺言書保管所）に保管することができます。法務局（遺言書保管所）に保管された自筆証書遺言は、相続開始時、家庭裁判所の検認が不要となります」",
        "choice3": "「妻Ｂさんが『配偶者に対する相続税額の軽減』の適用を受けるためには、Ａさんの相続開始時において、Ａさんとの婚姻期間が10年以上でなければなりません」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "4",
        "image": "3-5.png"
    },
    {
        "id": 90,
        "shikenId": 1,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの相続に係る課税遺産総額（ 「課税価格の合計額－遺産に係る基礎控除額」 ）が２億4,000万円であった場合の相続税の総額として、次のうち最も適切なものはどれか。",
        "choice1": "1,200万円",
        "choice2": "5,300万円",
        "choice3": "7,400万円<div class='pt-3'>        <img src='/img/88_2_2.png' width='420'/>      </div>",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3-5.png"
    },
    {
        "id": 91,
        "shikenId": 1,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "ファイナンシャル・プランニング業務を行うに当たっては、関連業法を遵守することが重要である。ファイナンシャル・プランナー（以下「ＦＰ」という）の行為に関する次の記述のうち、最も適切なものはどれか。",
        "question2": "",
        "choice1": "投資助言・代理業の登録をしていないＦＰが、顧客からの質問を受け、ＮＩＳＡ（少額投資非課税制度）の仕組みと特徴について説明した。",
        "choice2": "税理士資格を有していないＦＰが、無料相談会において、相談者の持参した資料に基づき、相談者が納付すべき相続税の具体的な税額計算を行った。",
        "choice3": "弁護士資格を有しないＦＰが、遺産分割に係る紛争中の顧客の依頼を受け、法律相談に基づく和解交渉を行い報酬を得た。",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 92,
        "shikenId": 1,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "下記は、田中家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表に関する次の記述のうち、正しいものはどれか。なお、計算に当たっては、キャッシュフロー表中に記載の整数を使用することとし、計算結果は万円未満を四捨五入することとする。<br><img src=\"/img/question/92_1.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "空欄（ア）に入る数値とその求め方：「520×(1＋0.01)<sup>2</sup>＝<u>530</u>」",
        "choice2": "空欄（イ）に入る数値とその求め方：「696－742＝<u>▲46</u>」",
        "choice3": "空欄（ウ）に入る数値とその求め方：「(520－102)×(1＋0.01)＝<u>422</u>」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 93,
        "shikenId": 1,
        "parentNo": 1,
        "no": 3,
        "groupId": 2,
        "answerType": 4,
        "inputType": 4,
        "question1": "永井家の現時点の資産および負債が下記＜資料＞のとおりである場合、＜資料＞に基づく永井家のバランスシートの空欄（ア）に当てはまる金額として、正しいものはどれか。なお、記載のない事項については一切考慮しないものとする。<br><br><br>＜永井家のバランスシート＞<br><img src=\"/img/question/103_2.png\" class=\"question-img\" /><br><br>＜資料＞<br><img src=\"/img/question/106_1.png\" class=\"question-img\" /><br><br>［負債残高］<br> 住宅ローン（自宅） ：3,500万円（団体信用生命保険付）<br> 自動車ローン（自家用）： 120万円<br> <br> ＜その他＞<br> 上記以外については、特に指定のない限り一切考慮しないこととする。 ",
        "question2": "",
        "choice1": "2,080（万円）",
        "choice2": "3,620（万円）",
        "choice3": "5,700（万円）",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 94,
        "shikenId": 1,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "榊さんは、今後１５年間で毎年３６万円ずつ積立貯蓄をして、老後の資金準備をしたいと考えている。積立期間中に年利２.０％で複利運用できるものとした場合、１５年後の積立金額として、正しいものはどれか。なお、下記〈資料〉の3つの係数の中から最も適切な係数を選択して計算し、解答に当たっては、万円未満を四捨五入することとする。また、記載のない事項については一切考慮しないこととする。<br><br> <img src=\"/img/question/105_2.png\" class=\"question-img\" />",
        "choice1": "623万円",
        "choice2": "463万円",
        "choice3": "48万円",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 95,
        "shikenId": 1,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "会社員の葛西真一さんは、会社の定期健康診断で異常を指摘され、２０２５年７月に２週間ほど入院をして治療を受けた。その際の病院への支払いが高額であったため、健康保険の高額療養費制度を利用して払戻しを受けたいと考えた。真一さんの２０２５年７月の保険診療に係る総医療費が６０万円であった場合、高額療養費制度により払戻しを受けることができる金額として、正しいものはどれか。なお、真一さんは全国健康保険協会管掌健康保険（協会けんぽ）の被保険者で、標準報酬月額は「３５万円」である。また、２０２５年７月に支払った医療費はこの入院に係るもののみであり、今回の入院について健康保険限度額適用認定証は提示していないものとする。<br><br><img src=\"/img/question/106_2.png\" class=\"question-img\" />",
        "choice1": "83,430円",
        "choice2": "96,570円",
        "choice3": "180,000円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 96,
        "shikenId": 1,
        "parentNo": 1,
        "no": 6,
        "groupId": 3,
        "answerType": 4,
        "inputType": 4,
        "question1": "下記＜資料＞は、ＴＹ銀行の顧客配布用・投資信託ガイドの「投資信託に関するリスク」のページの一部（抜粋）である。＜資料＞に関する次の記述のうち、最も適切なものはどれか。<br><br>＜資料＞<br><img src=\"/img/question/93_1.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "空欄（　ア　）に入る語句は、「信用リスク」である。",
        "choice2": "空欄（　イ　）に入る語句は、「為替変動リスク」である。",
        "choice3": "空欄（　ウ　）に入る語句は、「流動性リスク」である。",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 97,
        "shikenId": 1,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 4,
        "inputType": 4,
        "question1": "個人向け国債に関する下表の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><br><img src=\"/img/question/94_1.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "（ア）１万円　（イ）０.０３％　（ウ）２年",
        "choice2": "（ア）１万円　（イ）０.０５％　（ウ）１年",
        "choice3": "（ア）５万円　（イ）０.０５％　（ウ）２年",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 98,
        "shikenId": 1,
        "parentNo": 1,
        "no": 8,
        "groupId": 4,
        "answerType": 4,
        "inputType": 4,
        "question1": "下記＜資料＞に基づくＫＸ株式とＫＹ株式の投資指標に関する次の記述の空欄（ア）、（イ）にあてはまる数値または語句の組み合わせとして、最も適切なものはどれか。なお、空欄（ア）の解答に当たっては、小数点以下第3位を四捨五入すること。<br><br>＜資料＞<br><img src=\"/img/question/95_1.png\" class=\"question-img\" /><br>",
        "question2": "",
        "choice1": "（ア）1.40 （イ）ＫＹ",
        "choice2": "（ア）1.60 （イ）ＫＸ",
        "choice3": "（ア）1.60 （イ）ＫＹ",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 99,
        "shikenId": 1,
        "parentNo": 1,
        "no": 9,
        "groupId": 4,
        "answerType": 4,
        "inputType": 4,
        "question1": "建築基準法に基づき、下記〈資料〉の土地に建築物を建築する場合、その土地に対する建築物の建築面積の最高限度（ア）と延べ面積（床面積の合計）の最高限度（イ）の組み合わせとして、最も適切なものはどれか。なお、記載のない条件については一切考慮しないこととする。<br><br>＜資料＞<br><img src=\"/img/question/96_2.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "（ア）180㎡ （イ）480㎡",
        "choice2": "（ア）180㎡ （イ）600㎡",
        "choice3": "（ア）300㎡ （イ）600㎡",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 100,
        "shikenId": 1,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 4,
        "inputType": 4,
        "question1": "借地借家法に基づく定期借地権に関する次の記述のうち、正しいものはどれか。",
        "question2": "",
        "choice1": "事業の用に供する建物の所有を目的とする場合、一般定期借地権を設定することはできない。",
        "choice2": "従業員の社宅として利用する建物の所有を目的として、事業用定期借地権等の設定契約をすることができる。",
        "choice3": "一般定期借地権の存続期間は５０年以上とされており、契約は公正証書等の書面または電磁的記録によって締結しなければならない。",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 101,
        "shikenId": 1,
        "parentNo": 1,
        "no": 11,
        "groupId": 5,
        "answerType": 4,
        "inputType": 4,
        "question1": "土地の登記記録において、権利部のうちの甲区（ア）、乙区（イ）に記録される事項の組み合わせとして、誤っているものはどれか。",
        "question2": "",
        "choice1": "（ア）抵当権設定登記（イ）所有権保存登記",
        "choice2": "（ア）所有権移転登記（イ）抵当権設定登記",
        "choice3": "（ア）所有権移転登記（イ）地上権設定登記",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 102,
        "shikenId": 1,
        "parentNo": 1,
        "no": 12,
        "groupId": 5,
        "answerType": 4,
        "inputType": 4,
        "question1": "石川雄一郎さんが加入している生命保険（下記＜資料＞参照）の保障内容に関する次の記述の空欄（ア）、（イ）にあてはまる金額の組合せとして、最も適切なものはどれか。なお、保険金および給付金の支払事由が生じたときにおいて、特約を含む保険契約は有効に継続しているものとし、雄一郎さんはこれまでに＜資料＞の保険から保険金および給付金を一度も受け取っていないものとする。また、各々の記述は独立した問題であり、相互に影響を与えないものとする。<br><br>＜資料＞<br><img src=\"/img/question/102_2.png\" class=\"question-img\" /><br><br><div class='b-box'>石川雄一郎さんが、２０２５年中に交通事故によって死亡した場合、保険会社から死亡保険金（　ア　）が支払われる。また、年間（　イ　）の年金が５年間支払われる。</div>",
        "question2": "",
        "choice1": "（ア）１,７００万円　（イ）３００万円",
        "choice2": "（ア）２,０００万円　（イ）５００万円",
        "choice3": "（ア）２,０００万円　（イ）３００万円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 103,
        "shikenId": 1,
        "parentNo": 1,
        "no": 13,
        "groupId": 6,
        "answerType": 4,
        "inputType": 4,
        "question1": "下記の（ア）～（ウ）のイメージ図は、定期保険、終身保険、養老保険のいずれかを表したものである。下記のイメージ図に関する次の記述のうち、最も適切なものはどれか。<br><img src=\"/img/question/99_1.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "（ア）は「終身保険」に関するイメージ図である。",
        "choice2": "（イ）は「定期保険」に関するイメージ図である。",
        "choice3": "（ウ）は「養老保険」に関するイメージ図である。",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 104,
        "shikenId": 1,
        "parentNo": 1,
        "no": 14,
        "groupId": 6,
        "answerType": 4,
        "inputType": 4,
        "question1": "損害保険の種類と事故の内容に関する次の記述のうち、最も適切なものはどれか。",
        "question2": "",
        "choice1": "国内旅行中に発生した地震や津波によるケガは、国内旅行傷害保険の補償の対象となる。",
        "choice2": "草野球の試合中にボールが右指を直撃し、被保険者が骨折した場合のケガは、普通傷害保険の補償の対象となる。",
        "choice3": "被保険者が業務の遂行中に自転車で誤って歩行者と接触し、ケガをさせたことにより損害賠償責任が生じた場合、個人賠償責任保険の補償の対象となる。",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 105,
        "shikenId": 1,
        "parentNo": 1,
        "no": 15,
        "groupId": 6,
        "answerType": 4,
        "inputType": 4,
        "question1": "Ｋ株式会社の会社員である竹市さんが２０２５年中に支払った医療費等が下記＜資料＞のとおりである場合、竹市さんの２０２５年分の所得税の確定申告における医療費控除の金額として、最も適切なものはどれか。なお、竹市さんの２０２５年分の所得は給与所得６００万円のみであり、竹市さんは妻と生計を一にしている。また、セルフメディケーション税制（特定一般用医薬品等購入費を支払った場合の医療費控除の特例）については考慮しないものとする。<br><br>＜資料＞<br><img src=\"/img/question/100_1.png\" class=\"question-img\" /><br>",
        "question2": "",
        "choice1": "290,000円",
        "choice2": "390,000円",
        "choice3": "450,000円",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 106,
        "shikenId": 1,
        "parentNo": 1,
        "no": 16,
        "groupId": 7,
        "answerType": 4,
        "inputType": 4,
        "question1": "会社員の山川さんは、２０２５年中に勤務先を定年退職した。山川さんの退職に係るデータが下記＜資料＞のとおりである場合、山川さんの所得税に係る退職所得の金額として、正しいものはどれか。<br><br>＜資料＞<br><img src=\"/img/question/101_1.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1,280万円",
        "choice2": "1,220万円",
        "choice3": "640万円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 107,
        "shikenId": 1,
        "parentNo": 1,
        "no": 17,
        "groupId": 7,
        "answerType": 4,
        "inputType": 4,
        "question1": "給与所得者である杉田さんは、２０２５年中にマンションを購入し、直ちに居住を開始した。杉田さんは、住宅借入金等特別控除（以下「住宅ローン控除」という）の適用を受けたいと考えており、ＦＰで税理士でもある村瀬さんに相談をした。村瀬さんの住宅ローン控除に関する次の説明のうち、最も適切なものはどれか。",
        "question2": "",
        "choice1": "「住宅ローン控除の毎年の控除額は、『住宅借入金等の年末残高等×０.７％』の式で計算されます。」",
        "choice2": "「一般的に、住宅ローン控除の適用を受けるためには、対象となる住宅の床面積が５５㎡以上でなければなりません。」",
        "choice3": "「住宅ローン控除は、その年分の合計所得金額が３,０００万円以下でなければ適用を受けることができません。」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 108,
        "shikenId": 1,
        "parentNo": 1,
        "no": 18,
        "groupId": 7,
        "answerType": 4,
        "inputType": 4,
        "question1": "小柳隆二さん（被相続人）の＜親族関係図＞が下記のとおりである場合、民法上の相続人および法定相続分の組み合わせとして、最も適切なものはどれか。なお、記載のない条件については、一切考慮しないこととする。<br><br><img src=\"/img/question/102_1.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "真琴　１／２　　順一　１／４　　祥子　１／４",
        "choice2": "真琴　２／３　　法子　１／３",
        "choice3": "真琴　１／２　　順一　１／２",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 109,
        "shikenId": 1,
        "parentNo": 1,
        "no": 19,
        "groupId": 7,
        "answerType": 4,
        "inputType": 4,
        "question1": "村西さん（３０歳）が２０２５年中に贈与を受けた財産の価額と贈与者は以下のとおりである。村西さんの２０２５年分の贈与税額として、正しいものはどれか。なお、２０２５年中において、村西さんはこれ以外の財産の贈与を受けておらず、その他記載のない事項については一切考慮しないこととする。<br><br><div class='b-box'>・村西さんの父からの贈与　現金５００万円<br>・村西さんの祖父からの贈与　現金２００万円</div><br><br>＜贈与税の速算表＞<br>（イ）18歳以上の者が直系尊属から贈与を受けた財産の場合<br><img src=\"/img/question/104_1.png\" class=\"question-img\" /><br><br>（ロ）上記（イ）以外の場合<br><img src=\"/img/question/105_1.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "８８万円",
        "choice2": "１１２万円",
        "choice3": "１２０万円",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 110,
        "shikenId": 1,
        "parentNo": 1,
        "no": 20,
        "groupId": 7,
        "answerType": 4,
        "inputType": 4,
        "question1": "長谷川信子さんは、夫から居住用不動産の贈与を受けた。信子さんは、この居住用不動産の贈与について、贈与税の配偶者控除の適用を受けることを検討しており、ＦＰで税理士でもある八代さんに相談をした。この相談に対する次の回答のうち、最も不適切なものはどれか。",
        "question2": "",
        "choice1": "「贈与税の配偶者控除の対象となる財産については、居住用不動産である家屋およびその敷地のほか、それらを取得するための資金も含まれます。」",
        "choice2": "「贈与税の配偶者控除の適用を受けた場合、贈与税の計算上、贈与税の課税価額から基礎控除額１１０万円のほかに最高２,５００万円の控除を受けることができます。」",
        "choice3": "「贈与税の配偶者控除は、贈与を受けた日において、婚姻期間が２０年以上ある配偶者から受けた贈与でなければ、適用を受けることができません。」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 201,
        "shikenId": 2,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "司法書士資格を有しないファイナンシャル・プランナーが、顧客本人の求めに応じ、その顧客の任意後見受任者となることは、司法書士法に抵触しない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 202,
        "shikenId": 2,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "確定拠出年金（個人型）の老齢給付金を一時金で受け取った場合、雑所得として所得税の課税対象となる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 203,
        "shikenId": 2,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "雇用保険の基本手当を受給するためには、倒産、解雇、雇止めなどの場合を除き、原則として、離職の日以前２年間に被保険者期間が通算して12カ月以上あることなどの要件を満たす必要がある。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 204,
        "shikenId": 2,
        "parentNo": 1,
        "no": 4,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "住宅支援機構と民間金融機関が提携した住宅ローンであるフラット35（買取型）の融資金利は固定金利であり、融資実行時点の金利が適用される。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 205,
        "shikenId": 2,
        "parentNo": 1,
        "no": 5,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "70歳未満の厚生年金保険の被保険者に支給される老齢厚生年金は、その者の総報酬月額相当額と基本月額の合計額が40万円を超える場合、年金額の一部または全部が支給停止となる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 206,
        "shikenId": 2,
        "parentNo": 1,
        "no": 6,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "収入保障保険の死亡保険金を一時金で受け取る場合の受取額は、一般に、年金形式で受け取る場合の受取総額よりも少なくなる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 207,
        "shikenId": 2,
        "parentNo": 1,
        "no": 7,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "定期保険特約付終身保険では、定期保険特約の保険金額を同額で自動更新すると、更新後の保険料は、通常、更新前よりも高くなる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 208,
        "shikenId": 2,
        "parentNo": 1,
        "no": 8,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "学資保険には、出生前加入特則を付加することにより、被保険者となる子が出生する前から保険に加入することができるものがある。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 209,
        "shikenId": 2,
        "parentNo": 1,
        "no": 9,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "リビング・ニーズ特約は、被保険者の余命が１年以内と判断された場合に、所定の範囲内で死亡保険金の一部または全部を生前に受け取ることができる特約である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 210,
        "shikenId": 2,
        "parentNo": 1,
        "no": 10,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "国内で事業を行う少額短期保険業者と締結した保険契約は、生命保険契約者保護機構および損害保険契約者保護機構による補償の対象とならない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 211,
        "shikenId": 2,
        "parentNo": 1,
        "no": 11,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "マネーストック統計とは、個人、一般法人、地方公共団体などの通貨保有主体が保有する通貨量の残高を集計したものである。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 212,
        "shikenId": 2,
        "parentNo": 1,
        "no": 12,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "外貨建て金融商品の取引にかかる為替手数料は、取扱金融機関によって異なることがある。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 213,
        "shikenId": 2,
        "parentNo": 1,
        "no": 13,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "債券の信用格付とは、債券やその発行体の信用評価を記号等で示したものであり、一般に、BB（ダブルビー）格相当以下の格付けが付された債券は、投資不適格債とされる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 214,
        "shikenId": 2,
        "parentNo": 1,
        "no": 14,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "ゆうちょ銀行においては、通常貯金と定期性貯金を合わせて１人2,600万円が預入限度額となっている。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 215,
        "shikenId": 2,
        "parentNo": 1,
        "no": 15,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "消費者契約法において、消費者が事業者の一定の行為により誤認または困惑し、それによって消費者契約の申込みまたは承諾の意思表示をしたときは、消費者はこれを取り消すことができるとされている。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 216,
        "shikenId": 2,
        "parentNo": 1,
        "no": 16,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "給与所得者のうち、その年中に支払を受けるべき給与の収入金額が2,000万円を超える者は、所得税の確定申告をする必要がある。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 217,
        "shikenId": 2,
        "parentNo": 1,
        "no": 17,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "所得税法における居住者（非永住者を除く）は、原則として、国内で生じた所得についてのみ所得税の納税義務が生じる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 218,
        "shikenId": 2,
        "parentNo": 1,
        "no": 18,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "電車・バス等の交通機関を利用して通勤している給与所得者が、勤務先から受ける通勤手当は、所得税法上、月額15万円を限度に非課税とされる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 219,
        "shikenId": 2,
        "parentNo": 1,
        "no": 19,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "公的年金等に係る雑所得の金額は、「その年の公的年金等に係る収入金額－公的年金等控除額－50万円」の算式により計算される。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 220,
        "shikenId": 2,
        "parentNo": 1,
        "no": 20,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "「ふるさと納税ワンストップ特例制度」の適用を受けるためには、適用を受けようとする年の寄附金の合計額が10万円以下でなければならない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 221,
        "shikenId": 2,
        "parentNo": 1,
        "no": 21,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "借地借家法の規定によれば、借地権は、その登記がない場合でも、土地の上に借地権者が登記されている建物を所有するときは、これをもって第三者に対して土地の賃借権を対抗することができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 222,
        "shikenId": 2,
        "parentNo": 1,
        "no": 22,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "不動産の売買契約において、買主が売主に解約手付を交付した場合、相手方が契約の履行に着手するまでは、買主はその手付を放棄することで、売主は受領した手付と同額を買主に提供することで、それぞれ契約を解除することができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 223,
        "shikenId": 2,
        "parentNo": 1,
        "no": 23,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "相続により不動産を取得した場合、不動産取得税は課されない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 224,
        "shikenId": 2,
        "parentNo": 1,
        "no": 24,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "土地の売買において、所有権の移転が発生したものの、手続上の要件が備わっていない場合などに、仮登記をすることができるが、この仮登記をすることで、その後に行う本登記の順位は保全され、所有権の移転を第三者に対抗することができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 225,
        "shikenId": 2,
        "parentNo": 1,
        "no": 25,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "借地借家法において、定期建物賃貸借契約（定期借家権）では、存続期間を１年以上としなければならない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 226,
        "shikenId": 2,
        "parentNo": 1,
        "no": 26,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "特別養子縁組が成立した場合、養子となった者と実方の父母との法律上の親族関係は終了する。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 227,
        "shikenId": 2,
        "parentNo": 1,
        "no": 27,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "成年後見制度には法定後見制度と任意後見制度があり、任意後見制度には本人の判断能力の程度などに応じて「後見」 「保佐」 「補助」の３つがある。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 228,
        "shikenId": 2,
        "parentNo": 1,
        "no": 28,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "父が所有する土地を子が無償で借り受け、その土地の上に建物を建築した場合、父から子へ借地権の贈与があったものとして、贈与税の課税対象となる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 229,
        "shikenId": 2,
        "parentNo": 1,
        "no": 29,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "民法において、被相続人の非嫡出子の法定相続分は、嫡出子の２分の１とされている。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 230,
        "shikenId": 2,
        "parentNo": 1,
        "no": 30,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "口頭による贈与契約は、その履行前であれば、各当事者は契約の解除をすることができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 231,
        "shikenId": 2,
        "parentNo": 2,
        "no": 31,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "後期高齢者医療広域連合の区域内に住所を有する（　　　）歳以上の者は、原則として、後期高齢者医療制度の被保険者となる。",
        "choice1": "1）65歳",
        "choice2": "2）70歳",
        "choice3": "3）75歳",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 232,
        "shikenId": 2,
        "parentNo": 2,
        "no": 32,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "元金1,000,000円を年率２％で複利運用しながら20年間にわたって毎年均等に取り崩して受け取る場合、毎年の受取金額は、下記の〈資料〉の係数を使用して算出すると、（　　　）である。<br>〈資料〉利率（年率）２％・期間20年の各種係数<br><img src='/img/234.png' style='width:550px'/>",
        "choice1": "1）14,840円",
        "choice2": "2）61,160円",
        "choice3": "3）82,640円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 233,
        "shikenId": 2,
        "parentNo": 2,
        "no": 33,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "独立行政法人日本学生支援機構が取り扱う奨学金（貸与型）には、（　①　）の第一種奨学金と（　②　）の第二種奨学金がある。",
        "choice1": "1）① 無利息　② 利息付",
        "choice2": "2）① 利息付　② 無利息",
        "choice3": "3）① 返済不要　② 無利息",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 234,
        "shikenId": 2,
        "parentNo": 2,
        "no": 34,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "雇用保険の教育訓練給付金のうち、一般教育訓練に係る教育訓練給付金の額は、教育訓練施設に支払った教育訓練費の（　①　）相当額であるが、その額が（　②　）を超える場合の支給額は、（　②　）となる。",
        "choice1": "1）① 10％　② ５万円",
        "choice2": "2）① 20％　② 10万円",
        "choice3": "3）① 30％　② 15万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 235,
        "shikenId": 2,
        "parentNo": 2,
        "no": 35,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税の計算において、国民年金基金の掛金は、（　　　）として所得控除の対象となる。",
        "choice1": "1）小規模共済等掛金控除",
        "choice2": "2）生命保険料控除",
        "choice3": "3）社会保険料控除",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 236,
        "shikenId": 2,
        "parentNo": 2,
        "no": 36,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "ソルベンシー・マージン比率は、保険会社が保険金等の支払余力をどの程度有するかを示す指標であり、この値が（　　　）を下回った場合、監督当局による早期是正措置の対象となる。",
        "choice1": "1）50％",
        "choice2": "2）100％",
        "choice3": "3）200％",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 237,
        "shikenId": 2,
        "parentNo": 2,
        "no": 37,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "がん保険では、一般に、責任開始日前に約（　　　）の免責期間が設けられており、その期間中にがんと診断されたとしても、がん診断給付金は支払われない。",
        "choice1": "1）１カ月",
        "choice2": "2）３カ月",
        "choice3": "3）６カ月",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 238,
        "shikenId": 2,
        "parentNo": 2,
        "no": 38,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "ホテルを運営する企業が、クロークで預かる顧客の荷物の紛失・盗難リスクの補償に備えるために、（　　　）に加入した。",
        "choice1": "1）受託者賠償責任保険",
        "choice2": "2）施設所有者賠償責任保険",
        "choice3": "3）生産物賠償責任保険",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 239,
        "shikenId": 2,
        "parentNo": 2,
        "no": 39,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "民法および失火の責任に関する法律（失火責任法）において、借家人が軽過失により火事を起こし、借家と隣家を焼失させた場合、借家の家主に対して損害賠償責任を（　①　）。また、隣家の所有者に対して損害賠償責任を（　②　）。",
        "choice1": "1）① 負う　② 負わない",
        "choice2": "2）① 負う　② 負う",
        "choice3": "3）① 負わない　② 負う",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 240,
        "shikenId": 2,
        "parentNo": 2,
        "no": 40,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税において、個人が支払う地震保険の保険料に係る地震保険料控除は、原則として、（　①　）を限度として年間支払保険料の（　②　）が控除額となる。",
        "choice1": "1）① ５万円　② ２分の１相当額",
        "choice2": "2）① ５万円　② 全額",
        "choice3": "3）① 10万円　② 全額",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 241,
        "shikenId": 2,
        "parentNo": 2,
        "no": 41,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "個人向け国債は、変動金利の商品である（　①　）、固定金利の商品である（　②　）の３種類がある。",
        "choice1": "1）① 変動３年・変動５年　② 固定１年",
        "choice2": "2）① 変動５年　② 固定１年・固定３年",
        "choice3": "3）① 変動10年　② 固定３年・固定５年",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 242,
        "shikenId": 2,
        "parentNo": 2,
        "no": 42,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "ベンチマークとなる指数の（　①　）局面において、先物やオプションを利用し、（　①　）幅の２倍、３倍の投資成果を目指すファンドは、（　②　）に分類される。",
        "choice1": "1）① 下落　② ベア型ファンド",
        "choice2": "2）① 下落　② ブル型ファンド",
        "choice3": "3）① 上昇　② ベア型ファンド",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 243,
        "shikenId": 2,
        "parentNo": 2,
        "no": 43,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "外貨預金の預入時に、預金者が円貨を外貨に換える際に適用される為替レートは（　①　）であり、払戻し時において、預金者が外貨を円貨に換える際に適用される為替レートは（　②　）である。",
        "choice1": "1）① TTB　② TTS",
        "choice2": "2）① TTM　② TTS",
        "choice3": "3）① TTS　② TTB",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 244,
        "shikenId": 2,
        "parentNo": 2,
        "no": 44,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "株式投資信託の投資手法のうち、マクロ経済の動向を分析して投資対象とする銘柄を選定する手法を（　①　）といい、個別銘柄の投資指標の分析や企業業績などのリサーチによって投資対象とする銘柄を選定する手法を（　②　）という。",
        "choice1": "1）① インデックス・アプローチ　② アクティブ・アプローチ",
        "choice2": "2）① トップダウン・アプローチ　② ボトムアップ・アプローチ",
        "choice3": "3）① グロース・アプローチ　② バリュー・アプローチ",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 245,
        "shikenId": 2,
        "parentNo": 2,
        "no": 45,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "元金2,000,000円を、年利３％（１年複利）で３年間運用した場合の元利合計金額は、税金や手数料等を考慮しない場合、（　　　）である。",
        "choice1": "1）2,083,654円",
        "choice2": "2）2,121,800円",
        "choice3": "3）2,185,454円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 246,
        "shikenId": 2,
        "parentNo": 2,
        "no": 46,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税において、控除対象扶養親族のうち、その年の12月31日時点の年齢が（　①　）である特定扶養親族に係る扶養控除の額は、扶養親族１人につき（　②　）となる。",
        "choice1": "1）① 16歳以上22歳未満　② 63万円",
        "choice2": "2）① 19歳以上23歳未満　② 63万円",
        "choice3": "3）② 19歳以上23歳未満　② 58万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 247,
        "shikenId": 2,
        "parentNo": 2,
        "no": 47,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税において、（　　　）は医療費控除の対象とならない。",
        "choice1": "1）治療のための入院中の食事代",
        "choice2": "2）薬局で購入した風邪薬の購入費用",
        "choice3": "3）コンタクトレンズや近視、乱視によるメガネの購入費用",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 248,
        "shikenId": 2,
        "parentNo": 2,
        "no": 48,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税において、上場株式の配当に係る配当所得について（　①　）を選択した場合、配当控除の適用を受けることができ、配当所得の金額に（　②　）を乗じた金額を、その年分の所得税額から控除することができる。",
        "choice1": "1）① 総合課税　② 10％もしくは５％",
        "choice2": "2）① 申告分離課税　② 15％もしくは10％",
        "choice3": "3）① 源泉分離課税　② 20.315％",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 249,
        "shikenId": 2,
        "parentNo": 2,
        "no": 49,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税の計算において、青色申告書を提出した年に生じた純損失の金額は、所定の要件のもと、その損失が生じた年の翌年以降（　　　）繰り越すことができる。",
        "choice1": "1）２年間",
        "choice2": "2）３年間",
        "choice3": "3）４年間",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 250,
        "shikenId": 2,
        "parentNo": 2,
        "no": 50,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税において、（　　　）の金額の計算上生じた損失の金額は、一定の場合を除き、他の所得の金額と損益通算することができる。",
        "choice1": "1）不動産所得・事業所得・山林所得・一時所得",
        "choice2": "2）不動産所得・一時所得・雑所得・譲渡所得",
        "choice3": "3）不動産所得・事業所得・山林所得・譲渡所得",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 251,
        "shikenId": 2,
        "parentNo": 2,
        "no": 51,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "個人が土地・建物を譲渡したことによる譲渡所得の金額の計算において、譲渡した土地・建物の取得費が不明である場合には、譲渡収入金額の（　　　）相当額を取得費とすることができる。",
        "choice1": "1）５％",
        "choice2": "2）15％",
        "choice3": "3）20％",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 252,
        "shikenId": 2,
        "parentNo": 2,
        "no": 52,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "固定資産税における小規模宅地（住宅用地で住宅１戸につき200㎡以下の部分）の課税標準については、当該住宅用地に係る固定資産税の課税標準となるべき価格の（　　　）の額とする特例がある。",
        "choice1": "1）２分の１",
        "choice2": "2）３分の１",
        "choice3": "3）６分の１",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 253,
        "shikenId": 2,
        "parentNo": 2,
        "no": 53,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "都市計画区域内にある幅員４ｍ未満の道で、建築基準法第42条第２項により道路とみなされるものについては、原則として、その道路の中心線から水平距離で（　①　）後退した線が道路の境界線とみなされ、当該部分は、建蔽率や容積率を算定する際の敷地面積に（　②　）。",
        "choice1": "1）① 1.5ｍ　② 算入することができる",
        "choice2": "2）① ２ｍ　② 算入することができる",
        "choice3": "3）① ２ｍ　② 算入することができない",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 254,
        "shikenId": 2,
        "parentNo": 2,
        "no": 54,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "「特定居住用財産の譲渡損失の損益通算及び繰越控除の特例」の適用を受けた場合、損益通算を行っても控除しきれなかった譲渡損失の金額は、譲渡した年の翌年以降（　　　）にわたり繰り越して控除を受けることができる。",
        "choice1": "1）１年間",
        "choice2": "2）３年間",
        "choice3": "3）５年間",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 255,
        "shikenId": 2,
        "parentNo": 2,
        "no": 55,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "農地法によれば、農地を宅地に転用する場合、原則として、都道府県知事の許可を受けなければならないが、市街化区域内の一定の農地を宅地に転用する場合については、あらかじめ（　　　）へ届出を提出すれば、都道府県知事の許可を受ける必要はない。",
        "choice1": "1）農業委員会",
        "choice2": "2）市区町村長",
        "choice3": "3）国土交通大臣",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 256,
        "shikenId": 2,
        "parentNo": 2,
        "no": 56,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "被相続人の業務上の死亡により、相続人が被相続人の雇用主から受け取った弔慰金は、被相続人の死亡時における普通給与の（　　　）に相当する金額までは、相続税の課税対象とならない。",
        "choice1": "1）１カ月分",
        "choice2": "2）６カ月分",
        "choice3": "3）３年分",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 257,
        "shikenId": 2,
        "parentNo": 2,
        "no": 57,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "遺留分を有する相続人の遺留分に係る侵害額請求権は、当該遺留分権利者が相続の開始および遺留分を侵害する贈与または遺贈があったことを知った時から（　①　）、または相続開始の時から（　②　）を経過した時に時効により消滅する。",
        "choice1": "1）① ３カ月　② １年",
        "choice2": "2）① １年　② 10年",
        "choice3": "3）① ３年　② ５年",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 258,
        "shikenId": 2,
        "parentNo": 2,
        "no": 58,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "遺産分割において、共同相続人の１人または数人が、相続により遺産の一部または全部を取得し、その者が他の相続人に対して生じた債務を金銭などの財産で負担する方法を（　　　）という。",
        "choice1": "1）換価分割",
        "choice2": "2）代償分割",
        "choice3": "3）現物分割",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 259,
        "shikenId": 2,
        "parentNo": 2,
        "no": 59,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "相続人が相続の放棄をする場合、自己のために相続の開始があったことを知った時から（　①　）以内に、（　②　）で家庭裁判所に申述しなければならない。",
        "choice1": "1）① １カ月　② 相続人全員",
        "choice2": "2）① ３カ月　② １人または数人",
        "choice3": "3）① ６カ月　② 相続人全員",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 260,
        "shikenId": 2,
        "parentNo": 2,
        "no": 60,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "公正証書遺言は、作成にあたり証人の立会が（　①　）であり、遺言者の相続開始時に家庭裁判所における検認手続が（　②　）である。",
        "choice1": "1）① 必要　② 必要",
        "choice2": "2）① 不要　② 必要",
        "choice3": "3）① 必要　② 不要",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 261,
        "shikenId": 2,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "はじめに、Mさんは、Aさんが現時点（2025年９月11日）において死亡した場合、妻Ｂさんが受給することができる遺族基礎年金の年金額（2025年度価額）を試算した。Mさんが試算した遺族基礎年金の計算式として、次のうち最も適切なものはどれか。",
        "choice1": "831,700円＋79,800円＋79,800円＝991,300円",
        "choice2": "831,700円＋239,300円＋79,800円＝1,150,800円",
        "choice3": "831,700円＋239,300円＋239,300円＝1,310,300円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "5-1.png"
    },
    {
        "id": 262,
        "shikenId": 2,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "次に、Ｍさんは、Aさんが現時点（2025年９月11日）において死亡した場合に、妻Ｂさんに支給される遺族厚生年金の金額等について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「遺族厚生年金の額は、原則として、Ａさんの厚生年金保険の被保険者記録を基礎として計算した老齢厚生年金の報酬比例部分の額の４分の３相当額となります」",
        "choice2": "「Ａさんの場合、遺族厚生年金の計算の基礎となる被保険者期間の月数が240月に満たないため、240月とみなして年金額が計算されます」",
        "choice3": "「二男Ｄさんが18歳に到達し、その年度の末日が終了したことで妻Ｂさんの有する遺族基礎年金の受給権が消滅したときは、妻Ｂさんが65歳に達するまでの間、妻Ｂさんに支給される遺族厚生年金に中高齢寡婦加算が加算されます」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "4",
        "image": "5-1.png"
    },
    {
        "id": 263,
        "shikenId": 2,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "最後に、Ｍさんは、公的介護保険（以下、「介護保険」という）について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「介護保険の被保険者が保険給付を受けるためには、都道府県から要介護・要支援認定を受ける必要があります。介護保険の被保険者は、65歳以上の第１号被保険者と40歳以上65歳未満の医療保険加入者である第２号被保険者に区分されます」",
        "choice2": "「介護保険の第２号被保険者は、要介護状態または要支援状態となった原因を問わず、保険給付を受けることができます」",
        "choice3": "「介護保険の第２号被保険者が介護給付を受けた場合、原則として、実際にかかった費用（食費、居住費等を除く）の１割を自己負担する必要があります」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "5-1.png"
    },
    {
        "id": 264,
        "shikenId": 2,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ｍさんは、Ｘ社株式の投資指標について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「株価の相対的な割高・割安の度合いを判断する指標に、PERやPBRがあります。〈Ｘ社に関する資料〉から算出されるＸ社株式のPERは0.6倍、PBRは６倍です」",
        "choice2": "「 〈X社に関する資料〉から算出されるＸ社のROEは３％です。一般に、ROEが高い会社ほど、自己資本の効率的な活用がなされていると判断されます」",
        "choice3": "「Ｘ社の配当性向は30％です。一般に、配当性向が高いほど、株主への利益還元の度合いが高いと判断できます」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "4",
        "image": "5-2.png"
    },
    {
        "id": 265,
        "shikenId": 2,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ｍさんは、NISAを利用した投資について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「NISAのつみたて投資枠における年間の非課税投資枠は40万円です。購入は累積投資契約に基づく定期かつ継続的な買付けを行う方法に限られており、非課税期間は10年間です」",
        "choice2": "「NISAのつみたて投資枠の対象となる金融商品は、長期の積立・分散投資に適した一定の商品性を有する公募株式投資信託やETFとされ、上場株式は対象となっていません」",
        "choice3": "「NISAを利用して購入した公募株式投資信託を解約した際に損失が生じた場合、その損失の金額は、特定口座で保有する上場株式等の譲渡益と通算することができます」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "5-2.png"
    },
    {
        "id": 266,
        "shikenId": 2,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Y社債を《設例》の条件で購入した場合の最終利回り（年率・単利）は、次のうちどれか。なお、計算にあたっては税金等を考慮せず、答は％表示における小数点以下第３位を四捨五入している。",
        "choice1": "0.44%",
        "choice2": "1.01%",
        "choice3": "1.95%",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "5-2.png"
    },
    {
        "id": 267,
        "shikenId": 2,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税における総所得金額は、次のうちどれか。",
        "choice1": "536万円",
        "choice2": "561万円",
        "choice3": "611万円 <br><br><img src='/img/question/67_1.png' width='500'>",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "4",
        "image": "5-3.png"
    },
    {
        "id": 268,
        "shikenId": 2,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税における所得控除に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「妻Bさんの合計所得金額が58万円以下であるため、Ａさんは妻Bさんにかかる配偶者控除の適用を受けることができます」",
        "choice2": "「Ａさんが適用を受けることができる長女Ｃさんに係る扶養控除の額は、38万円です」",
        "choice3": "「長男Dさんは、特定扶養親族に該当するため、Aさんは、長男Dさんについて58万円の適用を受けることができます」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "5-3.png"
    },
    {
        "id": 269,
        "shikenId": 2,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税における医療費控除および確定申告に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「Aさんは、2025年中に支払った医療費の領収書を勤務先に提出することで、年末調整において医療費控除の適用を受けることができます」",
        "choice2": "「Ａさんが、妻Ｂさんの通院時に自家用車で送迎していた場合、その際にかかったガソリン代や駐車料金は、医療費控除の対象となる医療費の範囲に含まれます」",
        "choice3": "「生命保険契約から支払われた入院給付金や健康保険から支給を受けた高額療養費がある場合は、支払った医療費の総額からそれらの金額を控除する必要があります」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "5-3.png"
    },
    {
        "id": 270,
        "shikenId": 2,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "甲土地に賃貸マンション（耐火建築物）を建築する場合の①建蔽率の上限となる建築面積と②容積率の上限となる延べ面積の組合せとして、次のうち最も適切なものはどれか。",
        "choice1": "① 240㎡ ② 960㎡",
        "choice2": "① 280㎡ ② 960㎡",
        "choice3": "① 280㎡ ② 1,200㎡",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "4",
        "image": "5-4.png"
    },
    {
        "id": 271,
        "shikenId": 2,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "自宅（建物およびその敷地である甲土地）の譲渡に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「Ａさんがタワーマンションに転居し、その後、居住していない現在の自宅を譲渡した場合に、Ａさんが『居住用財産を譲渡した場合の3,000万円の特別控除の特例』の適用を受けるためには、家屋に自己が居住しなくなった日から３年を経過する日の属する年の12月31日までの譲渡であること等の要件を満たす必要があります」",
        "choice2": "「Ａさんが甲土地を譲渡し、『居住用財産を譲渡した場合の長期譲渡所得の課税の特例』（軽減税率の特例）の適用を受けた場合、課税長期譲渡所得金額が6,000万円以下の部分については、軽減税率が適用されます」",
        "choice3": "「Ａさんが、購入したタワーマンションをその後譲渡し、新たな住居を購入する場合、譲渡した年の１月１日において譲渡した居住用財産の所有期間が５年を超えていること等の要件を満たせば、『特定の居住用財産の買換えの場合の長期譲渡所得の課税の特例』の適用を受けることができます」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "5-4.png"
    },
    {
        "id": 272,
        "shikenId": 2,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "自己建設方式による甲土地の有効活用に関する以下の文章の空欄①～③に入る語句又は数値の組合せとして、次のうち最も適切なものはどれか。 <br> <br> <div class='b-box'>ⅰ）「Ａさんが甲土地に賃貸マンションを建築した場合、相続税の課税価格の計算上、甲土地は（ ① ）として評価されます」 <br> ⅱ）「甲土地が貸付事業用宅地等に該当すれば、『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けることができます。貸付事業用宅地等は、相続税の課税価格の計算上、（ ② ）㎡までの部分について（ ③ ）％の減額が受けられます」</div>",
        "choice1": "① 貸家建付地 ② 200 ③ 50",
        "choice2": "① 貸家建付地 ② 200 ③ 80",
        "choice3": "① 貸宅地 ② 400 ③ 80",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "5-4.png"
    },
    {
        "id": 273,
        "shikenId": 2,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの相続等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「遺言により、妻Ｂさんおよび長女Ｃさんが相続財産の大半を取得した場合、二女Ｄさんおよび長男Eさんが遺留分侵害請求権を行使する可能性があります」",
        "choice2": "「 『配偶者に対する相続税額の軽減』の適用を受けた場合、妻Bさんが相続により取得した財産の金額が、配偶者の法定相続分相当額と１億円のいずれか多い金額を超えない限り、妻Bさんが納付すべき相続税額は生じません」",
        "choice3": "「遺産分割をめぐる争いを防ぐ手段として、遺言書の作成をお勧めします。自筆証書遺言は、遺言者が、その全文、日付および氏名、財産目録のすべてを自書する必要があります」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "5-5.png"
    },
    {
        "id": 274,
        "shikenId": 2,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "仮に、Ａさんの相続が現時点（2025年５月23日）で開始し、Ａさんの相続に係る課税遺産総額（課税価格の合計額－遺産に係る基礎控除額）が２億4,000万円であった場合の相続税の総額は、次のうちどれか。",
        "choice1": "4,400万円",
        "choice2": "4,900万円",
        "choice3": "7,200万円 <div class='pt-3'>        <img src='/img/88_2_3.png' width='420'/>      </div>",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "4",
        "image": "5-5.png"
    },
    {
        "id": 275,
        "shikenId": 2,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの相続に係る小規模宅地等についての相続税の課税価格の計算の特例（以下、「本特例」という）に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「妻Ｂさんが自宅の敷地を相続により取得し、特定居住用宅地等として本特例の適用を受けた場合、敷地全体について80％の減額が受けられます」",
        "choice2": "「妻Ｂさんが自宅の敷地を相続により取得し、相続税の申告期限までに自宅の敷地を売却した場合であっても、当該敷地は特定居住用宅地等として本特例の適用を受けることができます」",
        "choice3": "「自宅の敷地と賃貸ビルの敷地について、本特例の適用を受けようとする場合、それぞれの宅地等の適用対象の限度面積まで適用を受けることはできず、適用対象面積の調整が必要です」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "5-5.png"
    },
    {
        "id": 276,
        "shikenId": 2,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "はじめに、Ｍさんは、老齢基礎年金について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「老齢基礎年金を受給するためには、原則として、国民年金の保険料納付済期間と保険料免除期間を合算した期間が10年必要です。Ａさんは、10年の受給資格期間を満たしていますので、原則として65歳から老齢基礎年金を受給することができます」",
        "choice2": "「Ａさんが希望すれば、60歳以上65歳未満の間に老齢基礎年金の繰上げ支給を請求することができます。仮に、Ａさんが60歳０カ月で老齢基礎年金の繰上げ支給を請求した場合の減額率は42％となります」",
        "choice3": "「Aさんは老後の年金収入を増やすために、所定の手続により、付加保険料を納付することができます。仮に、Aさんが付加保険料を60月納付し、65歳から老齢基礎年金を受給する場合、年額24,000円の付加年金を受給することができます」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "6-1.png"
    },
    {
        "id": 277,
        "shikenId": 2,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "次に、Ｍさんは、Aさんが老齢基礎年金の受給を65歳から開始した場合の年金額（2025年度価額）を試算した。Mさんが試算した老齢基礎年金の年金額の計算式として、次のうち最も適切なものはどれか。",
        "choice1": "<img src='/img/question/277_1.png' style='margin-top: -10px;margin-bottom:35px;height:50px'>",
        "choice2": "<img src='/img/question/277_2.png' style='margin-top: -11px;margin-bottom:35px;height:50px'>",
        "choice3": "<img src='/img/question/277_3.png' style='margin-top: -30px;margin-bottom:0px;height:65px'>",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "4",
        "image": "6-1.png"
    },
    {
        "id": 278,
        "shikenId": 2,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "最後に、Ｍさんは、老後の年金収入を増やすことができる各種制度について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「国民年金基金は、国民年金の第１号被保険者を対象とした、老齢基礎年金に上乗せする年金を支給する任意加入の年金制度です。国民年金基金の給付には、老齢年金、遺族一時金および障害年金があります」",
        "choice2": "「確定拠出年金の個人型年金は、加入者自身が掛金の運用方法を選択し、資産を形成する年金制度です。将来の年金額は、運用実績により変動しますが、拠出した掛金の合計額を下回ることはありません」",
        "choice3": "「小規模企業共済制度は、個人事業主が廃業等した場合に必要となる資金を準備しておくための制度です。毎月の掛金は、1,000円から70,000円までの範囲内（500円単位）で選択でき、支払った掛金は所得控除の対象となります」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "6-1.png"
    },
    {
        "id": 279,
        "shikenId": 2,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "はじめに、Ｍさんは、Ａさんが個人事業主となった場合の社会保険の取扱いについて説明した。Ｍさんが、Ａさんに対して説明した以下の文章の空欄①～③に入る数値の組合せとして、次のうち最も適切なものはどれか。<br> <br> <div class='b-box'>ⅰ）「Ａさんは、退職日の翌日から（ ① ）日以内に所定の申出をすることにより、最長で（ ➁ ）年間、任意継続被保険者として健康保険に加入することができます」 <br> ⅱ）「ＡさんがＸ社を退職し、厚生年金保険の被保険者でなくなった場合、妻Ｂさんは、国民年金の第（ ③ ）号被保険者への種別変更の届出を行い、国民年金の保険料を納付することになります」</div>",
        "choice1": "① 14 ② ２ ③ ３",
        "choice2": "① 20 ② ５ ③ １",
        "choice3": "① 20 ② ２ ③ １",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "6-2.png"
    },
    {
        "id": 280,
        "shikenId": 2,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "次に、Ｍさんは、Ａさんに想定されるリスクについて説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「個人事業主が加入する国民健康保険には、高額療養費制度が設けられています。仮に、Aさんが病気やケガで医師の診察を受け、同年中に医療機関等に支払った医療費の一部負担金等の合計が自己負担限度額を超えた場合、所定の手続により支払った医療費の全額が高額療養費として支払われます」",
        "choice2": "「個人事業主となったＡさんが生活習慣病等で働けなくなった場合、会社員のときよりも収入が減少するリスクが高くなると思われます。そのため、治療費の準備に加えて、働けなくなった場合の所得補償の準備もご検討ください」",
        "choice3": "「Ａさんのような公的介護保険の第２号被保険者は、要介護状態または要支援状態となった原因を問わず、公的介護保険からの保険給付を受けられます」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "6-2.png"
    },
    {
        "id": 281,
        "shikenId": 2,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "最後に、Ｍさんは、生命保険の見直しについてアドバイスした。ＭさんのＡさんに対するアドバイスとして、次のうち最も不適切なものはどれか。",
        "choice1": "「最近では、入院１日目から相応の一時金が支払われるタイプや、退院後の通院治療のために給付金が支払われるタイプの保険（特約）が販売されています。保険会社各社の保障内容をよく比較して、見直しを検討しましょう」",
        "choice2": "「現在加入している定期保険特約付終身保険を見直す方法として、契約転換制度の活用が考えられます。ただし、契約転換時の告知や医師の審査が必要である点に注意が必要です」",
        "choice3": "「Aさんが加入している生命保険には、リビング・ニーズ特約が付加されていますので、Aさんが余命１年以内と判断された場合、生前給付金を受け取ることができます」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "4",
        "image": "6-2.png"
    },
    {
        "id": 282,
        "shikenId": 2,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "仮に、将来Ｘ社がＡさんに役員退職金4,500万円を支給した場合、Ａさんが受け取る役員退職金に係る退職所得の金額として、次のうち最も適切なものはどれか。なお、Ａさんの役員在任期間（勤続年数）を37年とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。",
        "choice1": "955万円",
        "choice2": "1,255万円",
        "choice3": "2,510万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "6-3.png"
    },
    {
        "id": 283,
        "shikenId": 2,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ｍさんは《設例》の終身保険について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「Ｘ社が契約者貸付制度を利用し、契約者貸付金を受け取った場合、当該終身保険契約は継続しているため、経理処理は必要ありません」",
        "choice2": "「Ａさんが所定の高度障害状態になった場合、高度障害保険金7,000万円がＸ社に支払われます。その後、Ａさんが死亡した場合には、死亡保険金は支払われません」",
        "choice3": "「Ａさんの勇退時に、契約者をＡさん、死亡保険金受取人をＡさんの相続人に名義変更して、当該終身保険契約を役員退職金の一部として現物支給した場合、契約は継続しているため、Ｘ社での経理処理は必要ありません」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "4",
        "image": "6-3.png"
    },
    {
        "id": 284,
        "shikenId": 2,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "《設例》の終身保険の第１回保険料払込時の経理処理（仕訳）として、次のうち最も適切なものはどれか。",
        "choice1": "<img src='/img/question/284_1.png' width='400'>",
        "choice2": "<img src='/img/question/284_2.png' width='400'>",
        "choice3": "<img src='/img/question/284_3.png' width='400'>",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "6-3.png"
    },
    {
        "id": 285,
        "shikenId": 2,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税における総所得金額は、次のうちどれか。",
        "choice1": "520万円",
        "choice2": "545万円",
        "choice3": "570万円<br><br><img src='/img/question/67_1.png' width='500'>",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "4",
        "image": "6-4.png"
    },
    {
        "id": 286,
        "shikenId": 2,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税における所得控除の控除額に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「母Ｃさんは老人扶養親族の同居老親等に該当するため、Ａさんが適用を受けることができる扶養控除の控除額は、63万円です」",
        "choice2": "「Ａさんが適用を受けることができる基礎控除の控除額は、95万円です」",
        "choice3": "「Ａさんが適用を受けることができる配偶者控除の控除額は、38万円です」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "6-4.png"
    },
    {
        "id": 287,
        "shikenId": 2,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税における生命保険料控除に関する以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。 <br> <br> <div class='b-box'>「Ａさんが加入した終身医療保険に係る保険料は、（ ① ）保険料控除の対象となります。2025年分の所得税において、Ａさんが生命保険料控除として総所得金額から控除することができる金額は、（ ② ）円です。また、生命保険料控除は、生命保険に加入した年分について、勤務先の年末調整で適用を受けることが（ ③ ）」</div>",
        "choice1": "① 介護医療 ② 40,000 ③ できます",
        "choice2": "① 介護医療 ② 100,000 ③ できません",
        "choice3": "① 一般生命 ② 40,000 ③ できません",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "6-4.png"
    },
    {
        "id": 288,
        "shikenId": 2,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "生前贈与に関する以下の文章の空欄①～③に入る語句または数値の組み合わせとして、次のうち最も適切なものはどれか。 <br> <br> <div class='b-box'>ⅰ）「Ａさんが長女Ｃさんに現金を贈与し、長女Ｃさんが暦年課税を選択した場合、その年分の贈与税額の計算上、基礎控除額として最大で（ ① ）万円を課税価格から控除することができます」<br> ⅱ）「Ａさんが長女Ｃさんに現金を贈与し、長女Ｃさんが相続時精算課税制度を選択した場合は、年間（ ① ）万円の基礎控除額の他に、累計で（ ② ）万円までの贈与について贈与税は課されません。 また、長女Ｃさんが相続時精算課税制度を選択した場合、その選択をした年分以降にＡさんから長女Ｃさんへ贈与する財産について、暦年課税へ変更することが（ ③ ）」</div>",
        "choice1": "① 110 ② 3,000 ③ できます",
        "choice2": "① 220 ② 2,500 ③ できません",
        "choice3": "① 110 ② 2,500 ③ できません",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "6-5.png"
    },
    {
        "id": 289,
        "shikenId": 2,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの相続等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「長女Ｃさんが受け取る一時払終身保険の死亡保険金は、みなし相続財産として相続税の課税対象となりますが、『500万円×法定相続人の数』を限度として、死亡保険金の非課税金額の規定の適用を受けることができます」",
        "choice2": "「妻Ｂさんが自宅の敷地を相続により取得し、特定居住用宅地等として『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けた場合、自宅の敷地について相続税の課税価格に算入すべき価額は1,400万円となります」",
        "choice3": "「円滑な遺産分割のための手段として遺言書の作成をお勧めします。自筆証書遺言は、その遺言の全文および財産目録をパソコンで作成し、日付および氏名を自書して押印することで作成することができます」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "6-5.png"
    },
    {
        "id": 290,
        "shikenId": 2,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "仮に、Ａさんの相続が現時点（2025年５月23日）で開始し、Ａさんの相続に係る課税遺産総額（課税価格の合計額－遺産に係る基礎控除額）が9,000万円であった場合の相続税の総額は、次のうちどれか。 ",
        "choice1": "1,200万円",
        "choice2": "1,275万円",
        "choice3": "2,000万円<div class='pt-3'>        <img src='/img/88_2_3.png' width='420'/>      </div>",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "4",
        "image": "6-5.png"
    },
    {
        "id": 291,
        "shikenId": 2,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "ファイナンシャル・プランニング業務を行うに当たっては、関連業法を順守することが重要である。ファイナンシャル・プランナー（以下「ＦＰ」という）の行為に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "生命保険募集人、保険仲立人の登録を受けていないＦＰが、生命保険契約を検討している顧客のライフプランに基づき、必要保障額を具体的に試算し、相談料金を受け取った。",
        "choice2": "投資助言・代理業の登録を受けていないＦＰが、顧客と投資顧問契約を締結し、当該契約に基づいて具体的な投資銘柄と投資タイミングについて有償で助言をした。",
        "choice3": "税理士資格を有していないＦＰが、相続対策を検討している顧客に対し、一般的な相続税制度の仕組みと手順を解説し、相談料金を受け取った。",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 292,
        "shikenId": 2,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "下記は、服部家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表の空欄（ア）、（イ）にあてはまる数値の組み合わせとして、正しいものはどれか。なお、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><img src=\"/img/question/292_2.png\" class=\"question-img\" /><br> <br> ※年齢および金融資産残高は各年１２月３１日現在のものとし、２０２５年を基準年とする。<br> ※給与収入は可処分所得で記載している。<br> ※記載されている数値は正しいものとする。<br> ※問題作成の都合上、一部を空欄にしてある。",
        "choice1": "（ア）４０５ （イ）１,３６４",
        "choice2": "（ア）４０６ （イ）１,３７４",
        "choice3": "（ア）４０５ （イ）１,３７４",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 293,
        "shikenId": 2,
        "parentNo": 1,
        "no": 3,
        "groupId": 2,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "長谷川家の現時点の資産および負債が下記＜資料＞のとおりである場合、＜資料＞に基づく長谷川家のバランスシートの空欄（ア）にあてはまる金額として、正しいものはどれか。なお、記載のない事項については一切考慮しないこととする。<br> <br><img src=\"/img/question/293_3.png\" class=\"question-img\"  style=\"width:600px\" /><br> <br> ＜資料＞<br><img src=\"/img/question/293_2.png\" class=\"question-img\"  style=\"width:500px\" /><br> <br> ［負債残高］<br> 住宅ローン（自宅マンション）：２,２００万円（債務者は長谷川さん、団体信用生命保険付き）",
        "choice1": "１,２２０（万円）",
        "choice2": "１,９２０（万円）",
        "choice3": "１,９６０（万円）",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 294,
        "shikenId": 2,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "会社員の山田さんは、６０歳で定年を迎えた後、公的年金の支給が始まる６５歳までの５年間の生活資金に退職一時金の一部を充てようと考えている。仮に、退職一時金のうち８００万円を年利１.０％で複利運用しながら５年間で均等に取り崩すこととした場合、毎年の生活資金に充てることができる最大金額として、正しいものはどれか。なお、下記＜資料＞の３つの係数の中から最も適切な係数を選択して計算し、解答に当たっては万円未満を切り捨てること。また、税金や記載のない事項については一切考慮しないこととする。<br><img src=\"/img/question/294_2.png\" class=\"question-img\" style=\"width:500px\" />",
        "choice1": "７６１万円",
        "choice2": "１５６万円",
        "choice3": "１６４万円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 295,
        "shikenId": 2,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "会社員の石戸さんは、通常６５歳から支給される老齢基礎年金および老齢厚生年金を繰り下げて受給できることを知り、ＦＰの矢尾さんに質問をした。老齢基礎年金および老齢厚生年金の繰下げ受給に関する次の記述のうち、最も適切なものはどれか。なお、老齢基礎年金および老齢厚生年金の受給要件は満たしているものとする。",
        "choice1": "「老齢基礎年金および老齢厚生年金を繰り下げて受給した場合には、一生涯増額された年金を受給することになります。」",
        "choice2": "「老齢基礎年金および老齢厚生年金を繰り下げて受給した場合の年金額は、繰下げ年数１年当たり0.4％の割合で増額された額となります。」",
        "choice3": "「老齢基礎年金と老齢厚生年金は、どちらか一方のみを繰り下げて受給することはできません。」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 296,
        "shikenId": 2,
        "parentNo": 1,
        "no": 6,
        "groupId": 3,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "景気動向指数に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「有効求人倍率や新設住宅着工床面積は、先行系列に採用されています。」",
        "choice2": "「東証株価指数や新規求人数は、一致系列に採用されています。」",
        "choice3": "「完全失業率や消費者物価指数は、遅行系列に採用されています。」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 297,
        "shikenId": 2,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "下記＜資料＞の外貨定期預金について、満期時の外貨ベースの元利合計額を円転した金額として、正しいものはどれか。なお、計算結果（円転した金額）について円未満の端数が生じる場合は切り捨てること。また、税金については考慮しないこととする。<br><img src=\"/img/question/297_1_1.png\" class=\"question-img\" />",
        "choice1": "８８７,２２９円",
        "choice2": "８８１,６９４円",
        "choice3": "８７７,１６４円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 298,
        "shikenId": 2,
        "parentNo": 1,
        "no": 8,
        "groupId": 4,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "小堀さんは、預金保険制度の対象となるＨＡ銀行の国内支店に下記＜資料＞の預金を預け入れている。<br> 仮に、ＨＡ銀行が破たんした場合、預金保険制度によって保護される金額に関する次の記述のうち、最も適切なものはどれか。<br><img src=\"/img/question/298_1_1.png\" class=\"question-img\" />",
        "choice1": "決済用預金は１,０００万円まで保護される。",
        "choice2": "外貨預金は全額保護される。",
        "choice3": "円定期預金および円普通預金は、合算し１,０００万円までが保護される。",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 299,
        "shikenId": 2,
        "parentNo": 1,
        "no": 9,
        "groupId": 4,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "公的な土地評価に関する下表の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img src=\"/img/question/299_1_1.png\" class=\"question-img\" />",
        "choice1": "（ア）総務省 （イ）市町村（東京２３区は東京都） （ウ）７０％",
        "choice2": "（ア）国土交通省 （イ）国税庁 （ウ）７０％",
        "choice3": "（ア）総務省 （イ）国税庁 （ウ）８０％",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 300,
        "shikenId": 2,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "下記＜資料＞の甲土地の建築面積の最高限度を算出する基礎となる敷地面積として、正しいものはどれか。なお、この土地の存する区域は特定行政庁が指定する区域に該当しないものとし、その他記載のない条件については一切考慮しないこととする。<br><img src=\"/img/question/300_1_1.png\" class=\"question-img\" />",
        "choice1": "２８０㎡",
        "choice2": "２９０㎡",
        "choice3": "３００㎡",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 301,
        "shikenId": 2,
        "parentNo": 1,
        "no": 11,
        "groupId": 5,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "下表は、定期借地権についてまとめた表である。下表の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img src=\"/img/question/301_1_1.png\" class=\"question-img\" />",
        "choice1": "（ア）制限なし （イ）30年以上50年未満 （ウ）借地人",
        "choice2": "（ア）公正証書等の書面または電磁的記録 （イ）10年以上50年未満 （ウ）土地所有者",
        "choice3": "（ア）公正証書等の書面または電磁的記録 （イ）50年以上 （ウ）土地所有者",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 302,
        "shikenId": 2,
        "parentNo": 1,
        "no": 12,
        "groupId": 5,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "皆木慎太朗さんが加入している医療保険（下記〈資料〉参照）の保障内容に関する次の記述の空欄（ア）にあてはまる金額として、正しいものはどれか。なお、保険契約は有効に継続しているものとする。また、慎太朗さんはこれまでに〈資料〉の保険から保険金および給付金を一度も受け取っていないものとする。<br><img src=\"/img/question/302_1_1.png\" class=\"question-img\" />",
        "choice1": "３８０,０００円",
        "choice2": "３９５,０００円",
        "choice3": "４００,０００円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 303,
        "shikenId": 2,
        "parentNo": 1,
        "no": 13,
        "groupId": 6,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "ＦＰの清野さんは相談者の角田さんから地震保険に関する質問を受けた。地震保険に関する清野さんの次の説明のうち、最も不適切なものはどれか。",
        "choice1": "「地震保険は単独で加入することはできず、火災保険等に付帯して加入する必要があります。」",
        "choice2": "「地震保険の割引制度には、『建築年割引』 『耐震等級割引』 『免震建築物割引』 『耐震診断割引』があり、それぞれの割引制度は重複適用が可能です。」",
        "choice3": "「地震による火災により、居住用の建物が全損となった場合、地震保険の補償の対象となります。」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 304,
        "shikenId": 2,
        "parentNo": 1,
        "no": 14,
        "groupId": 6,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "損害保険の用語に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「保険金とは、保険事故により損害が生じたとき、保険会社が被保険者または保険金受取人に支払う金銭のことです。」",
        "choice2": "「一部保険とは、保険の対象の価額（保険価額）が保険金額を超えている保険のことです。」",
        "choice3": "「再調達価額とは、保険の対象と同等のものを新たに建築または購入するのに必要な金額から、使用による消耗分を差し引いた金額のことです。」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 305,
        "shikenId": 2,
        "parentNo": 1,
        "no": 15,
        "groupId": 6,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "西住さんは、２０２５年７月に新築のアパートを購入し、新たに不動産賃貸業を開始した。購入したアパートの建物部分の情報は下記＜資料＞のとおりである。西住さんの２０２５年分の所得税における不動産所得の金額の計算上、必要経費に算入する減価償却費の金額として、正しいものはどれか。<br><img src=\"/img/question/305_1_1.png\" class=\"question-img\" style=\"width:500px\" />",
        "choice1": "９３５,０００円",
        "choice2": "１,８２７,５００円",
        "choice3": "１,８７０,０００円",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 306,
        "shikenId": 2,
        "parentNo": 1,
        "no": 16,
        "groupId": 7,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "土地と建物の譲渡に係る所得税の計算に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「土地と建物などの譲渡による所得は、不動産所得として総合課税の対象となります。」",
        "choice2": "「土地を譲渡したことによる譲渡損失の金額は、原則として他の各種所得の金額と損益通算することができます。」",
        "choice3": "「土地と建物などの譲渡による所得の金額は、原則として『譲渡価額－取得費－譲渡費用』として計算します。」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 307,
        "shikenId": 2,
        "parentNo": 1,
        "no": 17,
        "groupId": 7,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "会社員の中野望さんが２０２５年中に支払った医療費等が下記＜資料＞のとおりである場合、望さんの２０２５年分の所得税の確定申告における医療費控除の金額として、正しいものはどれか。なお、望さんの２０２５年中の所得は、給与所得８００万円のみであり、支払った医療費等はすべて望さんおよび生計を一にする妻のために支払ったものである。また、医療費控除の金額が最も大きくなるよう計算することとし、セルフメディケーション税制（特定一般用医薬品等購入費を支払った場合の医療費控除の特例）については、考慮しないものとする。<br><img src=\"/img/question/307_1_1.png\" class=\"question-img\" /><br> <br> （※１）人間ドックの結果、重大な疾病は発見されていない。<br> （※２）この入院について、加入中の生命保険から入院給付金が７万円支給された。",
        "choice1": "１２万円",
        "choice2": "１９万円",
        "choice3": "２２万円",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 308,
        "shikenId": 2,
        "parentNo": 1,
        "no": 18,
        "groupId": 7,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "２０２５年１月５日に相続が開始された三河太一朗さん（被相続人）の〈親族関係図〉が下記のとおりである場合、民法上の相続人および法定相続分の組み合わせとして、正しいものはどれか。なお、記載のない条件については一切考慮しないこととする。<br><img src=\"/img/question/308_1_1.png\" class=\"question-img\" />",
        "choice1": "美佐子 ２／３　みき １／３",
        "choice2": "美佐子 １／２　みき １／２",
        "choice3": "美佐子 １／２　優佳 １／２",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 309,
        "shikenId": 2,
        "parentNo": 1,
        "no": 19,
        "groupId": 7,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "相続開始後の各種手続きにおける下記〈資料〉の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、記載のない事項については一切考慮しないこととする。<br><img src=\"/img/question/309_1_1.png\" class=\"question-img\" />",
        "choice1": "（ア）１０ヵ月\n（イ）地方裁判所\n（ウ） ６ヵ月",
        "choice2": "（ア）３ヵ月\n（イ）地方裁判所\n（ウ）１０ヵ月",
        "choice3": "（ア）３ヵ月\n（イ）家庭裁判所\n（ウ）１０ヵ月",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 310,
        "shikenId": 2,
        "parentNo": 1,
        "no": 20,
        "groupId": 7,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "姉歯さん（８２歳）は、将来発生するであろう自身の相続について、遺産分割等でのトラブルを防ぐために公正証書遺言の作成を検討しており、ＦＰの桐谷さんに相談をした。下記の空欄（ア）～（ウ）にあてはまる語句または数値の組合せとして、最も適切なものはどれか。<br> ＜桐谷さんの説明＞<br><div class='b-box'> 「公正証書遺言は、証人（ ア ）人以上の立会いのもと、遺言者が遺言の趣旨を公証人に口授し、公証人がそれを筆記して作成される遺言のことです。公正証書遺言は、相続開始後における検認が（ イ ）です。なお、すでに作成した公正証書遺言を撤回したい場合、自筆証書遺言で撤回することは（ ウ ）」</div>",
        "choice1": "（ア）１\n（イ）不要\n（ウ）できます",
        "choice2": "（ア）２\n（イ）必要\n（ウ）できません",
        "choice3": "（ア）２\n（イ）不要\n（ウ）できます",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 1001,
        "shikenId": 20,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "ファイナンシャル・プランナー（以下「ＦＰ」という）の顧客に対する行為に関する次の記述のうち、関連法規に照らし、最も不適切なものはどれか。",
        "choice1": "金融商品取引業の登録を受けていないＦＰのＡさんは、顧客から確定拠出年金の個人型年金（iDeCo）について相談を受け、iDeCoの運用商品の特徴について説明した。",
        "choice2": "社会保険労務士の資格を有しないＦＰのＢさんは、顧客から公的年金の老齢給付の繰上げ受給について相談を受け、顧客の「ねんきん定期便」の年金受取見込額を基に、繰り上げた場合の年金額を試算した。",
        "choice3": "司法書士の資格を有しないＦＰのＣさんは、住宅ローンを完済した顧客から、抵当権の抹消登記について相談を受け、申請書を作成して登記手続を代行した。",
        "choice4": "税理士の資格を有しないＦＰのＤさんは、顧客からふるさと納税について相談を受け、寄附金控除の仕組みについて説明した。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1002,
        "shikenId": 20,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "ライフプランニングにおけるライフステージ別の一般的な資金の活用等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "Ａさん（60歳）は、退職金と預貯金のうち、今後の生活資金を確保した残りの余裕資金から、子が住宅を取得するための頭金として、税務上非課税となる範囲で現金を贈与することとした。",
        "choice2": "Ｂさん（25歳）は、子の教育資金を準備するため、金融機関のカードローンで資金を借り入れ、高リスクだが、高い収益が見込める金融商品を購入して積極的な運用を図ることとした。",
        "choice3": "Ｃさん（70歳）は、相続対策として、相続人がもめないように、遺言執行者として弁護士を指定した自筆証書遺言を作成し、法務局（遺言書保管所）に保管の申請をすることとした。",
        "choice4": "Ｄさん（40歳）は、老後の生活資金を充実させるために、確定拠出年金の個人型年金（iDeCo）を利用して余裕資金を運用することとした。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1003,
        "shikenId": 20,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "労働者災害補償保険（以下「労災保険」という）に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "業務上の負傷または疾病が治癒したときに身体に一定の障害が残り、その障害の程度が労働者災害補償保険法に規定する障害等級に該当する場合、障害補償給付が受けられる。",
        "choice2": "労災保険の適用を受ける労働者には、雇用形態がアルバイトやパートタイマーである者も含まれる。",
        "choice3": "労災保険の保険料を計算する際に用いる保険料率は、適用事業所の事業の種類により異なる。",
        "choice4": "労災保険の適用事業所の事業主は、その営む事業において使用する労働者数の多寡にかかわらず、労災保険の特別加入の対象となる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1004,
        "shikenId": 20,
        "parentNo": 1,
        "no": 4,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "雇用保険法に基づく育児休業給付および介護休業給付に関する次の記述のうち、最も適切なものはどれか。なお、記載されたもの以外の要件はすべて満たしているものとする。",
        "choice1": "育児休業給付金に係る支給単位期間において、一般被保険者や高年齢被保険者に対して支払われた賃金額が、休業開始時賃金日額に支給日数を乗じて得た額の60％相当額以上である場合、当該支給単位期間について育児休業給付金は支給されない。",
        "choice2": "一般被保険者や高年齢被保険者の父母および配偶者の父母は、介護休業給付金の支給対象となる家族に該当しない。",
        "choice3": "一般被保険者や高年齢被保険者が、一定の状態にある家族を介護するために休業する場合、同一の対象家族について、通算３回かつ180日の介護休業を限度とし、介護休業給付金が支給される。",
        "choice4": "一般被保険者や高年齢被保険者が、１歳に満たない子を養育するために休業する場合、育児休業給付金が支給される。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1005,
        "shikenId": 20,
        "parentNo": 1,
        "no": 5,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "公的年金に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "産前産後休業を取得している厚生年金保険の被保険者の厚生年金保険料は、所定の手続きにより、被保険者負担分と事業主負担分がいずれも免除される。",
        "choice2": "老齢厚生年金の受給権者が老齢厚生年金の繰下げ支給の申出をする場合、老齢基礎年金の繰下げ支給の申出を同時に行わなければならない。",
        "choice3": "老齢厚生年金の額に加給年金額が加算されるためには、原則として、厚生年金保険の被保険者期間が10年以上であり、かつ、その受給権者によって生計を維持されている一定の要件を満たす配偶者または子がいる必要がある。",
        "choice4": "国民年金の第１号被保険者は、日本国内に住所を有する20歳以上60歳未満の自営業者や学生などのうち、日本国籍を有する者のみが該当する。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1006,
        "shikenId": 20,
        "parentNo": 1,
        "no": 6,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "国民年金基金、小規模企業共済および中小企業退職金共済に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "国民年金基金には、国民年金の第３号被保険者が加入することはできない。",
        "choice2": "国民年金基金には、国内に住所を有する60歳以上65歳未満の国民年金の任意加入被保険者も加入することができる。",
        "choice3": "小規模企業共済に加入した場合、支払った掛金額の全額が小規模企業共済等掛金控除として所得税の所得控除の対象となる。",
        "choice4": "中小企業退職金共済に新規で加入する事業主は、加入月から１年間、掛金月額の２分の１相当額（従業員ごとに5,000円が上限）について国の助成を受けることができる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1007,
        "shikenId": 20,
        "parentNo": 1,
        "no": 7,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "公的年金に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "障害基礎年金と遺族厚生年金の受給権を有している者は、65歳以降、障害基礎年金と遺族厚生年金を同時に受給することができない。",
        "choice2": "障害基礎年金と老齢厚生年金の受給権を有している者は、65歳以降、障害基礎年金と老齢厚生年金を同時に受給することができない。",
        "choice3": "同一の事由により、障害厚生年金と労働者災害補償保険法に基づく障害補償年金が支給される場合、障害補償年金は全額支給され、障害厚生年金は所定の調整率により減額される。",
        "choice4": "健康保険の傷病手当金の支給を受けるべき者が、同一の疾病または負傷およびこれにより発した疾病について障害厚生年金の支給を受けることができる場合、障害厚生年金の支給が優先される。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1008,
        "shikenId": 20,
        "parentNo": 1,
        "no": 8,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "住宅金融支援機構と金融機関が提携した住宅ローンであるフラット35（買取型）に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "フラット35Ｓは、省エネルギー性、耐震性など一定の技術基準を満たした住宅を取得する場合に、借入金利を一定期間引き下げる制度である。",
        "choice2": "フラット35の利用者向けインターネットサービスである「住・MyNote」を利用して繰上げ返済する場合、一部繰上げ返済の最低返済額は10万円である。",
        "choice3": "店舗付き住宅などの併用住宅を建築する際に、フラット35を利用することはできない。",
        "choice4": "住宅金融支援機構は、融資を実行する金融機関から住宅ローン債権を買い取り、対象となる住宅の第１順位の抵当権者となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1009,
        "shikenId": 20,
        "parentNo": 1,
        "no": 9,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "リタイアメントプランニング等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "金融機関のリバースモーゲージには、一般に、利用者が死亡し、担保物件の売却代金により借入金を返済した後も債務が残った場合に、利用者の相続人がその返済義務を負う「ノンリコース型」と、返済義務を負わない「リコース型」がある。",
        "choice2": "高齢者の居住の安定確保に関する法律に定める「サービス付き高齢者向け住宅」に入居した者は、「状況把握サービス」や「生活相談サービス」を受けることができる。",
        "choice3": "将来、本人の判断能力が不十分になった場合に備えて、あらかじめ本人が選任した者と締結する任意後見契約は、公正証書によらない場合であっても有効である。",
        "choice4": "確定拠出年金の加入者が、老齢給付金を60歳から受給するためには、通算加入者等期間が５年以上なければならない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1010,
        "shikenId": 20,
        "parentNo": 1,
        "no": 10,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "クレジットカード会社（貸金業者）が発行するクレジットカードの一般的な利用に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "クレジットカードで商品を購入（ショッピング）した場合の返済方法の一つである定額リボルビング払い方式は、クレジットの利用金額・件数に関わらず、あらかじめ設定した一定の金額を支払う方式である。",
        "choice2": "クレジットカードで無担保借入（キャッシング）をする行為は、貸金業法上、総量規制の対象となる。",
        "choice3": "クレジットカード会員規約では、原則としてクレジットカードは他人へ貸与することが禁止されているが、クレジットカード会員が生計を維持している親族に対しては貸与することができる。",
        "choice4": "クレジットカード会員の信用情報は、クレジットカード会社が加盟する指定信用情報機関により管理されており、会員は自己の信用情報について所定の手続きにより開示請求をすることができる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1011,
        "shikenId": 20,
        "parentNo": 1,
        "no": 11,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "個人年金保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、契約者（＝保険料負担者）、被保険者および年金受取人は同一人とする。",
        "choice1": "外貨建て個人年金保険では、円換算支払特約を付加することで、契約時点の為替レートで円換算した年金を受け取ることができる。",
        "choice2": "個人年金保険では、被保険者が保険料払込期間中に所定の高度障害状態に該当すると、以後の保険料の払込みが免除され、直ちに年金を受け取ることができる。",
        "choice3": "個人年金保険（保証期間付終身年金）では、保証期間中に被保険者が死亡した場合、死亡給付金受取人が、既払込保険料相当額からすでに支払われた年金額を差し引いた金額を死亡給付金として受け取ることができる。",
        "choice4": "生存保障重視型の個人年金保険では、他の契約条件が同一で生存保障重視型ではない個人年金保険と比較して、保険料払込期間中の死亡給付金や解約返戻金の額が低く設定され、将来受け取る年金額が高く設定されている。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1012,
        "shikenId": 20,
        "parentNo": 1,
        "no": 12,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "生命保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、特約については考慮しないものとする。",
        "choice1": "養老保険では、被保険者に高度障害保険金が支払われた場合であっても、その被保険者が保険期間満了まで生存したときには満期保険金が支払われる。",
        "choice2": "収入保障保険の死亡保険金を年金形式で受け取る場合の受取総額は、一時金で受け取る場合の受取額と同額である。",
        "choice3": "変額保険（終身型）の死亡保険金については、運用実績に応じて保険金額が変動するが、契約時に定めた保険金額（基本保険金額）は保証される。",
        "choice4": "こども保険（学資保険）では、契約者が死亡した場合、あらかじめ指定された受取人に死亡給付金が支払われる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1013,
        "shikenId": 20,
        "parentNo": 1,
        "no": 13,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "生命保険料控除に関する次の記述のうち、最も適切なものはどれか。なお、各選択肢において、ほかに必要とされる要件等はすべて満たしているものとする。",
        "choice1": "養老保険の保険料は、介護医療保険料控除の対象となる。",
        "choice2": "少額短期保険の保険料は、その保険契約が被保険者の死亡時に死亡保険金が支払われるものである場合、一般の生命保険料控除の対象となる。",
        "choice3": "終身保険の月払保険料のうち、2026年１月に払い込まれた2025年12月分の保険料は、2025年分の一般の生命保険料控除の対象となる。",
        "choice4": "変額個人年金保険の保険料は、個人年金保険料控除の対象とはならず、一般の生命保険料控除の対象となる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1014,
        "shikenId": 20,
        "parentNo": 1,
        "no": 14,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "個人年金保険の税金に関する次の記述のうち、最も不適切なものはどれか。なお、いずれも契約者（＝保険料負担者）は個人であるものとする。",
        "choice1": "契約者と被保険者が異なる個人年金保険において、年金支払開始前に被保険者が死亡して契約者が受け取った死亡給付金は、所得税の課税対象となる。",
        "choice2": "契約者と年金受取人が異なる個人年金保険において、年金支払開始時に年金受取人が取得した年金受給権は、贈与税の課税対象となる。",
        "choice3": "契約者と年金受取人が同一人である個人年金保険（保証期間付終身年金）において、保証期間中に年金受取人が死亡して遺族が取得した残りの保証期間の年金受給権は、相続税の課税対象となる。",
        "choice4": "契約者と年金受取人が同一人である個人年金保険において、年金受取人が毎年受け取る年金は、雑所得として公的年金等控除の対象となる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1015,
        "shikenId": 20,
        "parentNo": 1,
        "no": 15,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "法人を契約者（＝保険料負担者）とする生命保険に係る保険料の経理処理に関する次の記述のうち、最も適切なものはどれか。なお、いずれの保険契約も保険料は年払いかつ全期払いで、2025年10月に締結したものとする。",
        "choice1": "被保険者が役員および従業員全員、死亡保険金受取人が被保険者の遺族、満期保険金受取人が法人である養老保険の支払保険料は、その全額を損金の額に算入することができる。",
        "choice2": "被保険者が役員、死亡保険金受取人が法人である終身保険の支払保険料は、その全額を損金に計上する。",
        "choice3": "被保険者が役員、死亡保険金受取人が法人で、最高解約返戻率が60％である定期保険（保険期間20年、年払保険料100万円）の支払保険料は、保険期間の前半100分の40相当期間においては、その40％相当額を限度に資産の額に算入する。",
        "choice4": "被保険者が役員、給付金受取人が法人である解約返戻金のない医療保険の支払保険料は、資産の額に算入する。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1016,
        "shikenId": 20,
        "parentNo": 1,
        "no": 16,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "任意加入の自動車保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、記載のない事項については考慮しないものとする。",
        "choice1": "対物賠償保険では、被保険自動車を運転中に、父の自宅の車庫に誤って衝突して車庫を損壊させた場合、補償の対象となる。",
        "choice2": "対人賠償保険では、被保険自動車を運転中に、対人事故を起こした被保険者が法律上の損害賠償責任を負った場合、自動車損害賠償責任保険等によって補償される部分を除いた額が補償の対象となる。",
        "choice3": "人身傷害保険では、被保険者が被保険自動車を運転中に起こした交通事故で死傷した場合、被保険者の過失割合にかかわらず、当該損害額が保険金額を限度として補償の対象となる。",
        "choice4": "一般条件の車両保険では、被保険自動車が洪水で水没した場合、補償の対象となる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1017,
        "shikenId": 20,
        "parentNo": 1,
        "no": 17,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "住宅用建物および家財を保険の対象とする火災保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、特約については考慮しないものとする。",
        "choice1": "火災保険の保険料は、対象となる住宅用建物の構造により、Ｍ構造、Ｔ構造、Ｈ構造の３つに区分されて算定される。",
        "choice2": "保険金額が2,000万円（保険価額と同額）の火災保険に加入した後、火災により住宅用建物が損害を被り、損害保険金1,000万円が支払われた場合、保険契約は継続するが、保険期間満了日までの保険金額が1,000万円に減額される。",
        "choice3": "火災保険では、隣家の火災の消火活動により住宅用建物に収容されている家財が損壊した場合、補償の対象とならない。",
        "choice4": "火災保険では、雪災により住宅用建物の屋根が損壊して100万円の損害が発生した場合、補償の対象とならない。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1018,
        "shikenId": 20,
        "parentNo": 1,
        "no": 18,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "医療保険等の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "がん保険の入院給付金は、１回の入院における支払日数および通算の支払日数に制限はない。",
        "choice2": "先進医療特約で先進医療給付金の支払対象とされている先進医療は、契約時点において厚生労働大臣によって定められているものである。",
        "choice3": "１泊２日の入院検査（人間ドック検診）で異常が認められ、治療を目的とした入院を医師から指示された場合、その追加の入院については医療保険の入院給付金の支払対象とならない。",
        "choice4": "特定（三大）疾病保障定期保険では、被保険者が特定疾病に罹患し、特定疾病保険金を受け取った場合でも、その後被保険者が死亡した際には死亡保険金が支払われる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1019,
        "shikenId": 20,
        "parentNo": 1,
        "no": 19,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "第三分野の保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、記載のない特約については考慮しないものとする。",
        "choice1": "所得補償保険では、ケガや病気によって就業不能となった場合であっても、所定の医療機関に入院しなければ、補償の対象とならない。",
        "choice2": "生命保険会社が取り扱う介護保険は、公的介護保険の加入年齢である40歳から加入可能となり、保険期間は65歳までとされる。",
        "choice3": "限定告知型の医療保険では、他の契約条件が同一で限定告知型ではない医療保険と比較して、割高な保険料が設定されている。",
        "choice4": "がん保険では、180日間または６カ月間の免責期間が設けられており、その期間中にがんと診断されても、がん診断給付金は支払われない。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1020,
        "shikenId": 20,
        "parentNo": 1,
        "no": 20,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "損害保険を利用した事業活動のリスク管理に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "家庭用品を製造する事業者が、製造した製品が原因で、当該製品を使用した顧客がケガをして法律上の損害賠償責任を負うリスクに備えて、生産物賠償責任保険（PL保険）を契約した。",
        "choice2": "ボウリング場を経営する事業者が、施設の管理不備により、来場者がケガをして法律上の損害賠償責任を負うリスクに備えて、受託者賠償責任保険を契約した。",
        "choice3": "建設業を営む事業者が、従業員が業務中の事故によりケガをする場合に備えて、労働者災害補償保険（政府労災保険）の上乗せとして企業費用・利益総合保険を契約した。",
        "choice4": "事業用ビルの賃貸業を営む事業者が、賃貸ビルに設置した機械設備が火災により損害を被る場合に備えて、機械保険を契約した。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1021,
        "shikenId": 20,
        "parentNo": 1,
        "no": 21,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "銀行等の金融機関で取り扱う預貯金の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "決済用預金は、「無利息」 「要求払い」 「決済サービスを提供できること」という３つの条件を満たした預金である。",
        "choice2": "当座預金は、株式の配当金の自動受取口座として利用することができる。",
        "choice3": "スーパー定期預金は、預入期間が３年以上の場合、単利型と半年複利型があるが、半年複利型を利用することができるのは法人に限られる。",
        "choice4": "大口定期預金は、最低預入金額が1,000万円に設定された固定金利型の定期預金である。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1022,
        "shikenId": 20,
        "parentNo": 1,
        "no": 22,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "銀行等の金融機関で取り扱う預金の一般的な商品性等に関する次の記述のうち、最も不適切なものはどれか。なお、本問においては、「民間公益活動を促進するための休眠預金等に係る資金の活用に関する法律」を休眠預金等活用法という。",
        "choice1": "オプション取引などのデリバティブを組み込んだ仕組預金には、金融機関の判断によって満期日が繰り上がるものがある。",
        "choice2": "ゆうちょ銀行の預入限度額は、通常貯金と定期性貯金（財形貯金各種を除く）のそれぞれについて1,300万円となっている。",
        "choice3": "期日指定定期預金は、据置期間経過後から最長預入期日までの間で、金融機関が指定した日が満期日となる。",
        "choice4": "2009年１月１日以降、取引がないまま10年が経過した預金等は、休眠預金等活用法に基づく「休眠預金等」に該当する。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1023,
        "shikenId": 20,
        "parentNo": 1,
        "no": 23,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "株式投資信託の運用手法および運用スタイルに関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "株価が現在の資産価値や利益水準などから割安と評価される銘柄に投資する手法は、グロース投資と呼ばれる。",
        "choice2": "ベンチマークを上回る運用成果を目指す株式投資信託の運用手法は、パッシブ運用と呼ばれる。",
        "choice3": "「ブル型」 「ベア型」と呼ばれる特殊型の投資信託のうち、「ベア型」は、ベンチマークが上昇すると基準価額が上昇するように設計されている。",
        "choice4": "マクロ的な環境要因等を基に国別組入比率や業種別組入比率などを決定し、その比率に応じて、個別銘柄を組み入れてポートフォリオを構築する手法は、トップダウン・アプローチと呼ばれる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1024,
        "shikenId": 20,
        "parentNo": 1,
        "no": 24,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "固定利付国債の利回り（単利・年率）と市場金利の変動との関係を説明した次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、手数料、経過利子、税金等については考慮しないものとし、国債のイールドカーブは順イールド（期間が長いものほど利回りが高い）の状況にあるものとする。<br> <br><div class='b-box'> 表面利率が1.0％、償還期限が５年（満期一括償還）の固定利付国債を発行時に額面100円当たり100円で購入し、１年後に売却した。売却時の市場金利が購入時よりも上昇していた場合、通常、当該国債の額面100円当たりの売却価格は100円を（ ア ）、当該国債の購入時から売却時までの所有期間利回りは1.0％（ イ ）。</div>",
        "choice1": "（ア）上回り （イ）よりも高くなる",
        "choice2": "（ア）下回り （イ）で変わらない",
        "choice3": "（ア）上回り （イ）で変わらない",
        "choice4": "（ア）下回り （イ）よりも低くなる",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1025,
        "shikenId": 20,
        "parentNo": 1,
        "no": 25,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "下記〈Ｘ社のデータ〉に基づき算出される投資指標等に関する次の記述のうち、最も適切なものはどれか。<br> <br> 〈X社のデータ〉<br><img src='/img/1025_2.png' width='500'>",
        "choice1": "１株当たり当期純利益は、50円である。",
        "choice2": "ROE（自己資本当期純利益率）は、40.0％である。",
        "choice3": "PBR（株価純資産倍率）は、4.0倍である。",
        "choice4": "配当利回りは、7.5％である。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1026,
        "shikenId": 20,
        "parentNo": 1,
        "no": 26,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "株式の信用取引の一般的な仕組みに関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "信用取引では、現物株式を所有していない場合、その株式の「売り」から取引を開始することはできない。",
        "choice2": "制度信用取引の建株を一般信用取引の建株に変更することはできるが、一般信用取引の建株を制度信用取引の建株に変更することはできない。",
        "choice3": "信用取引では、売買が成立した後に相場が変動して証券会社が定める最低委託保証金維持率を下回った場合、追加保証金を差し入れるなどの方法により、委託保証金の不足を解消しなくてはならない。",
        "choice4": "金融商品取引法では、株式の信用取引を行う際の委託保証金の額は20万円以上であり、かつ、当該取引に係る株式の時価に100分の20を乗じた金額以上でなければならないとされている。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1027,
        "shikenId": 20,
        "parentNo": 1,
        "no": 27,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "金融派生商品に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "金融派生商品を利用する場合、現物取引を行った場合と同等の投資効果を得るには、現物取引よりも多額の資金を投入する必要がある。",
        "choice2": "現物価格の変動による利益と同額の利益が発生するように、現物と同じポジションの先物を保有することなどにより、価格変動リスク等を回避または軽減することを狙う取引を、ヘッジ取引という。",
        "choice3": "現物価格と当該現物を原資産とする先物の理論価格との間で価格差が生じた場合、割安な方を売り、割高な方を買うポジションを組み、その価格差を利益として得ることを狙う取引を、裁定取引という。",
        "choice4": "先物の将来の価格を予想してポジションを取り、予想どおりの方向に変動したときに反対売買を行って利益を確定することを狙う取引を、スペキュレーション取引という。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1028,
        "shikenId": 20,
        "parentNo": 1,
        "no": 28,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "下記〈資料〉に基づくファンドＡとファンドＢの過去３年間の運用パフォーマンスの比較評価に関する次の記述の空欄（ア）～（ウ）にあてはまる語句または数値の組み合わせとして、最も適切なものはどれか。<br> <br> 〈資料〉ファンドAとファンドBの過去３年間の運用パフォーマンスに関する情報<br><img src='/img/1028_2.png' width='500'><br> <br><div class='b-box'> 無リスク金利を1.0％として、〈資料〉の数値によりファンドＡのシャープレシオの値を算出すると（ ア ）となり、同様に算出したファンドＢのシャープレシオの値は（ イ ）となる。両ファンドの運用パフォーマンスを比較すると、過去３年間は（ ウ ）の方が効率的な運用であったと判断される。</div>",
        "choice1": "（ア）0.95 （イ）0.69 （ウ）ファンドＡ",
        "choice2": "（ア）0.95 （イ）0.69 （ウ）ファンドＢ",
        "choice3": "（ア）0.80 （イ）0.60 （ウ）ファンドＡ",
        "choice4": "（ア）0.80 （イ）0.60 （ウ）ファンドＢ",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1029,
        "shikenId": 20,
        "parentNo": 1,
        "no": 29,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "わが国における個人による金融商品取引に係るセーフティネットに関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "確定拠出年金の加入者が運用の方法として選択した定期預金は、加入者の預金として、預金保険制度による保護の対象となる。",
        "choice2": "日本国内で事業を行う生命保険会社が破綻した場合、生命保険契約者保護機構による補償の対象となる保険契約については、高予定利率契約を除き、原則として、破綻時点の責任準備金等の80％まで補償される。",
        "choice3": "証券会社が破綻し、分別管理が適切に行われていなかったために、一般顧客の資産の一部または全部が返還されない事態が生じた場合、日本投資者保護基金により、補償対象債権に係る顧客資産について一般顧客１人当たり1,000万円を上限として補償される。",
        "choice4": "銀行で購入した投資信託は、日本投資者保護基金による保護の対象とならない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1030,
        "shikenId": 20,
        "parentNo": 1,
        "no": 30,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "金融商品の取引等に係る各種法令に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、「金融サービスの提供及び利用環境の整備等に関する法律」を金融サービス提供法という。",
        "choice1": "金融サービス提供法において、金融サービス仲介業の登録を受けた事業者は、銀行業・金融商品取引業・保険業・貸金業に係る金融サービスのうち、顧客に対し高度に専門的な説明を必要とする金融サービスを仲介することが認められている。",
        "choice2": "金融商品取引法において、金融商品取引業者等が顧客と金融商品取引契約を締結するときは、原則として、契約後すみやかに重要事項を記載した契約締結前交付書面を交付することが義務付けられている。",
        "choice3": "大阪取引所における金、白金などのコモディティを対象とした市場デリバティブ取引は、金融商品取引法の適用対象とならない。",
        "choice4": "消費者契約法において、消費者が事業者の一定の行為により誤認または困惑し、それによって消費者契約の申込みまたは承諾の意思表示をしたときは、消費者はこれを取り消すことができるとされている。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1031,
        "shikenId": 20,
        "parentNo": 1,
        "no": 31,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税の基本的な仕組みに関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "所得税では、原則として、納税者本人の申告により納付すべき税額が確定し、この確定した税額を納付する申告納税制度が採用されている。",
        "choice2": "所得税の納税義務を負うのは居住者のみであり、非居住者が所得税の納税義務を負うことはない。",
        "choice3": "所得税では、課税対象となる所得を10種類に区分し、それぞれの所得の種類ごとに定められた計算方法により所得の金額を計算する。",
        "choice4": "所得税額の計算において課税総所得金額に乗じる税率は、課税総所得金額が大きくなるにつれて段階的に税率が高くなる超過累進税率が採用されている。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1032,
        "shikenId": 20,
        "parentNo": 1,
        "no": 32,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税における各種所得に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "老齢基礎年金の受給者の公的年金等に係る雑所得以外の所得に係る合計所得金額が1,000万円を超える場合、雑所得の金額の計算上、老齢基礎年金に係る収入金額から公的年金等控除額は控除されない。",
        "choice2": "不動産の貸付けをしたことに伴い敷金の名目により収受した金銭の額のうち、その全部または一部について、返還を要しないことが確定した金額は、その確定した日の属する年分の不動産所得の金額の計算上、総収入金額に算入する。",
        "choice3": "退職一時金を受け取った退職者が、「退職所得の受給に関する申告書」を提出していない場合、所得税および復興特別所得税として、退職一時金の支給額の20.42％が源泉徴収される。",
        "choice4": "為替予約を締結していない外貨定期預金を満期時に円貨で払い戻した結果生じた為替差益は、雑所得として総合課税の対象となる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1033,
        "shikenId": 20,
        "parentNo": 1,
        "no": 33,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税における各種所得の金額の計算上生じた次の損失の金額のうち、給与所得の金額と損益通算することができるものはどれか。",
        "choice1": "上場株式等に係る譲渡所得の金額の計算上生じた損失の金額",
        "choice2": "不動産所得の金額の計算上生じた損失の金額のうち、不動産所得を生ずべき業務の用に供する土地の取得に要した負債の利子の額に相当する部分の金額",
        "choice3": "公的年金等以外の雑所得の金額の計算上生じた損失の金額",
        "choice4": "物品販売業による事業所得の金額の計算上生じた損失の金額",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1034,
        "shikenId": 20,
        "parentNo": 1,
        "no": 34,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税における所得控除等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "控除対象扶養親族のうち、その年の12月31日時点の年齢が19歳以上23歳未満の者を特定扶養親族といい、その者に係る扶養控除の額は63万円である。",
        "choice2": "合計所得金額が900万円以下の納税者と生計を一にする配偶者（青色申告者の事業専従者として給与の支払いを受ける人および白色申告者の事業専従者である人を除く）の合計所得金額が58万円以下の場合、納税者が適用を受けることができる配偶者控除の額は38万円である。",
        "choice3": "納税者の合計所得金額が2,500万円を超える場合、基礎控除の額は58万円である。",
        "choice4": "給与所得控除額は、給与等の収入金額に応じて計算されるが、収入金額が850万円を超える場合は195万円となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1035,
        "shikenId": 20,
        "parentNo": 1,
        "no": 35,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税の青色申告に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "青色申告の適用を受けることができる者は、不動産所得、事業所得、山林所得を生ずべき業務を行う者で、納税地の所轄税務署長の承認を受けた者である。",
        "choice2": "前年からすでに業務を行っている者が、本年分から新たに青色申告の適用を受けようとする場合、その承認を受けようとする年の３月31日までに「青色申告承認申請書」を納税地の所轄税務署長に提出しなければならない。",
        "choice3": "青色申告を取りやめようとする者は、その年の翌年３月15日までに「青色申告の取りやめ届出書」を納税地の所轄税務署長に提出しなければならない。",
        "choice4": "前年からすでに業務を行っている者が、本年分から新たに青色申告の適用を受けるために青色申告の承認の申請を行ったが、その年の12月31日までに、その申請につき承認または却下の処分がなかったときは、その日において承認があったものとみなされる。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1036,
        "shikenId": 20,
        "parentNo": 1,
        "no": 36,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税における住宅借入金等特別控除（以下「住宅ローン控除」という）に関する次の記述のうち、最も適切なものはどれか。なお、記載されたもの以外の要件はすべて満たしているものとする。",
        "choice1": "住宅ローン控除の対象となる家屋は、納税者がもっぱら居住の用に供する家屋に限られ、店舗併用住宅は対象とならない。",
        "choice2": "住宅ローン控除の適用を受けるためには、その対象となる家屋を取得等した日から３ヵ月以内に自己の居住の用に供さなければならない。",
        "choice3": "給与所得者が住宅ローン控除の適用を受けようとする場合、最初の年分については年末調整の対象者であっても確定申告しなければならない。",
        "choice4": "住宅ローン控除の適用を受けていた者が、転勤等のやむを得ない事由により転居したため、取得した住宅を居住の用に供しなくなった場合、翌年以降はいかなる場合も当該住居に係る住宅ローン控除の適用は受けることができない。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1037,
        "shikenId": 20,
        "parentNo": 1,
        "no": 37,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "法人税の損金に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "2016年４月１日以後に取得した建物附属設備の減価償却方法は、定額法である。",
        "choice2": "役員退職給与を損金の額に算入するためには、所定の時期に確定額を支給する旨の定めの内容に関する届出書をあらかじめ税務署長に提出しなければならない。",
        "choice3": "参加者１人当たり10,000円以下の得意先との接待飲食費は、必要とされる書類を保存していれば、その２分の１の額を損金の額に算入することができる。",
        "choice4": "損金の額に算入される租税公課のうち、事業税については、原則として、その事業税に係る納税申告書を提出した日の属する事業年度の損金の額に算入することができない。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1038,
        "shikenId": 20,
        "parentNo": 1,
        "no": 38,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "消費税の簡易課税制度に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "簡易課税制度の適用を受けることができるのは、基準期間における課税売上高が１億円以下の事業者である。",
        "choice2": "新たに事業を開始した事業者は、事業を開始した日の属する課税期間内に、「消費税簡易課税制度選択届出書」を所轄税務署長に提出することで、当該課税期間から簡易課税制度の適用を受けることができる。",
        "choice3": "簡易課税制度を選択した事業者は、事業を廃止した場合を除き、原則として、５年間は簡易課税制度の適用を継続しなければならない。",
        "choice4": "簡易課税制度の選択を取りやめる場合、原則として、その適用を取りやめようとする課税期間の初日から３ヵ月以内に「消費税簡易課税制度選択不適用届出書」を所轄税務署長に提出しなければならない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1039,
        "shikenId": 20,
        "parentNo": 1,
        "no": 39,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "会社と役員間の取引に係る所得税・法人税に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "役員が会社に無利息で金銭の貸付けを行った場合、原則として、通常収受すべき利息に相当する金額が、その役員の雑所得の収入金額に算入される。",
        "choice2": "会社が所有する建物を適正な時価よりも高い価額で役員に譲渡した場合、その会社の所得の金額の計算上、適正な時価と譲渡対価の差額は、益金の額に算入される。",
        "choice3": "会社が役員の所有する土地を時価未満の価額で譲り受けた場合、時価と譲受対価の差額相当額は、その会社の所得金額の計算上、益金の額に算入される。",
        "choice4": "役員が会社の所有する社宅に無償で居住している場合、原則として、通常の賃料相当額が、その役員の給与所得の収入金額に算入される。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1040,
        "shikenId": 20,
        "parentNo": 1,
        "no": 40,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "決算書の分析に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "当座比率（％）は、「当座資産÷流動負債×100」の算式で計算される。",
        "choice2": "固定比率（％）は、「固定資産÷自己資本×100」の算式で計算される。",
        "choice3": "自己資本比率（％）は、「自己資本÷総資産×100」の算式で計算される。",
        "choice4": "流動比率（％）は、「流動資産÷総資産×100」の算式で計算される。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1041,
        "shikenId": 20,
        "parentNo": 1,
        "no": 41,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産鑑定評価基準における不動産の価格を求める鑑定評価の手法に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "収益還元法は、文化財の指定を受けた建造物等の一般的に市場性を有しない不動産や賃貸の用に供されていない自用の不動産の価格を求める際には、基本的に適用してはならないとされている。",
        "choice2": "収益還元法のうち直接還元法は、対象不動産の一期間の純収益を還元利回りで還元して対象不動産の価格を求める手法である。",
        "choice3": "原価法は、価格時点における対象不動産の再調達原価を求め、この再調達原価について増加修正を行って対象不動産の価格をもとめる手法である。",
        "choice4": "取引事例比較法では、取引事例の取引時点が価格時点と異なり、その間に価格水準の変動があると認められる場合であっても、当該取引事例の価格は取引時点の価格から修正する必要はないとされている。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1042,
        "shikenId": 20,
        "parentNo": 1,
        "no": 42,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "土地の価格に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "地価公示法による公示価格は、毎年１月１日を標準地の価格判定の基準日としている。",
        "choice2": "都道府県地価調査の基準地の標準価格は、毎年７月１日を価格判定の基準日としている。",
        "choice3": "固定資産税評価額は、原則として、市町村長が固定資産評価基準により決定する。",
        "choice4": "評価替えの基準年度における宅地の固定資産税評価額は、前年の地価公示法による公示価格等の80％を目途として評定されている。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1043,
        "shikenId": 20,
        "parentNo": 1,
        "no": 43,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "民法および借地借家法に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、借地借家法第38条における定期建物賃貸借契約を定期借家契約といい、それ以外の建物賃貸借契約を普通借家契約という。また、記載のない特約については考慮しないものとする。",
        "choice1": "賃借人は、建物の引渡しを受けた後の通常の使用および収益によって生じた建物の損耗ならびに経年変化については、賃貸借が終了したときに原状に復する義務を負わない。",
        "choice2": "普通借家契約において、賃借人が賃貸人の同意を得て建物に付加した造作について、賃貸借終了時、賃借人が賃貸人に、その買取りを請求しない旨の特約をした場合、その特約は無効である。",
        "choice3": "定期借家契約を締結するときは、賃貸人は、契約後すみやかに、賃借人に対し、契約の更新がなく、期間満了により賃貸借が終了することについて、その旨を記載した書面を交付し、または、賃借人の承諾を得て当該書面に記載すべき事項を電磁的方法により提供して、説明しなければならない。",
        "choice4": "定期借家契約において、経済事情の変動があっても賃貸借期間中は賃料を増減額しないこととする特約をした場合、その特約は無効である。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1044,
        "shikenId": 20,
        "parentNo": 1,
        "no": 44,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "借地借家法に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、借地借家法第38条における定期建物賃貸借契約を定期借家契約といい、それ以外の建物賃貸借契約を普通借家契約という。また、特約については考慮しないものとする。",
        "choice1": "普通借家契約において、建物の賃借人による建物の賃貸借の解約の申入れは、賃貸人および賃借人が建物の使用を必要とする事情や建物の利用状況などを考慮して、正当の事由があると認められる場合でなければすることができない。",
        "choice2": "定期借家契約は、建物の賃借人が建物の全部または一部を事業の用に供することを目的とする場合、公正証書によってしなければならない。",
        "choice3": "普通借家契約において、存続期間を１年未満とする建物の賃貸借は、期間の定めがない建物の賃貸借とみなされる。",
        "choice4": "定期借家契約は、契約の更新がなく、期間の満了により建物の賃貸借が終了し、再契約をすることはできない。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1045,
        "shikenId": 20,
        "parentNo": 1,
        "no": 45,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "都市計画法に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "都市計画区域内において、用途地域が定められている区域については、防火地域または準防火地域のいずれかを定めなければならない。",
        "choice2": "三大都市圏の一定の区域や一定の大都市の都市計画区域においては、都市計画に市街化区域と市街化調整区域との区分を定めるものとされている。",
        "choice3": "市街化区域および市街化調整区域については、原則として用途地域を定めるものとされている。",
        "choice4": "市街化区域は、すでに市街地を形成している区域およびおおむね５年以内に優先的かつ計画的に市街化を図るべき区域とされている。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1046,
        "shikenId": 20,
        "parentNo": 1,
        "no": 46,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "建物の区分所有等に関する法律に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "区分所有建物のうち、構造上の独立性と利用上の独立性を備えた部分は、区分所有権の目的となる専有部分の対象となり、規約により共用部分とすることはできない。",
        "choice2": "規約を変更するためには、区分所有者および議決権の各４分の３以上の多数による集会の決議が必要となる。",
        "choice3": "区分所有者は、敷地利用権が数人で有する所有権である場合、原則として、その有する専有部分とその専有部分に係る敷地利用権とを分離して処分することはできない。",
        "choice4": "区分所有者以外の専有部分の占有者は、建物またはその敷地もしくは附属施設の使用方法について、区分所有者が規約または集会の決議に基づいて負う義務と同一の義務を負う。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1047,
        "shikenId": 20,
        "parentNo": 1,
        "no": 47,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産の取得等に係る税金に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "所定の要件を満たす戸建て住宅（認定長期優良住宅を除く）を新築した場合、不動産取得税の課税標準の算定に当たっては、１戸につき最高1,200万円を価格から控除することができる。",
        "choice2": "不動産に抵当権設定登記をする際の登録免許税の課税標準は、債権金額（根抵当権の場合は極度金額）である。",
        "choice3": "土地の所有権を等価交換方式による全部譲渡により取得した場合は、原則として、取得者に対して不動産取得税は課されない。",
        "choice4": "不動産の所有権移転登記をする際の登録免許税の税率は、登記原因が贈与による場合の方が相続による場合に比べて高くなる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1048,
        "shikenId": 20,
        "parentNo": 1,
        "no": 48,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "個人が土地を譲渡した場合の譲渡所得に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "相続人が相続により取得した土地を譲渡した場合、その土地の所有期間を判定する際の取得の日は、相続人が当該相続を登記原因として所有権移転登記をした日である。",
        "choice2": "土地の譲渡が短期譲渡所得に区分される場合、課税短期譲渡所得に対して、原則として、所得税（復興特別所得税を含む）15.315％、住民税５％の税率により課税される。",
        "choice3": "土地を譲渡する際に支出した仲介手数料は、譲渡所得の金額の計算上、譲渡費用に含まれない。",
        "choice4": "譲渡所得の金額の計算上、譲渡した土地の取得費が不明な場合には、譲渡収入金額の５％相当額を取得費とすることができる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1049,
        "shikenId": 20,
        "parentNo": 1,
        "no": 49,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "居住用財産を譲渡した場合の3,000万円の特別控除（以下「3,000万円特別控除」という）および居住用財産を譲渡した場合の長期譲渡所得の課税の特例（以下「軽減税率の特例」という）に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "3,000万円特別控除は、居住用財産で居住の用に供さなくなったものを譲渡する場合、居住の用に供さなくなった日から３年を経過した日の属する年の12月31日までに譲渡しなければ、適用を受けることができない。",
        "choice2": "軽減税率の特例は、譲渡した日の属する年の１月１日における居住用財産の所有期間が20年を超えていなければ、適用を受けることができない。",
        "choice3": "3,000万円特別控除は、居住用財産を配偶者に譲渡した場合には適用を受けることができない。",
        "choice4": "3,000万円特別控除と軽減税率の特例は、同一の居住用財産の譲渡について、重複して適用を受けることができる。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1050,
        "shikenId": 20,
        "parentNo": 1,
        "no": 50,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産の有効活用の手法の一般的な特徴に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "等価交換方式における全部譲渡方式は、土地所有者がいったん土地の全部をデベロッパーに譲渡し、その対価としてその土地上にデベロッパーが建設した建物およびその土地の一部を譲り受ける方式である。",
        "choice2": "建設協力金方式は、土地所有者が、建設する建物を貸し付ける予定のテナント等に建設資金の全部または一部を貸し付け、当該テナント等がビルや店舗等を建設する方式である。",
        "choice3": "定期借地権方式では、土地所有者が自己の土地上に建設される建物の所有名義人となり、当該土地と建物を一定期間貸し付けることにより地代・賃料収入を得ることができる。",
        "choice4": "事業受託方式は、土地の有効活用の企画、建設会社の選定、建設資金の調達等をデベロッパーに任せ、当該土地上に建設された建物の管理・運営等は土地所有者が行う方式である。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1051,
        "shikenId": 20,
        "parentNo": 1,
        "no": 51,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "民法上の贈与に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "書面によらない贈与は、その履行の終わった部分については、各当事者が解除をすることができない。",
        "choice2": "定期贈与とは、贈与者が受贈者に対して定期的に財産を給付することを目的とする贈与をいい、贈与者または受贈者のいずれか一方の死亡によって、その効力を失う。",
        "choice3": "死因贈与では、民法の遺贈に関する規定が準用され、贈与者のみの意思表示により成立し、贈与者の死亡によって効力が生じる。",
        "choice4": "負担付贈与では、受贈者がその負担である義務を履行しない場合において、贈与者が相当の期間を定めてその履行の催告をし、その期間内に履行がない場合、原則として、贈与者は、当該贈与の契約の解除をすることができる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1052,
        "shikenId": 20,
        "parentNo": 1,
        "no": 52,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "相続人が次の（ア）～（ウ）である場合、民法上、それぞれの場合における被相続人の配偶者の法定相続分の組み合わせとして、最も適切なものはどれか。<br> <br> （ア）被相続人の配偶者および子の合計２人<br> （イ）被相続人の配偶者および母の合計２人<br> （ウ）被相続人の配偶者および兄の合計２人",
        "choice1": "（ア）１／２（イ）１／３（ウ）１／４",
        "choice2": "（ア）１／２（イ）２／３（ウ）３／４",
        "choice3": "（ア）３／４（イ）２／３（ウ）１／２",
        "choice4": "（ア）１／３（イ）２／３（ウ）３／４",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1053,
        "shikenId": 20,
        "parentNo": 1,
        "no": 53,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "贈与税の申告と納付に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "国税電子申告・納税システム（e-Tax）は、贈与税の申告には対応していない。",
        "choice2": "贈与税の申告書は、原則として、贈与を受けた年の翌年２月１日から３月15日までの間に、受贈者の納税地の所轄税務署長に提出しなければならない。",
        "choice3": "贈与税を納期限までに納付することが困難である場合、その納付を困難とする金額を限度として延納を申請することができる。",
        "choice4": "贈与税の納付について認められる延納期間は、最長５年である。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1054,
        "shikenId": 20,
        "parentNo": 1,
        "no": 54,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "民法上の相続人等に関する次の記述のうち、最も不適切なものはどれか。なお、記載のない事項については考慮しないものとする。",
        "choice1": "特別養子縁組による養子は、実方の父母の相続人とならない。",
        "choice2": "被相続人の子が廃除により相続権を失った場合、その者に被相続人の直系卑属である子がいるときは、その子（被相続人の孫）は代襲相続人となる。",
        "choice3": "離婚した元配偶者との間に出生した被相続人の子が当該元配偶者の親権に服している場合、その子は相続人とならない。",
        "choice4": "被相続人と婚姻の届出をしておらず、被相続人といわゆる内縁関係にあった者は、被相続人の配偶者とはみなされず相続人とならない。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1055,
        "shikenId": 20,
        "parentNo": 1,
        "no": 55,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "民法に規定する相続の承認および放棄に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "被相続人の子が相続の放棄をした場合、その相続の放棄をした者の子（被相続人の孫）は、代襲相続人とならない。",
        "choice2": "契約者（＝保険料負担者）および被保険者を被相続人とする生命保険契約の死亡保険金受取人に指定されていた相続人が、被相続人の死亡により死亡保険金を受け取った場合、その相続について単純承認をしたものとみなされる。",
        "choice3": "単純承認とは、相続人が受け継いだ資産（積極財産）の範囲内で負債（消極財産）を支払い、積極財産を超える消極財産については責任を負わないという相続の方法をいう。",
        "choice4": "相続の放棄をしようとする者は、原則として、相続の開始があったことを知った時から１カ月以内に、家庭裁判所に相続の放棄をする旨を申述しなければならない。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1056,
        "shikenId": 20,
        "parentNo": 1,
        "no": 56,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "相続税における宅地の評価に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "二方面に路線がある角地を路線価方式によって評価する場合、それぞれの路線価に奥行価格補正率を乗じた価額を比較し、高い方の路線価が正面路線価となる。",
        "choice2": "宅地の価額は、その宅地が登記上は２筆の宅地であっても一体として利用している場合は、その２筆の宅地全体を１画地として評価する。",
        "choice3": "宅地の評価方法には、路線価方式と倍率方式とがあり、いずれを採用するかについては、宅地の所在地により各国税局長が指定している。",
        "choice4": "倍率方式によって評価する宅地が不整形地である場合の価額は、原則として、その宅地の固定資産税評価額に一定倍率を乗じた価額に宅地の形状に応じた補正率を乗じて算出する。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1057,
        "shikenId": 20,
        "parentNo": 1,
        "no": 57,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "小規模宅地等についての相続税の課税価格の計算の特例に関する次の空欄（ア）～（エ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、宅地等の適用面積の調整は考慮しないものとする。<br> <br><img src='/img/1058_2.png' width='600'>",
        "choice1": "（ア）50％ （イ）330㎡ （ウ）400㎡ （エ）50％",
        "choice2": "（ア）50％ （イ）400㎡ （ウ）200㎡ （エ）80％",
        "choice3": "（ア）80％ （イ）330㎡ （ウ）400㎡ （エ）50％",
        "choice4": "（ア）80％ （イ）400㎡ （ウ）200㎡ （エ）80％",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1058,
        "shikenId": 20,
        "parentNo": 1,
        "no": 58,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "直系尊属から住宅取得等資金の贈与を受けた場合の贈与税の非課税の特例（以下「本特例」という）に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "受贈者の配偶者の父母（義父母）から住宅取得資金の贈与を受けた場合、本特例の適用を受けることができる。",
        "choice2": "住宅取得資金の贈与者が死亡した場合において、その相続人が贈与を受けた住宅取得資金のうち、本特例の適用を受けて贈与税が非課税とされた金額については、その贈与が暦年課税または相続時精算課税制度のいずれの適用を受けていたとしても、相続税の課税価格に加算されない。",
        "choice3": "受贈者が自己の居住の用に供する家屋とともにその敷地の用に供される土地を取得する場合において、その土地の取得の対価に充てるための金銭については、本特例の適用を受けることができない。",
        "choice4": "新築した家屋が店舗併用住宅である場合、その家屋の新築の対価に充てるための金銭については、本特例の適用を受けることができない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1059,
        "shikenId": 20,
        "parentNo": 1,
        "no": 59,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "Ａさんの相続が開始した場合の相続税額の計算における土地の評価に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "Ａさんが、自己が所有する土地の上に自宅を建築して居住していた場合、この土地は自用地として評価する。",
        "choice2": "Ａさんが、自己が所有する土地に建物の所有を目的とする賃借権を設定し、借地人がこの土地の上に自宅を建築して居住していた場合、この土地は貸宅地として評価する。",
        "choice3": "Ａさんの子が、Ａさんが所有する土地を使用貸借で借り受け、自宅を建築して居住していた場合、この土地は貸宅地として評価する。",
        "choice4": "Ａさんが、自己が所有する土地の上に店舗用建物を建築し、当該建物を第三者に賃貸していた場合、この土地は貸家建付地として評価する。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1060,
        "shikenId": 20,
        "parentNo": 1,
        "no": 60,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "法人成り等に関する次の記述の空欄（ア）～（ウ）にあてはまる数値の組み合わせとして、最も適切なものはどれか。<br> <br><div class='b-box'> 個人事業の場合、通常、利益は事業所得として他の所得と合算されて最高（ ア ）％の超過累進税率による所得税の課税対象となるが、個人事業の法人成りにより、法人に課される法人税は、原則として、比例税率となる。なお、資本金の額が１億円以下の法人（適用除外事業者を除く）に対する法人税の税率は、軽減措置が適用される。年800万円以下の所得金額からなる部分の金額については原則として（ イ ）％とされ（その事業年度の所得金額が10億円を超える場合を除く）、年800万円超の所得金額からなる部分の金額については（ ウ ）％とされる。</div>",
        "choice1": "（ア）50（イ）19.0（ウ）15.0",
        "choice2": "（ア）50（イ）15.0（ウ）19.0",
        "choice3": "（ア）45（イ）23.2（ウ）15.0",
        "choice4": "（ア）45（イ）15.0（ウ）23.2",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1061,
        "shikenId": 20,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 2,
        "inputType": 7,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、遺族基礎年金について説明した。Ｍさんが説明した以下の文章の空欄①〜④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/25a_1061_2.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ハ,ト,ホ,ル",
        "score": "1,1,1,1",
        "image": "25a_1061.png"
    },
    {
        "id": 1062,
        "shikenId": 20,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、遺族厚生年金について説明した。Ｍさんが説明した以下の文章の空欄①〜③に入る最も適切な数値を入力しなさい。なお、年金額は2025年度価額に基づいて計算し、年金額の端数処理は円未満を四捨五入すること。<br><br><img class='question-img' src='/img/question/25a_1062_2.png'>",
        "choice1": "月",
        "choice2": "円",
        "choice3": "歳",
        "choice4": "",
        "choice5": "",
        "answer": "300,551791,65",
        "score": "1,1,1",
        "image": "25a_1061.png"
    },
    {
        "id": 1063,
        "shikenId": 20,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、公的介護保険（以下、「介護保険」という）の保険給付等について説明した。Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/25a_1063_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1",
        "score": "1,1,1",
        "image": "25a_1061.png"
    },
    {
        "id": 1064,
        "shikenId": 20,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "《設例》のデータに基づいて算出される次の①、②を求めなさい。〈答〉は表示単位の小数点以下第 ３ 位を四捨五入し、小数点以下第 ２ 位までを解答すること。<br><br>① Ｘ社のＲＯＥ<br>② Ｘ社のＰＢＲ",
        "choice1": "％",
        "choice2": "倍",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "4.44,1.11",
        "score": "2,2",
        "image": "25a_1064.png"
    },
    {
        "id": 1065,
        "shikenId": 20,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、《設例》のデータに基づいて、株式の投資指標等について説明した。Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/25a_1065_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,1,2",
        "score": "1,1,1",
        "image": "25a_1064.png"
    },
    {
        "id": 1066,
        "shikenId": 20,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、2024年から始まった新しいNISAについて説明した。Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/25a_1066_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2",
        "score": "1,1,1",
        "image": "25a_1064.png"
    },
    {
        "id": 1067,
        "shikenId": 20,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "ＡさんがＸ社から受け取った退職金に係る退職所得の金額を計算した下記の計算式の空欄①〜③に入る最も適切な数値を入力しなさい。なお、Ａさんは、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。また、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/25a_1067_2.png'>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "answer": "800,2060,470",
        "score": "1,1,1",
        "image": "25a_1067.png"
    },
    {
        "id": 1068,
        "shikenId": 20,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "Ａさんの2025年分の所得金額について、次の①、②を求めなさい。なお、総所得金額の計算上、Ａさんが所得金額調整控除の適用対象者に該当している場合、所得金額調整控除額を控除すること。また、〈答〉は万円単位とすること。<br><br>① 総所得金額に算入される一時所得の金額<br>② 総所得金額<br><br><img class='question-img' src='/img/question/25a_1068_2.png'>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "50,540",
        "score": "2,2",
        "image": "25a_1067.png"
    },
    {
        "id": 1069,
        "shikenId": 20,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税における所得控除に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br>① 「Ａさんが適用を受けることができる配偶者控除の額は、48万円です」<br>② 「Ａさんが適用を受けることができる長男Ｃさんに係る扶養控除の額は、63万円です」<br>③ 「Ａさんが適用を受けることができる母Ｄさんに係る扶養控除の額は、38万円です」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2",
        "score": "1,1,1",
        "image": "25a_1067.png"
    },
    {
        "id": 1070,
        "shikenId": 20,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "甲土地に準耐火建築物を建築する場合における次の①、②を求めなさい。<br><br>① 建蔽率の上限となる建築面積<br>② 容積率の上限となる延べ面積",
        "choice1": "㎡",
        "choice2": "㎡",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "320,1200",
        "score": "2,2",
        "image": "25a_1070.png"
    },
    {
        "id": 1071,
        "shikenId": 20,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "自己建設方式による甲土地の有効活用に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/25a_1071_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,2",
        "score": "1,1,1",
        "image": "25a_1070.png"
    },
    {
        "id": 1072,
        "shikenId": 20,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんが甲土地に自己建設方式によって賃貸マンションを建築した場合における賃貸事業開始後の相続税評価額に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/25a_1072_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1",
        "score": "1,1,1",
        "image": "25a_1070.png"
    },
    {
        "id": 1073,
        "shikenId": 20,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 2,
        "inputType": 7,
        "question1": "",
        "question2": "Ａさんの相続等に関する以下の文章の空欄①〜③に入る最も適切な語句を、下記の〈語句群〉のイ〜ヌのなかから選び、その記号を答えなさい。<br><br><img class='question-img' src='/img/question/25a_1073_2.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "イ,リ,ホ",
        "score": "1,1,1",
        "image": "25a_1073.png"
    },
    {
        "id": 1074,
        "shikenId": 20,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "生前贈与に関する次の記述①〜④について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/25a_1074_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2,1",
        "score": "1,1,1,1",
        "image": "25a_1073.png"
    },
    {
        "id": 1075,
        "shikenId": 20,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "現時点（2025年10月 １ 日）において、Ａさんに相続が開始した場合における相続税の総額を試算した下記の表の空欄①〜③に入る最も適切な数値を求めなさい。なお、相続税の課税価格の合計額は １ 億6, 000万円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/25a_1075_2.png'>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "answer": "4200,1070,2140",
        "score": "1,1,1",
        "image": "25a_1073.png"
    },
    {
        "id": 1076,
        "shikenId": 20,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "Ａさんが、原則として、65歳から受給することができる老齢基礎年金および老齢厚生年金の年金額（2025年度価額）を計算した次の〈計算の手順〉の空欄①〜④に入る最も適切な数値を入力しなさい。計算にあたっては、《設例》の〈Ａさんとその家族に関する資料〉および下記の〈資料〉に基づくこと。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/25a_1076_2.png'>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "",
        "answer": "774521,1113710,577,1114287",
        "score": "1,1,1,1",
        "image": "25a_1076.png"
    },
    {
        "id": 1077,
        "shikenId": 20,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさん夫婦に対して、公的年金制度からの老齢給付について説明した。Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/25a_1077_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,2",
        "score": "1,1,1",
        "image": "25a_1076.png"
    },
    {
        "id": 1078,
        "shikenId": 20,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、定年退職後の社会保険の各種取扱い等について説明した。Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/25a_1078_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2",
        "score": "1,1,1",
        "image": "25a_1076.png"
    },
    {
        "id": 1079,
        "shikenId": 20,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、下記の〈前提〉においてＡさんが死亡した場合、妻Ｂさんが受給することができる公的年金制度からの遺族給付について説明した。Ｍさんが説明した以下の文章の空欄①〜③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br><img class='question-img' src='/img/question/25a_1079_2.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ロ,ヘ,リ",
        "score": "1,1,1",
        "image": "25a_1079.png"
    },
    {
        "id": 1080,
        "shikenId": 20,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、必要保障額およびＡさんが提案を受けた生命保険の死亡保障の額について説明した。Ｍさんが説明した以下の文章の空欄①、②に入る最も適切な数値を入力しなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/25a_1080_2.png'>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "4524,5000",
        "score": "2,1",
        "image": "25a_1079.png"
    },
    {
        "id": 1081,
        "shikenId": 20,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、Ａさんが提案を受けた生命保険の保障内容および課税関係について説明した。Ｍさんが説明した次の記述①〜④について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/25a_1081_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2,1",
        "score": "1,1,1,1",
        "image": "25a_1079.png"
    },
    {
        "id": 1082,
        "shikenId": 20,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "仮に、Ｘ社がＡさんに役員退職金6, 500万円を支給した場合、Ａさんが受け取る役員退職金について、次の①、②を答えなさい。〈答〉は万円単位とすること。なお、Ａさんの役員在任期間（勤続年数）を39年 ９ カ月とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。<br><br>① 退職所得控除額<br>② 退職所得の金額",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2200,2150",
        "score": "1,2",
        "image": "25a_1082.png"
    },
    {
        "id": 1083,
        "shikenId": 20,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、《設例》の〈資料 １ 〉の無配当逓増定期保険について説明した。Ｍさんが説明した次の記述①〜④について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/25a_1083_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2,2",
        "score": "1,1,1,1",
        "image": "25a_1082.png"
    },
    {
        "id": 1084,
        "shikenId": 20,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、長男Ｂさんに対して、《設例》の〈資料 ２ 〉の無配当低解約返戻金型終身保険について説明した。Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br><img class='question-img' src='/img/question/25a_1084_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,2",
        "score": "1,1,1",
        "image": "25a_1082.png"
    },
    {
        "id": 1085,
        "shikenId": 20,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税の課税に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/25a_1085_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1",
        "score": "1,1,1",
        "image": "25a_1085.png"
    },
    {
        "id": 1086,
        "shikenId": 20,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税における配偶者控除に関する以下の文章の空欄①〜③に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を答えなさい。<br><br><img class='question-img' src='/img/question/25a_1086_2.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ト,イ,チ",
        "score": "1,1,1",
        "image": "25a_1085.png"
    },
    {
        "id": 1087,
        "shikenId": 20,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税の算出税額を計算した下記の表の空欄①〜④に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/25a_1087_2.png'>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "",
        "answer": "8000000,380000,580000,532500",
        "score": "1,1,1,1",
        "image": "25a_1085.png"
    },
    {
        "id": 1088,
        "shikenId": 20,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "Ｘ社株式に関する以下の文章の空欄①〜③に入る最も適切な語句を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br><img class='question-img' src='/img/question/25a_1088_2.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ニ,ト,チ",
        "score": "1,1,1",
        "image": "25a_1088.png"
    },
    {
        "id": 1089,
        "shikenId": 20,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんの相続等に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/25a_1089_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2",
        "score": "1,1,1",
        "image": "25a_1088.png"
    },
    {
        "id": 1090,
        "shikenId": 20,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "現時点（2025年 ７ 月 １ 日）において、Ａさんの相続が開始した場合における相続税の総額を試算した下記の表の空欄①〜④に入る最も適切な数値を求めなさい。なお、相続税の課税価格の合計額は ４ 億2, 000万円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/25a_1090_2.png'>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "万円",
        "choice5": "",
        "answer": "4800,5740,2090,9920",
        "score": "1,1,1,1",
        "image": "25a_1088.png"
    },
    {
        "id": 1100,
        "shikenId": 20,
        "parentNo": 2,
        "no": 1,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25a_fp2/1.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,2,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1101,
        "shikenId": 20,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25a_fp2/2.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "2",
        "image": ""
    },
    {
        "id": 1102,
        "shikenId": 20,
        "parentNo": 2,
        "no": 3,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25a_fp2/3.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "900,270",
        "score": "1,1",
        "image": ""
    },
    {
        "id": 1103,
        "shikenId": 20,
        "parentNo": 2,
        "no": 4,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25a_fp2/4.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "24000",
        "score": "2",
        "image": ""
    },
    {
        "id": 1104,
        "shikenId": 20,
        "parentNo": 2,
        "no": 5,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25a_fp2/5.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "%",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "0.533",
        "score": "2",
        "image": ""
    },
    {
        "id": 1105,
        "shikenId": 20,
        "parentNo": 1,
        "no": 6,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25a_fp2/6.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "2",
        "image": ""
    },
    {
        "id": 1106,
        "shikenId": 20,
        "parentNo": 2,
        "no": 7,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25a_fp2/7.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,2,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1107,
        "shikenId": 20,
        "parentNo": 2,
        "no": 8,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25a_fp2/8.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1108,
        "shikenId": 20,
        "parentNo": 2,
        "no": 9,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25a_fp2/9.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "㎡",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "110.4",
        "score": "2",
        "image": ""
    },
    {
        "id": 1109,
        "shikenId": 20,
        "parentNo": 1,
        "no": 10,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25a_fp2/10.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "2",
        "image": ""
    },
    {
        "id": 1110,
        "shikenId": 20,
        "parentNo": 1,
        "no": 11,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25a_fp2/11.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "2",
        "image": ""
    },
    {
        "id": 1111,
        "shikenId": 20,
        "parentNo": 1,
        "no": 12,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25a_fp2/12.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "2",
        "image": ""
    },
    {
        "id": 1112,
        "shikenId": 20,
        "parentNo": 1,
        "no": 13,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25a_fp2/13.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "2",
        "image": ""
    },
    {
        "id": 1113,
        "shikenId": 20,
        "parentNo": 1,
        "no": 14,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25a_fp2/14.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "2",
        "image": ""
    },
    {
        "id": 1114,
        "shikenId": 20,
        "parentNo": 2,
        "no": 15,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25a_fp2/15.png\" class=\"question-img\" /><br><br><img src=\"/img/question/25a_fp2/16.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "answer": "11,1266,4310",
        "score": "1,1,1",
        "image": ""
    },
    {
        "id": 1115,
        "shikenId": 20,
        "parentNo": 2,
        "no": 16,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25a_fp2/17.png\" class=\"question-img\" /><br><br><img src=\"/img/question/25a_fp2/18.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "answer": "110,218,10",
        "score": "1,1,1",
        "image": ""
    },
    {
        "id": 1116,
        "shikenId": 20,
        "parentNo": 2,
        "no": 17,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25a_fp2/19.png\" class=\"question-img\" /><br><br><img src=\"/img/question/25a_fp2/20.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,1,1,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1117,
        "shikenId": 20,
        "parentNo": 1,
        "no": 18,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25a_fp2/21.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "1",
        "score": "2",
        "image": ""
    },
    {
        "id": 1118,
        "shikenId": 20,
        "parentNo": 1,
        "no": 19,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25a_fp2/22.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "2",
        "image": ""
    },
    {
        "id": 1119,
        "shikenId": 20,
        "parentNo": 2,
        "no": 20,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25a_fp2/23.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "68",
        "score": "2",
        "image": ""
    },
    {
        "id": 1120,
        "shikenId": 20,
        "parentNo": 2,
        "no": 21,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25a_fp2/24.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1121,
        "shikenId": 20,
        "parentNo": 2,
        "no": 22,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25a_fp2/25.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2840",
        "score": "1",
        "image": ""
    },
    {
        "id": 1122,
        "shikenId": 20,
        "parentNo": 2,
        "no": 23,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25a_fp2/26.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "227",
        "score": "2",
        "image": ""
    },
    {
        "id": 1123,
        "shikenId": 20,
        "parentNo": 2,
        "no": 24,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25a_fp2/27.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,1,2,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1124,
        "shikenId": 20,
        "parentNo": 1,
        "no": 25,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25a_fp2/28.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "2",
        "image": ""
    },
    {
        "id": 1125,
        "shikenId": 20,
        "parentNo": 1,
        "no": 26,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25a_fp2/29.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "2",
        "image": ""
    },
    {
        "id": 1126,
        "shikenId": 20,
        "parentNo": 1,
        "no": 27,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25a_fp2/30.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "2",
        "image": ""
    },
    {
        "id": 1127,
        "shikenId": 20,
        "parentNo": 2,
        "no": 28,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25a_fp2/31.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "446",
        "score": "2",
        "image": ""
    },
    {
        "id": 1128,
        "shikenId": 20,
        "parentNo": 2,
        "no": 29,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25a_fp2/32.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2474",
        "score": "2",
        "image": ""
    },
    {
        "id": 1129,
        "shikenId": 20,
        "parentNo": 2,
        "no": 30,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25a_fp2/33.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1130,
        "shikenId": 20,
        "parentNo": 2,
        "no": 31,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25a_fp2/34.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "3315000",
        "score": "1",
        "image": ""
    },
    {
        "id": 1131,
        "shikenId": 20,
        "parentNo": 2,
        "no": 32,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25a_fp2/35.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "28413000",
        "score": "1",
        "image": ""
    },
    {
        "id": 1132,
        "shikenId": 20,
        "parentNo": 2,
        "no": 33,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25a_fp2/36.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1152000",
        "score": "2",
        "image": ""
    },
    {
        "id": 1133,
        "shikenId": 20,
        "parentNo": 2,
        "no": 34,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25a_fp2/37.png\" class=\"question-img\" /><br><br><img src=\"/img/question/25a_fp2/38.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "6120",
        "score": "2",
        "image": ""
    },
    {
        "id": 1134,
        "shikenId": 20,
        "parentNo": 1,
        "no": 35,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25a_fp2/39.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "2",
        "image": ""
    },
    {
        "id": 1135,
        "shikenId": 20,
        "parentNo": 2,
        "no": 36,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25a_fp2/40.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1",
        "score": "1,1,1",
        "image": ""
    },
    {
        "id": 1136,
        "shikenId": 20,
        "parentNo": 2,
        "no": 37,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25a_fp2/41.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1137,
        "shikenId": 20,
        "parentNo": 1,
        "no": 38,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25a_fp2/42.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "2",
        "image": ""
    },
    {
        "id": 1138,
        "shikenId": 20,
        "parentNo": 2,
        "no": 39,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25a_fp2/43.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1139,
        "shikenId": 20,
        "parentNo": 2,
        "no": 40,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25a_fp2/44.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1140,
        "shikenId": 21,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "ファイナンシャル・プランナー（以下「ＦＰ」という）の顧客に対する行為に関する次の記述のうち、関連法規に照らし、最も不適切なものはどれか。",
        "choice1": "税理士の登録を受けていないＦＰのＡさんは、顧客から「直系尊属から教育資金の一括贈与を受けた場合の贈与税の非課税」について相談を受け、関連法令の条文を示しながら、制度の概要を無償で説明した。",
        "choice2": "弁護士の登録を受けていないＦＰのＢさんは、顧客から配偶者居住権について相談を受け、関連法令の条文を示しながら、制度の概要を無償で説明した。",
        "choice3": "金融商品取引業の登録を受けていないＦＰのＣさんは、投資一任契約に基づき、顧客から株式投資に関する必要な権限を有償で委任され、当該顧客の資金を預かって値上がりが期待できる株式の個別銘柄への投資を行った。",
        "choice4": "生命保険募集人の登録を受けていないＦＰのＤさんは、ライフプランの相談に来た顧客に対して、生命保険の一般的な商品内容や目的別の活用方法を有償で説明した。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1141,
        "shikenId": 21,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "雇用保険法に基づく育児休業給付および介護休業給付に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "介護休業給付金は、同一の対象家族について介護休業を分割して取得する場合、休業開始日から休業日数が通算して93日に達するまでに５回を限度として支給される。",
        "choice2": "一般被保険者の配偶者の父母は、介護休業給付金の支給対象となる家族に該当する。",
        "choice3": "育児休業給付金の支給額は、１支給単位期間について、休業開始日から休業日数が通算して300日に達するまでの間は、原則として、休業開始時賃金日額に支給日数を乗じて得た額の67％相当額である。",
        "choice4": "育児休業給付金は、一般被保険者の休業開始日前１年間に、みなし被保険者期間が通算して６ヵ月以上なければ支給されない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1142,
        "shikenId": 21,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "公的医療保険に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "全国健康保険協会管掌健康保険（協会けんぽ）の一般保険料率は、都道府県ごとに算定され、保険料は、原則として、労使で折半して負担する。",
        "choice2": "自営業者や農林漁業従事者などが被保険者となる国民健康保険は、国が保険者として運営している。",
        "choice3": "退職により健康保険の被保険者資格を喪失した者が、健康保険の任意継続被保険者になるためには、資格喪失日の前日まで継続して１年以上の被保険者期間がなければならない。",
        "choice4": "健康保険や国民健康保険の被保険者は、原則として、70歳に達したときに、その被保険者資格を喪失して後期高齢者医療制度の被保険者となる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1143,
        "shikenId": 21,
        "parentNo": 1,
        "no": 4,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "老齢厚生年金の繰下げ支給に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "老齢厚生年金の受給権者が、老齢厚生年金の繰下げ支給の申出をする場合、老齢基礎年金の繰下げ支給の申出を同時に行わなければならない。",
        "choice2": "老齢厚生年金の受給権者が、老齢厚生年金の受給権を取得したときに遺族厚生年金の受給権者であった場合、老齢厚生年金の繰下げ支給の申出をすることができない。",
        "choice3": "老齢厚生年金の繰下げ支給による年金の増額率は、繰り下げた月数に0.5％を乗じて得た率である。",
        "choice4": "加給年金額が加算される老齢厚生年金について繰下げ支給の申出をする場合、加給年金額についても繰下げ支給による増額の対象となる。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1144,
        "shikenId": 21,
        "parentNo": 1,
        "no": 5,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "公的年金に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "厚生年金保険の被保険者である夫が死亡し、子のない30歳未満の妻が遺族厚生年金の受給権を取得した場合、その妻に対する遺族厚生年金の支給期間は、最長で５年間である。",
        "choice2": "障害等級１級または２級に該当する程度の障害の状態にある障害厚生年金の受給権者が、18歳未満の子を有する場合、その受給権者には子の加算額が加算された障害厚生年金が支給される。",
        "choice3": "国民年金の保険料納付済期間が10年以上あり、厚生年金保険の被保険者期間を有する者は、原則として、65歳から老齢基礎年金および老齢厚生年金を受給することができる。",
        "choice4": "学生納付特例の承認を受けた期間に係る国民年金保険料のうち、追納することができる保険料は、追納に係る厚生労働大臣の承認を受けた日の属する月前10年以内の期間に係るものに限られる。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1145,
        "shikenId": 21,
        "parentNo": 1,
        "no": 6,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "確定拠出年金に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "企業型年金や確定給付企業年金等を実施していない一定規模以下の中小企業の事業主は、労使の合意かつ従業員の同意を基に、従業員が加入している個人型年金の加入者掛金に事業主掛金を上乗せして納付することができる。",
        "choice2": "個人型年金に加入できるのは、国内に居住する国民年金の被保険者に限られる。",
        "choice3": "個人型年金の加入者が60歳から老齢給付金を受給するためには、通算加入者等期間が10年以上なければならない。",
        "choice4": "企業型年金において、加入者が掛金を拠出することができることを規約で定める場合、加入者掛金の額は、その加入者に係る事業主掛金の額を超える額とすることができない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1146,
        "shikenId": 21,
        "parentNo": 1,
        "no": 7,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "公的年金の障害給付に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "同一の事由により、労働者災害補償保険の障害補償年金と障害基礎年金および障害厚生年金が支給される場合、障害基礎年金および障害厚生年金は、所定の割合で減額されて支給される。",
        "choice2": "障害基礎年金の受給権者が新たに所定の要件を満たす子を有するに至った場合、所定の手続きにより、その子を有するに至った日の属する月の翌月から、その子に係る加算額が加算された障害基礎年金が支給される。",
        "choice3": "厚生年金保険の被保険者が病気により障害を負い、その障害の状態が障害認定日においては所定の障害等級に該当していなかったものの、その後病状が悪化して、所定の障害等級に該当するに至った場合、65歳に達する日の前日までに請求することにより、原則として、障害厚生年金の支給を受けることができる。",
        "choice4": "障害厚生年金の額の計算上、その計算の基礎となる被保険者期間の月数が300月に満たない場合、300月として計算する。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1147,
        "shikenId": 21,
        "parentNo": 1,
        "no": 8,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "国民年金基金、小規模企業共済および中小企業退職金共済に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "小規模企業共済では、共済契約の解約時における掛金納付月数が12カ月未満である場合、解約事由にかかわらず、解約手当金は支給されない。",
        "choice2": "中小企業退職金共済の掛金は、事業主と従業員の合意に基づき、事業主と従業員が折半して負担することができる。",
        "choice3": "国民年金基金の掛金月額は、選択した給付の型および加入口数に応じて決まり、加入時の年齢や性別による差異はない。",
        "choice4": "小規模企業共済の掛金は、確定拠出年金の個人型年金の掛金との合計で、月額68,000円が限度とされている。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1148,
        "shikenId": 21,
        "parentNo": 1,
        "no": 9,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "リタイアメントプランニング等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "将来、本人の判断能力が不十分になった場合に備えて、あらかじめ本人が選任した者と締結する任意後見契約は、所定の様式の公正証書によってしなければならない。",
        "choice2": "金融機関のリバースモーゲージは、通常、利用者が自宅に住み続けながらその不動産を担保に資金を借り入れ、利用者の死亡後に、その不動産の売却等により借入金を返済する仕組みである。",
        "choice3": "老後生活資金として一定期間、毎年一定額を受け取るために必要な元本を計算する際、毎年受け取りたい金額に乗じる係数は年金現価係数である。",
        "choice4": "定年年齢を75歳未満に定めている事業主は、高年齢者等の雇用の安定等に関する法律に基づき、雇用する高年齢者の75歳までの雇用確保のため、所定の措置を講じるよう努めなければならない。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1149,
        "shikenId": 21,
        "parentNo": 1,
        "no": 10,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "決算書に基づく経営分析指標に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "ROEは、自己資本に対する当期純利益の割合を示したものであり、一般に、この数値が低い方が経営の効率性が高いと判断される 。",
        "choice2": "固定長期適合率は、自己資本に対する固定資産の割合を示したものであり、一般に、この数値が低い方が財務の健全性が高いと判断される。",
        "choice3": "損益分岐点比率は、実際の売上高に対する損益分岐点売上高の割合を示したものであり、一般に、この数値が低い方が企業の収益性が高いと判断される。",
        "choice4": "自己資本比率は、総資本に対する自己資本の割合を示したものであり、一般に、この数値が低い方が財務の健全性が高いと判断される。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1150,
        "shikenId": 21,
        "parentNo": 1,
        "no": 11,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "生命保険の保険料等の一般的な仕組みに関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "所定の利率による運用収益をあらかじめ見込んで保険料を割り引く際に使用する予定利率を低く設定した場合、新規契約の保険料は高くなる。",
        "choice2": "保険料は、大数の法則および収支相等の原則に基づき、予定死亡率、予定利率および予定事業費率の３つの予定基礎率を用いて算定される。",
        "choice3": "保険料は、将来の保険金・給付金等の支払い財源となる純保険料と、保険会社が保険契約を維持・管理していくために必要な経費等の財源となる付加保険料で構成される。",
        "choice4": "保険会社が実際に要した事業費が、保険料を算定する際に見込んでいた事業費よりも多かった場合、費差益が生じる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1151,
        "shikenId": 21,
        "parentNo": 1,
        "no": 12,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "生命保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、記載のない特約については考慮しないものとする。",
        "choice1": "変額保険（終身型）では、契約時に定めた保険金額（基本保険金額）が保証されており、運用実績にかかわらず、死亡保険金の額は基本保険金額を下回らない。",
        "choice2": "低解約返戻金型終身保険は、保険料払込期間中の一定期間における解約返戻金額および死亡保険金額が他の契約条件が同一で低解約返戻金型ではない終身保険に比べて低く抑えられているため、割安な保険料が設定されている。",
        "choice3": "定期保険特約付終身保険（更新型）は、定期保険特約を同額の保険金額で更新する場合、被保険者の健康状態についての告知や医師の診査が必要であり、その健康状態によっては更新することができない。",
        "choice4": "逓減定期保険は、保険期間の経過に伴い所定の割合で保険料が逓減するが、保険金額は一定である。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1152,
        "shikenId": 21,
        "parentNo": 1,
        "no": 13,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "外貨建て生命保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、 記載のない特約については考慮しないものとする。",
        "choice1": "外貨建て終身保険は、契約時に円換算支払特約を付加すれば、契約時の為替相場で円換算した死亡保険金を受け取ることができる。",
        "choice2": "MVA（市場価格調整）機能を有する外貨建て生命保険は、市場金利に応じた運用資産の価格変動に伴い、解約時の解約返戻金額が増減する。",
        "choice3": "外貨建て終身保険は、円貨建ての終身保険と異なり、支払った保険料が生命保険料控除の対象とならない。",
        "choice4": "外貨建て生命保険は、通常、米ドル・豪ドル・ユーロなどの外貨で保険料を払い込んで円貨で保険金等を受け取る保険であり、終身保険のほか、養老保険や個人年金保険などがある。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1153,
        "shikenId": 21,
        "parentNo": 1,
        "no": 14,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "総合福祉団体定期保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、契約者は法人であるものとする。",
        "choice1": "法人が負担した保険料は、その全額を損金の額に算入することができる。",
        "choice2": "契約の締結には、被保険者になることについての加入予定者の同意が必要である。",
        "choice3": "保険期間は、１年から５年の範囲内で、被保険者ごとに設定することができる。",
        "choice4": "ヒューマン・ヴァリュー特約を付加した場合、当該特約の死亡保険金受取人は法人となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1154,
        "shikenId": 21,
        "parentNo": 1,
        "no": 15,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "契約者（＝保険料負担者）を法人とする生命保険に係る保険料等の経理処理に関する次の記述のうち、最も不適切なものはどれか。なお、いずれの保険契約も保険料は年払いかつ全期払いで、2025年10月に締結したものとする。",
        "choice1": "被保険者が役員・従業員全員、給付金受取人が法人である医療保険について、法人が受け取った入院給付金および手術給付金は、その全額を益金の額に算入する。",
        "choice2": "被保険者が役員、死亡保険金受取人が法人で、最高解約返戻率が80％である定期保険（保険期間30年）の支払保険料は、保険期間の前半４割相当期間においては、その60％相当額を資産に計上し、残額を損金の額に算入することができる。",
        "choice3": "被保険者が役員、死亡保険金受取人が法人である終身保険の支払保険料は、その全額を資産に計上する。",
        "choice4": "被保険者が役員・従業員全員、死亡保険金受取人が被保険者の遺族、満期保険金受取人が法人である養老保険の支払保険料は、その全額を損金の額に算入することができる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1155,
        "shikenId": 21,
        "parentNo": 1,
        "no": 16,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "任意加入の自動車保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、記載のない事項については考慮しないものとする。",
        "choice1": "記名被保険者が被保険自動車を運転中に、ハンドル操作を誤って通行人が連れていたペットの犬に接触してケガをさせ、法律上の損害賠償責任を負った場合、対物賠償保険の補償の対象となる。",
        "choice2": "豪雨による洪水で被保険自動車が水没して被った損害は、一般条件の車両保険の補償の対象となる。",
        "choice3": "記名被保険者が被保険自動車を運転中に、ハンドル操作を誤って車庫入れを誘導していた記名被保険者の配偶者に接触してケガをさせた場合、対人賠償保険の補償の対象となる。",
        "choice4": "記名被保険者が被保険自動車を運転中に、ハンドル操作を誤って衣料品販売店の店舗に衝突した場合、店舗の復旧期間中の休業損害は、対物賠償保険の補償の対象となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1156,
        "shikenId": 21,
        "parentNo": 1,
        "no": 17,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "傷害保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、特約および記載のない事項については考慮しないものとする。",
        "choice1": "交通事故傷害保険では、デパートのエスカレーターに搭乗中の事故によりケガをした場合、補償の対象となる。",
        "choice2": "普通傷害保険では、被保険者が自動車を運転中に他の自動車と衝突してケガをした場合、被保険者の過失割合にかかわらず補償の対象となる。",
        "choice3": "普通傷害保険では、海外旅行中に地震により倒壊した建物の下敷きになりケガをした場合、補償の対象となる。",
        "choice4": "国内旅行傷害保険では、被保険者が旅行中の飲食により細菌性食中毒を発症した場合、補償の対象となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1157,
        "shikenId": 21,
        "parentNo": 1,
        "no": 18,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "法人を契約者（＝保険料負担者）とする損害保険に係る保険料等の経理処理に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "法人が所有する賃貸アパートが台風により損壊し、法人が受け取った火災保険の保険金で原状回復のための修理をした場合、当該保険金を益金の額に算入し、修理費を損金の額に算入することができる。",
        "choice2": "業務中の事故によりケガをするリスクに備えて、法人がすべての従業員を被保険者とする普通傷害保険に加入した場合、支払った保険料は、その２分の１相当額を限度として損金の額に算入することができる。",
        "choice3": "法人が所有する業務用自動車が交通事故で全損となり、受け取った自動車保険の車両保険金で同一事業年度中に代替車両を取得した場合であっても、圧縮記帳は認められない。",
        "choice4": "法人が所有する賃貸アパートを保険の対象として支払った地震保険の保険料は、地震保険料控除として５万円を限度として損金の額に算入することができる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1158,
        "shikenId": 21,
        "parentNo": 1,
        "no": 19,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "医療保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "引受基準緩和型の医療保険と引受基準緩和型ではない一般の医療保険を比較した場合、他の契約条件が同一であれば、保険料は引受基準緩和型の医療保険の方が高くなる。",
        "choice2": "更新型の医療保険では、保険期間中に入院給付金を受け取った場合、保険期間満了時に契約を更新することができない。",
        "choice3": "医療保険では、人間ドック等の治療を目的としない入院をし、異常が発見されなかった場合、入院給付金を受け取ることができない。",
        "choice4": "先進医療特約で先進医療給付金の支払対象とされている先進医療は、療養を受けた日時点において厚生労働大臣によって定められたものである。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1159,
        "shikenId": 21,
        "parentNo": 1,
        "no": 20,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "損害保険を活用した家庭のリスク管理に関する次の記述のうち、最も不適切なものはどれか。なお、契約者（＝保険料負担者）は会社員の個人であるものとする。",
        "choice1": "同居の子が原動機付自転車で通学中に、他人に接触してケガをさせて法律上の損害賠償責任を負うリスクに備えて、火災保険加入時に個人賠償責任補償特約を付帯した。",
        "choice2": "所定の病気やケガにより会社の業務にまったく従事することができなくなるリスクに備えて、所得補償保険を契約した。",
        "choice3": "自動車の運転中に誤って単独事故を起こして車両が破損するリスクに備えて、自動車保険の一般条件の車両保険を契約した。",
        "choice4": "海岸近くに自宅を新築したので、地震による津波で自宅が損壊するリスクに備えて、火災保険に地震保険を付帯して契約した。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1160,
        "shikenId": 21,
        "parentNo": 1,
        "no": 21,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "銀行等の金融機関で取り扱う預金商品の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "期日指定定期預金は、据置期間経過後から最長預入期日までの間で、任意の日を満期日として指定することができる。",
        "choice2": "決済用預金のうち、当座預金は、個人、法人のいずれも利用することができるが、無利息型普通預金は、法人が利用することはできない。",
        "choice3": "貯蓄預金は、給与、年金等の自動受取口座や公共料金等の自動振替口座に指定することができる。",
        "choice4": "総合口座において、紙の通帳の代わりにオンライン上で入出金の明細や残高を確認することができるサービスを提供しているのは、ネット専業銀行に限られる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1161,
        "shikenId": 21,
        "parentNo": 1,
        "no": 22,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "株式投資信託の一般的な運用手法等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "ベンチマークの動きに連動して同等の運用収益率を得ることを目指すパッシブ運用は、アクティブ運用に比べて運用コストが低い傾向がある。",
        "choice2": "株価が現在の資産価値や利益水準などから割安と評価される銘柄に投資する手法は、バリュー運用と呼ばれる。",
        "choice3": "割安な銘柄の売建てと割高な銘柄の買建てをそれぞれ同程度の金額で行い、市場の価格変動に左右されない絶対的な収益の確保を目指す手法は、マーケット・ニュートラル運用と呼ばれる。",
        "choice4": "個別企業の業績の調査や財務分析によって投資対象となる銘柄を選定し、その積上げによってポートフォリオを構築する手法は、ボトムアップ・アプローチと呼ばれる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1162,
        "shikenId": 21,
        "parentNo": 1,
        "no": 23,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "表面利率が0.5％で、償還までの残存期間が８年の固定利付債券を額面100円当たり101円で購入し、購入から５年後に額面100円当たり100円で売却した場合の所有期間利回り（単利・年率）として、最も適切なものはどれか。なお、手数料、経過利子、税金等については考慮しないものとし、計算結果は表示単位の小数点以下第３位を四捨五入するものとする。",
        "choice1": "0.17％",
        "choice2": "0.30％",
        "choice3": "0.37％",
        "choice4": "0.50％",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1163,
        "shikenId": 21,
        "parentNo": 1,
        "no": 24,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "東京証券取引所の市場区分等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "スタンダード市場の上場会社がプライム市場へ市場区分の変更を申請することはできるが、プライム市場の上場会社がスタンダード市場へ市場区分の変更を申請することはできない。",
        "choice2": "JPX日経インデックス400は、プライム市場、スタンダード市場、グロース市場を主市場とする普通株式の中から、ROEや営業利益等の指標等により選定された400銘柄を対象として算出される。",
        "choice3": "プライム市場の上場維持基準では、新規上場から一定期間経過後の株主数および流通株式数について、新規上場基準よりも高い数値基準が設定されている。",
        "choice4": "プライム市場の新規上場基準では、上場申請会社の直近事業年度におけるROEの数値基準について、８％以上と定められている。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1164,
        "shikenId": 21,
        "parentNo": 1,
        "no": 25,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "債券投資のリスクに関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "債券の価格変動リスクは、表面利率などの他の条件が同一であれば、一般に、残存期間が長いほど高くなる。",
        "choice2": "債券の発行体の所在する国や地域における政治・経済状況の変化等により、債券価格が大きく変動したり、債券の元本や利子の支払不能等が生じたりするリスクを、一般に、カントリーリスクという。",
        "choice3": "債券の信用格付けにおいて、Ｂ（シングルビー）格相当以上の格付けが付された債券は、一般に、投資適格債と呼ばれ、信用リスクが低い債券とされる。",
        "choice4": "外貨建て債券の為替変動リスクを回避または軽減する方法の一つとして、当該債券の購入時に、その償還日にあわせて為替予約を行う為替ヘッジが考えられる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1165,
        "shikenId": 21,
        "parentNo": 1,
        "no": 26,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "金融派生商品に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "コール・オプション、プット・オプションのいずれも、他の条件が同一であれば、満期までの期間が長いほど、プレミアム（オプション料）は高くなる。",
        "choice2": "先物取引によりスペキュレーション取引を行う場合、先物価格が今後上昇すると予測すれば売り建てして、実際に相場が上昇した後に買い戻すことで利益を得ることができる。",
        "choice3": "先物取引における買い手は、最終決済価格が約定価格よりも低い場合、その差額分の利益を得ることができる。",
        "choice4": "先物取引に係る雑所得の金額の計算上生じた損失の金額は、上場株式等に係る譲渡所得の金額と損益通算することができる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1166,
        "shikenId": 21,
        "parentNo": 1,
        "no": 27,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "オプション取引の一般的な特徴に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "コール・オプションの買い手の最大利益とプット・オプションの買い手の最大利益は、いずれもプレミアム（オプション料）の額となる。",
        "choice2": "コール・オプションおよびプット・オプションは、他の条件が同一であれば、いずれもボラティリティが上昇するほど、プレミアム（オプション料）は高くなる。",
        "choice3": "権利行使期間中であればいつでも権利行使が可能なものをヨーロピアン・オプションといい、満期日（権利行使日）においてのみ権利行使が可能なものをアメリカン・オプションという。",
        "choice4": "コール・オプションは「原資産を権利行使価格で売る権利」であり、プット・オプションは「原資産を権利行使価格で買う権利」である。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1167,
        "shikenId": 21,
        "parentNo": 1,
        "no": 28,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "ポートフォリオ理論に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "ポートフォリオのリスクとは、一般に、組成されたポートフォリオの損失額の大きさを示すのではなく、そのポートフォリオの期待収益率と実際の収益率の乖離の度合いをいう。",
        "choice2": "ポートフォリオのリスクは、組み入れた各資産のリスクを組入比率で加重平均した値以下となる。",
        "choice3": "異なる２資産からなるポートフォリオにおいて、２資産間の相関係数がゼロである場合、ポートフォリオを組成することによる分散投資の効果（リスクの低減効果）は生じない。",
        "choice4": "ポートフォリオの期待収益率は、組み入れた各資産の期待収益率を組入比率で加重平均した値となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1168,
        "shikenId": 21,
        "parentNo": 1,
        "no": 29,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "NISA（非課税上場株式等管理契約に係る少額投資非課税制度）に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、NISAにより投資収益が非課税となる非課税口座をNISA口座という。",
        "choice1": "NISA口座で保有する上場株式を売却することで生じた譲渡損失の金額のうち、損益通算してもなお控除しきれない金額は、確定申告を行うことにより、翌年以後３年間にわたって繰り越すことができる。",
        "choice2": "NISA口座で保有する上場株式を売却することで生じた譲渡損失の金額は、上場株式の配当金の受取方法として株式数比例配分方式を選択した場合、当該口座で保有する上場株式の配当金の金額と通算することができる。",
        "choice3": "特定口座で保有する上場株式をNISA口座に設定される非課税管理勘定に移管することにより、移管後５年以内に生じた当該上場株式の譲渡益は非課税となる。",
        "choice4": "NISAにおいて、年間投資額の上限は、「つみたて投資枠」が120万円であり、「成長投資枠」が240万円である。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1169,
        "shikenId": 21,
        "parentNo": 1,
        "no": 30,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "金融商品の取引等に係る各種法令に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、「金融サービスの提供及び利用環境の整備等に関する法律」を金融サービス提供法、「犯罪による収益の移転防止に関する法律」を犯罪収益移転防止法という。",
        "choice1": "消費者契約法では、事業者の不適切な行為によって、消費者が誤認や困惑をし、それによって消費者契約の申込みまたはその承諾の意思表示をした場合、消費者は、当該契約によって生じた損害について賠償を請求することができるとされている。",
        "choice2": "犯罪収益移転防止法では、金融機関等の特定事業者が顧客と特定業務に係る取引を行った場合、特定事業者は、原則として、直ちに当該取引に関する記録を作成し、当該取引の行われた日から７年間保存しなければならないとされている。",
        "choice3": "金融商品取引法では、金融商品取引契約を締結しようとする金融商品取引業者等は、あらかじめ顧客（特定投資家を除く）に契約締結前交付書面を交付しなければならないとされているが、顧客から交付を要しない旨の意思表示があった場合、その交付義務は免除される。",
        "choice4": "金融サービス提供法では、金融サービス仲介業の登録を受けた事業者は、銀行、証券、保険、貸金業の分野のサービスを仲介することができるが、特定の金融機関に所属し、その指導および監督を受けなければならないとされている。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1170,
        "shikenId": 21,
        "parentNo": 1,
        "no": 31,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "わが国の税制に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "所得税では、課税対象となる所得を８種類に区分し、それぞれの所得の種類ごとに定められた計算方法により所得の金額を計算する。",
        "choice2": "相続税は直接税に該当し、消費税は間接税に該当する。",
        "choice3": "固定資産税は国税に該当し、登録免許税は地方税に該当する。",
        "choice4": "相続税では、納税者が申告書に記載した被相続人の資産等の内容に基づき、税務署長が納付すべき税額を決定する賦課課税方式を採用している。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1171,
        "shikenId": 21,
        "parentNo": 1,
        "no": 32,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税における所得の種類に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "個人年金保険の契約者（＝保険料負担者）である個人が、その保険契約に基づき、年金受給開始後に将来の年金給付の総額に代えて受け取った一時金に係る所得は、退職所得となる。",
        "choice2": "会社の役員が役員退職金を受け取ったことによる所得は、給与所得となる。",
        "choice3": "不動産の貸付けを事業的規模で行ったことにより生じた賃料収入に係る所得は、不動産所得となる。",
        "choice4": "会社員が勤務先から無利息で金銭を借り入れたことにより生じた経済的利益は、雑所得となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1172,
        "shikenId": 21,
        "parentNo": 1,
        "no": 33,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税の損益通算に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "生命保険の解約返戻金を受け取ったことによる一時所得の金額の計算上生じた損失の金額は、不動産所得の金額と損益通算することができる。",
        "choice2": "業務用車両を譲渡したことによる譲渡所得の金額の計算上生じた損失の金額は、事業所得の金額と損益通算することができる。",
        "choice3": "不動産所得の金額の計算上生じた損失の金額のうち、不動産所得を生ずべき土地の取得に要した負債の利子の額に相当する部分の金額は、事業所得の金額と損益通算することができる。",
        "choice4": "先物取引に係る雑所得の金額の計算上生じた損失の金額は、不動産所得の金額と損益通算することができる。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1173,
        "shikenId": 21,
        "parentNo": 1,
        "no": 34,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税における各種所得控除に関する次の記述のうち、最も不適切なものはどれか。なお、各選択肢において、ほかに必要とされる要件等はすべて満たしているものとする。",
        "choice1": "納税者の合計所得金額が2,500万円を超える場合、基礎控除の適用を受けることはできない。",
        "choice2": "納税者の合計所得金額が1,000万円を超える場合、配偶者控除の適用を受けることはできない。",
        "choice3": "納税者の合計所得金額が500万円を超える場合、寡婦控除の適用を受けることはできない。",
        "choice4": "納税者の合計所得金額が1,000万円を超える場合、医療費控除の適用を受けることはできない。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1174,
        "shikenId": 21,
        "parentNo": 1,
        "no": 35,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "給与所得者の所得税の確定申告に関する次の記述のうち、最も適切なものはどれか。なお、各選択肢において、記載された所得以外の所得は考慮しないものとする。また、いずれも適切に源泉徴収等がされ、年末調整すべきものは年末調整が済んでいるものとする。",
        "choice1": "Ａ社からの給与の収入金額が800万円で、生命保険の満期保険金に係る一時所得の金額が50万円ある場合、確定申告は不要である。",
        "choice2": "Ｂ社からの給与の収入金額が70万円で、老齢基礎年金および老齢厚生年金の公的年金に係る雑所得の金額が250万円ある場合、確定申告は不要である。",
        "choice3": "Ｃ社からの給与の収入金額が800万円で、アルバイトとして兼業しているＤ社からの給与の収入金額が30万円ある場合、確定申告は不要である。",
        "choice4": "Ｅ社からの給与の収入金額が3,000万円で、Ｆ社からの原稿料収入に係る雑所得の金額が15万円ある場合、確定申告は不要である。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1175,
        "shikenId": 21,
        "parentNo": 1,
        "no": 36,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "法人税の原則的な取扱いに関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "新設法人が設立事業年度から青色申告の適用を受けようとする場合は、設立の日から１カ月以内に「青色申告の承認申請書」を納税地の所轄税務署長に提出し、その承認を受けなければならない。",
        "choice2": "法人税の納税地は、その法人の代表者の住所または居所の所在地である。",
        "choice3": "法人は、法人税の納税地に異動があった場合、異動届出書を異動前および異動後の納税地の所轄税務署長に提出しなければならない。",
        "choice4": "期末資本金の額等が１億円以下の一定の中小法人に対する法人税の税率は、所得金額のうち年800万円以下の部分について軽減税率が適用される。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1176,
        "shikenId": 21,
        "parentNo": 1,
        "no": 37,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "法人税の損金に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "法人が役員に対して定期同額給与を支給した場合、不相当に高額な部分の金額など一定のものを除き、その全額を損金の額に算入することができる。",
        "choice2": "法人が会議に関連して、茶菓、弁当その他これらに類する飲食物を供与するために通常要する費用を支出した場合 、その全額を損金の額に算入することができる。",
        "choice3": "法人が減価償却費として損金経理した金額のうち、償却限度額に達するまでの金額は、その全額を損金の額に算入することができる。",
        "choice4": "法人が法人税および法人住民税を納付した場合、その全額を損金の額に算入することができる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1177,
        "shikenId": 21,
        "parentNo": 1,
        "no": 38,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "消費税に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "消費税の課税期間に係る基準期間は、個人事業者についてはその年の前々年である。",
        "choice2": "消費税の課税事業者が行う居住の用に供する家屋の貸付けは、その貸付期間が１カ月以上であれば、消費税の課税取引に該当する。",
        "choice3": "消費税の課税事業者である個人は、原則として、消費税の確定申告書をその年の翌年３月15日までに納税地の所轄税務署長に提出しなければならない。",
        "choice4": "簡易課税制度の適用を受けることができるのは、消費税の課税期間に係る基準期間における課税売上高が１億円以下の事業者である。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1178,
        "shikenId": 21,
        "parentNo": 1,
        "no": 39,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "会社と役員間の取引に係る所得税・法人税に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "会社が役員に対して無利息で金銭の貸付けを行った場合、原則として、通常収受すべき利息に相当する金額が、会社の益金の額に算入される。",
        "choice2": "役員が所有する建物を適正な時価の２分の１以上かつ時価未満の価額で会社に譲渡した場合、役員は、時価相当額を譲渡価額として譲渡所得の計算を行う。",
        "choice3": "会社が役員からの借入金について債務免除を受けた場合、会社はその債務免除を受けた金額を益金の額に算入する。",
        "choice4": "会社が所有する土地を適正な時価よりも低い価額で役員に譲渡した場合、その適正な時価と譲渡価額との差額が役員の給与所得の収入金額に算入される。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1179,
        "shikenId": 21,
        "parentNo": 1,
        "no": 40,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "損益計算書、貸借対照表およびキャッシュフロー計算書の一般的な特徴に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "貸借対照表において、資産の部の合計額と、負債の部および純資産の部の合計額は一致する。",
        "choice2": "キャッシュフロー計算書は、一会計期間における企業の資金の増減を示したものである。",
        "choice3": "損益計算書において、営業利益の額は、売上総利益の額から販売費及び一般管理費の額を差し引いた額である。",
        "choice4": "損益計算書において、経常利益の額は、営業利益の額に特別利益・特別損失の額を加算・減算した額である。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1180,
        "shikenId": 21,
        "parentNo": 1,
        "no": 41,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産の登記や調査に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "抵当権の登記の登記事項は、権利部乙区に記録される。",
        "choice2": "登記情報提供サービスでは、登記所が保有する登記情報を、インターネットを使用してパソコン等で確認することができるが、取得した登記情報に係る電子データには登記官の認証文は付されない。",
        "choice3": "新築した建物の所有権を取得した者は、その所有権の取得の日から１カ月以内に、所有権保存登記を申請しなければならない。",
        "choice4": "区分建物を除く建物に係る登記記録において、床面積は、壁その他の区画の中心線で囲まれた部分の水平投影面積（壁芯面積）により記録される。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1181,
        "shikenId": 21,
        "parentNo": 1,
        "no": 42,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "宅地建物取引業法に関する次の記述のうち、最も適切なものはどれか。なお、買主は宅地建物取引業者ではないものとする。",
        "choice1": "宅地建物取引業者が、自ら売主となる宅地の売買契約の締結に際して手付を受領したときは、その手付がいかなる性質のものであっても、買主が契約の履行に着手する前であれば、当該宅地建物取引業者はその手付を返還することで、契約の解除をすることができる。",
        "choice2": "アパートやマンションの所有者が、当該建物の賃貸を自ら業として行うためには、あらかじめ宅地建物取引業の免許を取得しなければならない。",
        "choice3": "専任媒介契約を締結した宅地建物取引業者は、依頼者に対し、当該専任媒介契約に係る業務の処理状況を、５日間に１回以上報告しなければならない。",
        "choice4": "宅地建物取引業者は、自ら売主となる宅地の売買契約の締結に際して、代金の額の10分の２を超える額の手付を受領することができない。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1182,
        "shikenId": 21,
        "parentNo": 1,
        "no": 43,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "借地借家法に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、同法第22条の借地権を一般定期借地権といい、第22条から第24条の定期借地権等以外の借地権を普通借地権という。また、記載のない特約については考慮しないものとする。",
        "choice1": "普通借地権の存続期間が満了する場合において、借地権者が契約の更新を請求し、借地権設定者が遅滞なく異議を述べなかったときは、借地上に建物があるかどうかにかかわらず、従前の契約と同一の条件で契約を更新したものとみなされる。",
        "choice2": "一般定期借地権において、契約の更新および建物の築造による存続期間の延長がなく、建物等の買取りの請求をしないこととする旨を定める特約は、公正証書による等書面（電磁的記録による場合を含む）によってしなければならない。",
        "choice3": "事業の用に供する建物の所有を目的として、一般定期借地権を設定することはできない。",
        "choice4": "普通借地権の存続期間は30年とされており、契約でこれより長い期間を定めることはできない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1183,
        "shikenId": 21,
        "parentNo": 1,
        "no": 44,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "都市計画法に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "市街化区域内で行う開発行為は、その規模にかかわらず、都道府県知事等の許可を受ける必要がある。",
        "choice2": "市街化調整区域は、おおむね10年以内に優先的かつ計画的に市街化を図るべき区域とされている。",
        "choice3": "市街化区域については用途地域を定め、市街化調整区域については原則として用途地域を定めないものとされている。",
        "choice4": "すべての都市計画区域において、都市計画に市街化区域と市街化調整区域の区域区分を定めなければならない。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1184,
        "shikenId": 21,
        "parentNo": 1,
        "no": 45,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "借地借家法に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、同法第38条における定期建物賃貸借契約を定期借家契約といい、それ以外の建物賃貸借契約を普通借家契約という。また、特約については考慮しないものとする。",
        "choice1": "定期借家契約は、公正証書によってしなければならない。",
        "choice2": "普通借家契約において、賃貸人は、賃貸人および賃借人が建物の使用を必要とする事情や建物の利用状況などを考慮して、正当の事由があると認められる場合でなければ、賃借人に対し、建物の賃貸借の解約の申入れをすることはできない。",
        "choice3": "普通借家契約において、賃貸人が賃借人に対して期間満了の１年前から６カ月前までの間に更新をしない旨の通知をしなかったときは、従前の契約と同じ期間で契約を更新したものとみなされる。",
        "choice4": "定期借家契約は、契約当事者間の合意があっても、存続期間を１年未満とすることはできない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1185,
        "shikenId": 21,
        "parentNo": 1,
        "no": 46,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "都市計画区域および準都市計画区域内における建築基準法の規定に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "建築物の高さに係る隣地斜線制限は、第一種低層住居専用地域、第二種低層住居専用地域および田園住居地域には適用されない。",
        "choice2": "第一種住居地域内においては、建築物の高さは10ｍまたは12ｍのうち当該地域に関する都市計画において定められた建築物の高さの限度を超えてはならない。",
        "choice3": "敷地の前面道路の幅員が12ｍ未満である建築物の容積率は、原則として、「都市計画で定められた容積率」と「前面道路の幅員に一定の数値を乗じて得たもの」とのいずれか低い方が上限となる。",
        "choice4": "建築物の敷地は、原則として、建築基準法に規定する道路に２ｍ以上接していなければならない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1186,
        "shikenId": 21,
        "parentNo": 1,
        "no": 47,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "建物の区分所有等に関する法律に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "区分所有建物のうち、構造上の独立性と利用上の独立性を備えた建物の部分は、区分所有権の目的となる専有部分であり、規約によって共用部分とすることはできない。",
        "choice2": "規約を変更するためには、区分所有者および議決権の各４分の３以上の多数による集会の決議が必要となり、この変更が一部の区分所有者の権利に特別の影響を及ぼすべきときは、当該区分所有者の承諾を得なければならない。",
        "choice3": "共用部分に対する区分所有者の共有持分は、規約に別段の定めがない限り、各共有者が有する専有部分の床面積の割合による。",
        "choice4": "区分所有建物ならびにその敷地および附属施設の管理を行うための区分所有者の団体（管理組合）は、区分所有者全員で構成される。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1187,
        "shikenId": 21,
        "parentNo": 1,
        "no": 48,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産の取得に係る税金に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "不動産取得税は、相続により不動産を取得した場合は課されるが、贈与により不動産を取得した場合は課されない。",
        "choice2": "登録免許税は、建物を新築した場合の建物表題登記であっても課される。",
        "choice3": "登録免許税は、贈与により不動産を取得した場合の所有権移転登記では課されない。",
        "choice4": "一定の要件を満たす戸建て住宅（認定長期優良住宅を除く）を新築した場合、不動産取得税の課税標準の算定に当たっては、１戸につき最高1,200万円を価格から控除することができる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1188,
        "shikenId": 21,
        "parentNo": 1,
        "no": 49,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産賃貸に係る所得税に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "アパート等の貸付けが不動産所得における事業的規模であるかどうかの判定において 、貸与することができる 独立した 室数がおおむね10以上であれば、特に反証がない限り、事業的規模として取り扱われる。",
        "choice2": "不動産所得に係る総収入金額を計算する場合において、契約により支払日が定められている賃貸料は、原則として、その定められた支払日が収入すべき時期となる。",
        "choice3": "不動産所得の金額の計算上、2025年中に取得した建物を同年中に貸し付けた場合の当該建物の減価償却費の計算においては、定額法または定率法の選択が可能である。",
        "choice4": "不動産所得の金額の計算上、当該不動産所得に係る所得税および住民税の額は必要経費に算入されない。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1189,
        "shikenId": 21,
        "parentNo": 1,
        "no": 50,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産の投資判断の手法等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "NPV法（正味現在価値法）による投資判断においては、対象不動産から得られる収益の現在価値の合計額が投資額を上回っている場合、その投資は有利であると判定することができる。",
        "choice2": "DCF法は、対象不動産の一期間の純収益を還元利回りで還元して対象不動産の収益価格を求める手法である。",
        "choice3": "DSCR（借入金償還余裕率）は、対象不動産から得られる収益による借入金の返済余裕度を評価する指標であり、対象不動産に係る当該指標の数値が1.0を下回っている場合は、対象不動産から得られる収益だけで借入金を返済することができる。",
        "choice4": "NOI利回り（純利回り）は、対象不動産から得られる年間の総収入額を総投資額で除して算出される利回りであり、不動産の収益性を測る指標である。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1190,
        "shikenId": 21,
        "parentNo": 1,
        "no": 51,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "民法上の贈与に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "定期贈与は、贈与者または受贈者のいずれか一方が生存している限り、その効力を失うことはない。",
        "choice2": "書面によらない贈与は、その履行の終わった部分を除き、各当事者が解除をすることができる。",
        "choice3": "死因贈与は、民法の遺贈に関する規定が準用されるため、書面によってしなければならない。",
        "choice4": "贈与は、当事者の一方が、ある財産を無償で相手方に与える意思表示をすることにより効力が生じ、相手方が受諾する必要はない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1191,
        "shikenId": 21,
        "parentNo": 1,
        "no": 52,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "相続時精算課税制度（以下「本制度」という）に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "本制度の適用を受けることを選択した場合、その選択をした年分以後、その選択に係る贈与者から贈与により取得した財産については、暦年課税に変更することができない。",
        "choice2": "本制度において、贈与者および受贈者の年齢が適用要件を満たすかどうかは、贈与があった年の１月１日現在の年齢で判定する。",
        "choice3": "本制度の適用を受けた贈与財産に係る贈与税額の計算上、適用される税率は、一律25％である。",
        "choice4": "本制度の選択に係る贈与者が死亡した場合における相続税額の計算上、相続税額からすでに納めた本制度に係る贈与税相当額を控除してもなお控除しきれない金額は、相続税の申告により還付を受けることができる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1192,
        "shikenId": 21,
        "parentNo": 1,
        "no": 53,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "贈与税の配偶者控除（以下「本控除」という）に関する次の記述のうち、最も不適切なものはどれか。なお、各選択肢において、ほかに必要とされる要件等はすべて満たしているものとする。",
        "choice1": "配偶者から受けた贈与について、贈与税の配偶者控除の適用を受けたことがある場合、その後、同一の配偶者から贈与を受けても、再び本控除の適用を受けることはできない。",
        "choice2": "本控除の適用を受けるためには、贈与者である配偶者との婚姻期間が贈与を受けた日の属する年の１月１日において20年以上でなければならない。",
        "choice3": "配偶者からの贈与について本控除の適用を受け、その翌年に当該配偶者が死亡した場合、当該配偶者に係る相続税額の計算上、本控除の適用を受けた財産のうち、本控除により控除された金額に相当する部分は相続税の課税価格に加算されない。",
        "choice4": "居住用不動産である家屋およびその敷地のうち、敷地のみの贈与を受けた場合であっても、本控除の適用を受けることができる。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1193,
        "shikenId": 21,
        "parentNo": 1,
        "no": 54,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "民法上の相続分に関する次の記述のうち、最も不適切なものはどれか。なお、記載のない事項については考慮しないものとする。",
        "choice1": "共同相続人の１人が遺産の分割前にその相続分を共同相続人以外の第三者に譲り渡した場合、他の共同相続人は、当該第三者に対して一定期間内にその価額および費用を支払うことで、その相続分を譲り受けることができる。",
        "choice2": "養子の法定相続分は、実子の法定相続分と同じである。",
        "choice3": "被相続人の兄弟姉妹が相続人である場合において、当該兄弟姉妹のうち被相続人の相続開始以前に死亡した者がいるときは、その死亡した者の子が代襲して相続人となる。",
        "choice4": "相続人が複数いる場合、各共同相続人は、被相続人の遺言により相続分や遺産分割方法の指定がされていなければ、法定相続分どおりに相続財産を分割しなければならない。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1194,
        "shikenId": 21,
        "parentNo": 1,
        "no": 55,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "遺産分割協議に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "遺産を現物分割する旨の遺産分割協議書を作成する際に、一定の場合を除き、遺産の一部についてのみ定めた遺産分割協議書を作成することができる。",
        "choice2": "遺産分割協議書は、民法で定められた形式に従って作成し、かつ、共同相続人全員が署名・捺印していなければ無効となる。",
        "choice3": "遺産分割協議書は、相続人が相続の開始があったことを知った日の翌日から10カ月以内に作成し、家庭裁判所に提出しなければならない。",
        "choice4": "適法に成立した遺産分割協議については、共同相続人全員の合意があったとしても、当該協議を解除し、再度、遺産分割協議を行うことはできない。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1195,
        "shikenId": 21,
        "parentNo": 1,
        "no": 56,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "相続税における取引相場のない株式の評価に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "同族株主のいる会社において、同族株主以外の株主が取得した株式は、その会社規模にかかわらず、原則として、配当還元方式によって評価する。",
        "choice2": "会社規模が小会社である会社の株式の価額は、純資産価額方式によって評価し、類似業種比準方式と純資産価額方式の併用方式によって評価することはできない。",
        "choice3": "会社規模が中会社である会社の株式の価額は、類似業種比準方式、または純資産価額方式のいずれかによって評価する。",
        "choice4": "同族株主が取得した土地保有特定会社に該当する会社の株式は、原則として、類似業種比準方式によって評価する。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1196,
        "shikenId": 21,
        "parentNo": 1,
        "no": 57,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "相続税の計算に関する次の記述のうち、最も適切なものはどれか。なお、本問において、相続の放棄をした者はいないものとする。",
        "choice1": "遺産に係る基礎控除額の計算上、法定相続人の数に含めることができる養子（実子とみなされる者を除く）の数は、実子がいる場合、２人に制限される。",
        "choice2": "相続人となるべき被相続人の子がすでに死亡しているため、その死亡した子を代襲して相続人となった被相続人の孫は、相続税額の２割加算の対象者となる。",
        "choice3": "相続人が被相続人の配偶者のみである場合、「配偶者に対する相続税額の軽減」の適用を受けた配偶者については、相続により取得した遺産額の多寡にかかわらず、納付すべき相続税額が生じない。",
        "choice4": "「配偶者に対する相続税額の軽減」の適用を受けることができる配偶者は、被相続人と法律上の婚姻の届出をした者に限られず、いわゆる内縁の配偶者も含まれる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1197,
        "shikenId": 21,
        "parentNo": 1,
        "no": 58,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "宅地および宅地の上に存する権利の相続税における評価に関する次の記述のうち、最も不適切なものはどれか。なお、評価の対象となる宅地は、借地権（建物等の所有を目的とする地上権または土地の賃借権）の設定に際し、その設定の対価として通常権利金その他の一時金を支払う「借地権の取引慣行のある地域」にあるものとする。また、宅地の上に存する権利は、定期借地権および一時使用目的の借地権等を除くものとする。",
        "choice1": "Ａさんが、所有する宅地の上にアパートを建築して賃貸の用に供していた場合において、Ａさんの相続が開始したときは、相続税額の計算上、その宅地の価額は貸家建付地として評価する。",
        "choice2": "Ｂさんが、借地権の設定に際して通常の権利金を支払って賃借した宅地の上にＢさん名義の自宅を建築して居住の用に供していた場合において、Ｂさんの相続が開始したときは、相続税額の計算上、その宅地の上に存するＢさんの権利の価額は、借地権として評価する。",
        "choice3": "Ｃさんが、借地権の設定に際して通常の権利金を支払って賃借した宅地の上にＣさん名義のアパートを建築して賃貸の用に供していた場合において、Ｃさんの相続が開始したときは、相続税額の計算上、その宅地の上に存するＣさんの権利の価額は、貸家建付借地権として評価する。",
        "choice4": "Ｄさんが、従前宅地であった土地を車庫などの施設がない青空駐車場（月極駐車場）の用に供していた場合において、Ｄさんの相続が開始したときは、相続税額の計算上、その土地の価額は貸宅地として評価する。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1198,
        "shikenId": 21,
        "parentNo": 1,
        "no": 59,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "遺言に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "共同相続人のうち一部の者についてのみ相続分を指定する内容の遺言は無効となる。",
        "choice2": "遺言執行者を指定する内容の遺言は無効となる。",
        "choice3": "共同相続人の遺留分を侵害する内容の遺言は無効となる。",
        "choice4": "被相続人は、遺言で、遺産分割の方法を定めることを第三者に委託することができる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1199,
        "shikenId": 21,
        "parentNo": 1,
        "no": 60,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "会社法に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "定時株主総会は、毎事業年度終了後一定の時期に招集しなければならないが、臨時株主総会は、必要がある場合にいつでも招集することができる。",
        "choice2": "株式会社において株主は、その有する株式の引受価額を限度として責任を負う。",
        "choice3": "すべての株式会社は、取締役会を置かなければならない。",
        "choice4": "取締役は、いつでも、株主総会の決議によって解任することができる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1200,
        "shikenId": 21,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "はじめに、Ｍさんは、Ａさんに対して、Ａさんが受給することができる公的年金制度からの老齢給付について説明した。Ｍさんが説明した以下の文章の空欄①〜③に入る最も適切な数値を入力しなさい。計算にあたっては、《設例》の〈Ａさんとその家族に関する資料〉および下記の〈資料〉に基づくこと。なお、年金額は2025年度価額に基づいて計算し、年金額の端数処理は円未満を四捨五入すること。また、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/25b_1200_2.png'>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "年",
        "choice4": "",
        "choice5": "",
        "answer": "769323,1028581,20",
        "score": "1,1,1",
        "image": "25b_1200.png"
    },
    {
        "id": 1201,
        "shikenId": 21,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、公的年金制度等の各種取扱いについて説明した。Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br><img class='question-img' src='/img/question/25b_1200_3.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1",
        "score": "1,1,1",
        "image": "25b_1200.png"
    },
    {
        "id": 1202,
        "shikenId": 21,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 2,
        "inputType": 7,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、老後の収入を増やすための各種制度について説明した。Ｍさんが説明した以下の文章の空欄①〜④に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を選びなさい。<br><br><img class='question-img' src='/img/question/25b_1200_4.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ロ,ホ,チ,ニ",
        "score": "1,1,1,1",
        "image": "25b_1200.png"
    },
    {
        "id": 1203,
        "shikenId": 21,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "《設例》の〈Ｘ社株式およびＹ社株式の情報〉および〈Ｘ社およびＹ社の財務データ〉に基づいて算出される次の①〜③を求めなさい。〈答〉は表示単位の小数点以下第 ３ 位を四捨五入し、小数点以下第 ２ 位までを解答すること。<br><br>① Ｘ社のＲＯＥ<br>② Ｘ社のＰＥＲ<br>③ Ｘ社の配当性向",
        "choice1": "％",
        "choice2": "倍",
        "choice3": "％",
        "choice4": "",
        "choice5": "",
        "answer": "11.32,10,39.17",
        "score": "1,1,1",
        "image": "25b_1203.png"
    },
    {
        "id": 1204,
        "shikenId": 21,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 2,
        "inputType": 7,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、Ｘ社株式の購入について説明した。Ｍさんが説明した以下の文章の空欄①〜④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選びなさい。なお、売買委託手数料等などは考慮しないものとする。<br><br><img class='question-img' src='/img/question/25b_1203_2.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル|ヲ|ワ|カ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ワ,ト,ヌ,ハ",
        "score": "1,1,1,1",
        "image": "25b_1203.png"
    },
    {
        "id": 1205,
        "shikenId": 21,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、Ｘ社株式の購入について説明した。Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br><img class='question-img' src='/img/question/25b_1203_3.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2",
        "score": "1,1,1",
        "image": "25b_1203.png"
    },
    {
        "id": 1206,
        "shikenId": 21,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんの所得税の確定申告等に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br><img class='question-img' src='/img/question/25b_1206_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2",
        "score": "1,1,1",
        "image": "25b_1206.png"
    },
    {
        "id": 1207,
        "shikenId": 21,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "Ａさんが勤務先から受け取る退職金に係る退職所得の金額を計算した次の〈計算の手順〉の空欄①〜③に入る最も適切な数値を入力しなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/25b_1206_3.png'>",
        "choice1": "万円",
        "choice2": "年",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "answer": "800,36,140",
        "score": "1,1,1",
        "image": "25b_1206.png"
    },
    {
        "id": 1208,
        "shikenId": 21,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税における課税総所得金額を計算した下記の表の空欄①〜③に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/25b_1206_4.png'><br><br><img class='question-img' src='/img/question/25b_1206_5.png'>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "",
        "choice5": "",
        "answer": "5770000,380000,1210000",
        "score": "2,1,1",
        "image": "25b_1206.png"
    },
    {
        "id": 1209,
        "shikenId": 21,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "甲土地上に建物を建てる場合の建築基準法上の規制に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br><img class='question-img' src='/img/question/25b_1209_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1",
        "score": "1,2,1",
        "image": "25b_1209.png"
    },
    {
        "id": 1210,
        "shikenId": 21,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 2,
        "inputType": 7,
        "question1": "",
        "question2": "甲土地の有効活用に関する以下の文章の空欄①〜③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選びなさい。<br><br><img class='question-img' src='/img/question/25b_1209_3.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ト,イ,ヌ",
        "score": "1,1,1",
        "image": "25b_1209.png"
    },
    {
        "id": 1211,
        "shikenId": 21,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "借地借家法の事業用定期借地権等に係る借地契約に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br><img class='question-img' src='/img/question/25b_1209_4.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1",
        "score": "1,1,1",
        "image": "25b_1209.png"
    },
    {
        "id": 1212,
        "shikenId": 21,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "「直系尊属から住宅取得等資金の贈与を受けた場合の贈与税の非課税」（以下、「本特例」という）に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br><img class='question-img' src='/img/question/25b_1212_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,1,2",
        "score": "1,1,1",
        "image": "25b_1212.png"
    },
    {
        "id": 1213,
        "shikenId": 21,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんの相続等に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br><img class='question-img' src='/img/question/25b_1212_3.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2",
        "score": "1,1,1",
        "image": "25b_1212.png"
    },
    {
        "id": 1214,
        "shikenId": 21,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "現時点（2025年 ９ 月 １ 日）において、Ａさんの相続が開始した場合における相続税の総額を試算した下記の表の空欄①〜③に入る最も適切な数値を求めなさい。なお、相続税の課税価格の合計額は ３ 億5, 000万円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/25b_1212_4.png'>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "answer": "4800,1565,7470",
        "score": "1,1,2",
        "image": "25b_1212.png"
    },
    {
        "id": 1215,
        "shikenId": 21,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "はじめに、Ｍさんは、Ａさんに対して、公的年金保険料の納付および受給について説明した。Ｍさんが説明した以下の文章の空欄①〜③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選びなさい。<br><br><img class='question-img' src='/img/question/25b_1215_2.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ロ,ハ,ヘ",
        "score": "1,1,1",
        "image": "25b_1215.png"
    },
    {
        "id": 1216,
        "shikenId": 21,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "次に、Ｍさんは、Ａさんに対して、定年退職後の社会保険の各種取扱い等について説明した。Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/25b_1215_3.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,1",
        "score": "1,1,1",
        "image": "25b_1215.png"
    },
    {
        "id": 1217,
        "shikenId": 21,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "最後に、Ｍさんは、Ａさんに対して、Ａさんが65歳以後に受給することができる公的年金制度からの老齢給付の額について説明した。Ａさんが、原則として65歳から受給することができる老齢基礎年金および老齢厚生年金の年金額（2025年度価額）を計算した次の〈計算の手順〉の空欄①〜④に入る最も適切な数値を入力しなさい。なお、計算にあたっては、《設例》の〈Ａさん夫妻に関する資料〉および下記の〈資料〉に基づくこと。また、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/25b_1215_4.png'>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "",
        "answer": "771055,1233865,61265,1711030",
        "score": "1,1,1,1",
        "image": "25b_1215.png"
    },
    {
        "id": 1218,
        "shikenId": 21,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "はじめに、Ｍさんは、《設例》の〈資料 １ 〉および〈資料 ２ 〉の生命保険の保障内容等について説明した。Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br><img class='question-img' src='/img/question/25b_1218_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1",
        "score": "1,1,1",
        "image": "25b_1218.png"
    },
    {
        "id": 1219,
        "shikenId": 21,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "次に、Ｍさんは、Ａさんに対して、公的介護保険（以下、「介護保険」という）について説明した。Ｍさんが説明した次の記述①〜④について、適切なものは○を、不適切なものは×を選びなさい。<br><br><img class='question-img' src='/img/question/25b_1218_3.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1,2",
        "score": "1,1,1,1",
        "image": "25b_1218.png"
    },
    {
        "id": 1220,
        "shikenId": 21,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "最後に、Ｍさんは、《設例》の〈資料 １ 〉の生命保険の課税関係について説明した。Ｍさんが説明した以下の文章の空欄①〜③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選びなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/25b_1218_4.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ヘ,ト,ハ",
        "score": "1,1,1",
        "image": "25b_1218.png"
    },
    {
        "id": 1221,
        "shikenId": 21,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "仮に、Ａさんが役員在任期間（勤続年数）37年 ４ カ月でＸ社を退任し、Ｘ社が役員退職金として5, 000万円支給した場合、Ａさんが受け取る役員退職金に係る退職所得の金額を計算した下記の計算式の空欄①〜④に入る最も適切な数値を入力しなさい。なお、Ａさんは、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。また、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/25b_1221_2.png'>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "万円",
        "choice5": "",
        "answer": "800,70,2060,1470",
        "score": "1,1,1,1",
        "image": "25b_1221.png"
    },
    {
        "id": 1222,
        "shikenId": 21,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、法人契約による定期保険の保険料に係る経理処理について説明した。Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/25b_1221_3.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,1,1",
        "score": "1,1,1",
        "image": "25b_1221.png"
    },
    {
        "id": 1223,
        "shikenId": 21,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、〈資料 １ 〉の無配当逓増定期保険について説明した。Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/25b_1221_4.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1",
        "score": "1,1,1",
        "image": "25b_1221.png"
    },
    {
        "id": 1224,
        "shikenId": 21,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税の計算における所得控除等に関する以下の文章の空欄①〜②に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を選びなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/25b_1224_2.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "イ,ホ",
        "score": "1,1",
        "image": "25b_1224.png"
    },
    {
        "id": 1225,
        "shikenId": 21,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税の課税等に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/25b_1224_3.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,1",
        "score": "1,1,1",
        "image": "25b_1224.png"
    },
    {
        "id": 1226,
        "shikenId": 21,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税の算出税額を計算した下記の表の空欄①〜④に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/25b_1224_4.png'>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "",
        "answer": "250000,1010000,580000,512500",
        "score": "1,1,1,2",
        "image": "25b_1224.png"
    },
    {
        "id": 1227,
        "shikenId": 21,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "現時点（2025年 ９ 月 １ 日）において、Ａさんの相続が開始した場合における相続税の総額を試算した下記の表の空欄①〜④に入る最も適切な数値を求めなさい。なお、相続税の課税価格の合計額は ４ 億4, 000万円とする。また、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/25b_1227_2.png'>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "万円",
        "choice5": "",
        "answer": "4800,6140,2240,10620",
        "score": "1,1,1,1",
        "image": "25b_1227.png"
    },
    {
        "id": 1228,
        "shikenId": 21,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "非上場株式等についての贈与税の納税猶予及び免除の特例（以下、「本特例」という）に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br><img class='question-img' src='/img/question/25b_1227_3.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2",
        "score": "1,1,1",
        "image": "25b_1227.png"
    },
    {
        "id": 1229,
        "shikenId": 21,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "Ａさんの相続等に関する以下の文章の空欄①〜③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選びなさい。<br><br><img class='question-img' src='/img/question/25b_1227_4.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "チ,ホ,ロ",
        "score": "1,1,1",
        "image": "25b_1227.png"
    },
    {
        "id": 1230,
        "shikenId": 21,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25b_fp2/1.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1231,
        "shikenId": 21,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25b_fp2/2.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1232,
        "shikenId": 21,
        "parentNo": 2,
        "no": 3,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25b_fp2/3.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,1",
        "score": "1,1",
        "image": ""
    },
    {
        "id": 1233,
        "shikenId": 21,
        "parentNo": 2,
        "no": 4,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25b_fp2/4.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,2,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1234,
        "shikenId": 21,
        "parentNo": 2,
        "no": 5,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25b_fp2/5.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "816956",
        "score": "3",
        "image": ""
    },
    {
        "id": 1235,
        "shikenId": 21,
        "parentNo": 1,
        "no": 6,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25b_fp2/6.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": ""
    },
    {
        "id": 1236,
        "shikenId": 21,
        "parentNo": 2,
        "no": 7,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25b_fp2/7.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1",
        "score": "1,1",
        "image": ""
    },
    {
        "id": 1237,
        "shikenId": 21,
        "parentNo": 2,
        "no": 8,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25b_fp2/8.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,1,2,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1238,
        "shikenId": 21,
        "parentNo": 2,
        "no": 9,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25b_fp2/9.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1239,
        "shikenId": 21,
        "parentNo": 1,
        "no": 10,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25b_fp2/10.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1240,
        "shikenId": 21,
        "parentNo": 2,
        "no": 11,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25b_fp2/11.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "㎡",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "900",
        "score": "2",
        "image": ""
    },
    {
        "id": 1241,
        "shikenId": 21,
        "parentNo": 2,
        "no": 12,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25b_fp2/12.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,1",
        "score": "1,1,1",
        "image": ""
    },
    {
        "id": 1242,
        "shikenId": 21,
        "parentNo": 2,
        "no": 13,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25b_fp2/13.png\" class=\"question-img\" /><br><br><img src=\"/img/question/25b_fp2/14.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "answer": "4,486,1210",
        "score": "2,2,2",
        "image": ""
    },
    {
        "id": 1243,
        "shikenId": 21,
        "parentNo": 2,
        "no": 14,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25b_fp2/15.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "80000",
        "score": "2",
        "image": ""
    },
    {
        "id": 1244,
        "shikenId": 21,
        "parentNo": 1,
        "no": 15,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25b_fp2/16.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1245,
        "shikenId": 21,
        "parentNo": 1,
        "no": 16,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25b_fp2/17.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1246,
        "shikenId": 21,
        "parentNo": 1,
        "no": 17,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25b_fp2/18.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": ""
    },
    {
        "id": 1247,
        "shikenId": 21,
        "parentNo": 2,
        "no": 18,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25b_fp2/19.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1248,
        "shikenId": 21,
        "parentNo": 1,
        "no": 19,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25b_fp2/20.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1249,
        "shikenId": 21,
        "parentNo": 1,
        "no": 20,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25b_fp2/21.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "2",
        "image": ""
    },
    {
        "id": 1250,
        "shikenId": 21,
        "parentNo": 2,
        "no": 21,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25b_fp2/22.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "55",
        "score": "3",
        "image": ""
    },
    {
        "id": 1251,
        "shikenId": 21,
        "parentNo": 1,
        "no": 22,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25b_fp2/23.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1252,
        "shikenId": 21,
        "parentNo": 1,
        "no": 23,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25b_fp2/24.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": ""
    },
    {
        "id": 1253,
        "shikenId": 21,
        "parentNo": 2,
        "no": 24,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25b_fp2/25.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1254,
        "shikenId": 21,
        "parentNo": 2,
        "no": 25,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25b_fp2/26.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "3200",
        "score": "3",
        "image": ""
    },
    {
        "id": 1255,
        "shikenId": 21,
        "parentNo": 1,
        "no": 26,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25b_fp2/27.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1256,
        "shikenId": 21,
        "parentNo": 2,
        "no": 27,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25b_fp2/28.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1257,
        "shikenId": 21,
        "parentNo": 2,
        "no": 28,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25b_fp2/29.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "318",
        "score": "1",
        "image": ""
    },
    {
        "id": 1258,
        "shikenId": 21,
        "parentNo": 2,
        "no": 29,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25b_fp2/30.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1029",
        "score": "2",
        "image": ""
    },
    {
        "id": 1259,
        "shikenId": 21,
        "parentNo": 1,
        "no": 30,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25b_fp2/31.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1260,
        "shikenId": 21,
        "parentNo": 2,
        "no": 31,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25b_fp2/32.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "8369600",
        "score": "1",
        "image": ""
    },
    {
        "id": 1261,
        "shikenId": 21,
        "parentNo": 2,
        "no": 32,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25b_fp2/33.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1920000",
        "score": "1",
        "image": ""
    },
    {
        "id": 1262,
        "shikenId": 21,
        "parentNo": 2,
        "no": 33,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25b_fp2/34.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "8610000",
        "score": "1",
        "image": ""
    },
    {
        "id": 1263,
        "shikenId": 21,
        "parentNo": 2,
        "no": 34,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/25b_fp2/35.png\" class=\"question-img\" /><br><br><img src=\"/img/question/25b_fp2/36.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "5320",
        "score": "3",
        "image": ""
    },
    {
        "id": 1264,
        "shikenId": 21,
        "parentNo": 2,
        "no": 35,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25b_fp2/37.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1265,
        "shikenId": 21,
        "parentNo": 2,
        "no": 36,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25b_fp2/38.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1266,
        "shikenId": 21,
        "parentNo": 2,
        "no": 37,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25b_fp2/39.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1267,
        "shikenId": 21,
        "parentNo": 1,
        "no": 38,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25b_fp2/40.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": ""
    },
    {
        "id": 1268,
        "shikenId": 21,
        "parentNo": 1,
        "no": 39,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/25b_fp2/41.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "2",
        "image": ""
    },
    {
        "id": 1269,
        "shikenId": 21,
        "parentNo": 2,
        "no": 40,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/25b_fp2/42.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1300,
        "shikenId": 22,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "ファイナンシャル・プランナー（以下「ＦＰ」という）の顧客に対する行為に関する次の記述のうち、関連法規および職業倫理に照らし、最も不適切なものはどれか。",
        "choice1": "社会保険労務士の登録を受けていないＦＰが、年金について相談に来た顧客の求めに応じ、公的年金の老齢給付を繰り上げた場合と繰り下げた場合の受給額について、それぞれの見込額を試算して説明した。",
        "choice2": "税理士の登録を受けていないＦＰが、個人事業主である顧客からの依頼に基づき、当該顧客が提出すべき確定申告書を無償で代理作成した。",
        "choice3": "金融商品取引業者の登録を受けていないＦＰが、資産運用の相談に来た顧客の求めに応じ、顧客の投資判断材料となる景気動向や企業業績に関する情報を提供した。",
        "choice4": "顧客から資産運用に関するセミナーの講師を依頼されたＦＰが、官公庁が作成した転載を禁止する旨の表示がない広報資料をインターネットで入手し、当該官公庁の許諾を得ることなく、セミナーのレジュメで出典を明記して使用した。 ",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1301,
        "shikenId": 22,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "健康保険に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "夫婦がともに被保険者である場合において、妻が出産したときは、所定の手続きにより、妻には出産育児一時金が支給され、夫には家族出産育児一時金が支給される。",
        "choice2": "１週間の所定労働時間または１ヵ月の所定労働時日数がその事業所に使用される通常の労働者（正社員）の４分の３未満である場合、健康保険の被保険者とならない。",
        "choice3": "全国健康保険協会管掌健康保険（協会けんぽ）の場合、一般保険料率は都道府県ごとに定められているのに対し、介護保険料率は全国一律である。 ",
        "choice4": "健康保険の被保険者資格を喪失した者で、喪失日の前日までに引き続き１ヵ月以上被保険者であった者は、所定の申出により、最長で２年間、健康保険の任意継続被保険者となることができる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1302,
        "shikenId": 22,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "労働者災害補償保険（以下「労災保険」という）に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "労災保険の適用を受ける労働者には、雇用形態がアルバイトやパートタイマーである者および日雇労働者や外国人労働者も含まれる。",
        "choice2": "労災指定病院で療養補償給付として受ける療養の給付については、労働者の一部負担金はない。",
        "choice3": "労働者が業務上の負傷または疾病による療養のため労働することができず、賃金を受けられない場合、賃金を受けられない日の第４日目から休業補償給付が支給される。",
        "choice4": "同一の事由により、障害厚生年金と労働者災害補償保険法に基づく障害補償年金が支給される場合、障害補償年金は全額支給され、障害厚生年金は所定の調整率により減額される。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1303,
        "shikenId": 22,
        "parentNo": 1,
        "no": 4,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "雇用保険に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "特定受給資格者等を除く一般の受給資格者に支給される基本手当の所定給付日数は、算定基礎期間が20年以上の場合、150日である。",
        "choice2": "基本手当日額の算定の基礎となる賃金日額は、原則として、離職の日以前６ヵ月間に支払われた賃金および賞与の総額を180で除して得た金額である。",
        "choice3": "育児休業給付金の額は、育児休業期間中に事業主から賃金が支払われなかった場合、育児休業開始日から通算して休業日数が180日に達する日までは休業開始時賃金日額に支給日数を乗じた額の67％相当額、180日を超えた日以降については50％相当額となる。",
        "choice4": "一般被保険者や高年齢被保険者が、要介護状態にある家族を介護するために休業する場合、同一の対象家族について、通算３回かつ93日の介護休業を限度として、介護休業給付金が支給される。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1304,
        "shikenId": 22,
        "parentNo": 1,
        "no": 5,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "公的年金に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "学生納付特例の承認を受けた期間に係る国民年金保険料のうち、追納することができる保険料は、追納に係る厚生労働大臣の承認を受けた日の属する月前10年以内の期間に係るものに限られる。",
        "choice2": "老齢厚生年金の繰上げ支給を請求する場合、老齢基礎年金の繰上げ支給の請求も同時に行わなければならない。",
        "choice3": "加給年金額が加算される老齢厚生年金について繰下げ支給の申出をする場合、加給年金額についても繰下げ支給による増額の対象となる。",
        "choice4": "65歳から老齢厚生年金を受給できる者が、63歳０ヵ月から繰上げ支給の請求をする場合、9.6％の減額率となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1305,
        "shikenId": 22,
        "parentNo": 1,
        "no": 6,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "障害給付および遺族給付に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "国民年金の被保険者ではない20歳未満の期間に初診日および障害認定日があり、20歳に達した日において障害等級1級または２級に該当する程度の障害の状態にある者に対しては、その者の前年の所得の額にかかわらず、障害基礎年金が支給される。",
        "choice2": "障害等級１級または２級に該当する程度の障害の状態にある障害厚生年金の受給権者が、18歳未満の子を有する場合、その障害厚生年金には子の加算額が加算される。",
        "choice3": "厚生年金保険の被保険者である夫が死亡し、子のない30歳未満の妻が遺族厚生年金の受給権を取得した場合、その妻に対する遺族厚生年金の支給期間は、最長で10年間である。",
        "choice4": "遺族厚生年金の年金額（中高齢寡婦加算額および経過的寡婦加算額を除く）は、原則として、死亡した者の厚生年金保険の被保険者記録を基に計算された老齢厚生年金の報酬比例部分の額の４分の３相当額である。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1306,
        "shikenId": 22,
        "parentNo": 1,
        "no": 7,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "公的年金等に係る税金に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "老齢基礎年金および老齢厚生年金の支払いの際に、所得税および復興特別所得税が源泉徴収される場合、その源泉徴収税率は10.21％である。",
        "choice2": "老齢基礎年金および老齢厚生年金の受給者が死亡した場合、その者に支給されるべき年金給付のうち、まだ支給されていなかったもの（未支給年金）は、相続税の課税対象となる。",
        "choice3": "老齢基礎年金を受給権発生日から数年後に請求し、遡及して数年分を一括して受給した場合、一括して受給した年金は、受給した年の一時所得として所得税の課税対象となる。",
        "choice4": "確定拠出年金の個人型年金の掛金を支払った場合、その全額を小規模企業共済等掛金控除として総所得金額等から控除することができる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1307,
        "shikenId": 22,
        "parentNo": 1,
        "no": 8,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "日本政策金融公庫の教育一般貸付（国の教育ローン）およびクレジットカード会社（貸金業者）が発行するクレジットカードに関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "国の教育ローンの金利は、固定金利または変動金利から選択することができる。",
        "choice2": "国の教育ローンを利用するためには、世帯年収（所得）が申込人の世帯で扶養している子の人数に応じて定められた額以下でなければならない。",
        "choice3": "クレジットカードで無担保借入（キャッシング）をする行為や商品を購入（ショッピング）する行為は、貸金業法上、総量規制の対象とならない。",
        "choice4": "クレジットカード会社が加盟する指定信用情報機関により管理されているクレジットカード会員の信用情報は、開示請求をすることができない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1308,
        "shikenId": 22,
        "parentNo": 1,
        "no": 9,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "住宅ローンの一般的な特徴等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "住宅ローンの返済方式では、借入額や返済期間等の他の条件が同一であれば、元金均等返済方式よりも元利均等返済方式の方が総返済額は多い。",
        "choice2": "住宅ローンの元利均等返済の利用を検討している者が借入額から年間返済額を試算する際、借入額に乗じる係数は、資本回収係数である。",
        "choice3": "住宅ローンの一部繰上げ返済をする場合、繰上げ返済額や金利等の他の条件が同一であれば、毎月の返済額を変更せずに返済期間を短縮する期間短縮型よりも、返済期間を変更せずに毎月の返済額を減らす返済額軽減型の方が、利息軽減効果が高くなる。",
        "choice4": "全期間固定金利型の住宅ローンに借り換えた場合、借換後の返済期間における市中金利の上昇によって返済負担が増加することはない。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1309,
        "shikenId": 22,
        "parentNo": 1,
        "no": 10,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "中小企業の資金調達方法の一般的な特徴および財務諸表に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "ＡＢＬ（アセット・ベースト・レンディング）は、企業が保有する売掛債権や在庫・機械設備等の資産を担保として金融機関から融資を受けて資金を調達する方法である。",
        "choice2": "第三者割当増資は、特定の既存株主に限定して新株引受権を与え、新たに株式を発行して資金を調達する方法である。",
        "choice3": "自己資本比率（％）は、「自己資本÷総資産×100」の算式で計算され、一般に、この数値が高い方が財務の健全性が高いと判断される。",
        "choice4": "固定長期適合率（％）は、「固定資産÷(自己資本＋固定負債)×100」の算式で計算され、一般に、この数値が低い方が財務の健全性が高いと判断される。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1310,
        "shikenId": 22,
        "parentNo": 1,
        "no": 11,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "生命保険の保険料等の一般的な仕組みに関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "保険料は、大数の法則および収支相等の原則に基づき、予定死亡率、予定利率および予定事業費率の３つの予定基礎率を用いて算定される。",
        "choice2": "保険料のうち、将来の保険金等の支払財源となる純保険料は、予定死亡率および予定利率に基づいて計算され、保険会社が保険契約を維持・管理していくために必要な経費等の財源となる付加保険料は、予定事業費率に基づいて計算される。",
        "choice3": "終身保険について、保険料の算定に用いられる予定利率が引き上げられた場合、新規契約の保険料は高くなる。",
        "choice4": "保険会社が実際に要した事業費が、保険料を算定する際に見込んでいた事業費よりも少なかった場合、費差益が生じる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1311,
        "shikenId": 22,
        "parentNo": 1,
        "no": 12,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "生命保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、記載のない特約については考慮しないものとする。",
        "choice1": "養老保険では、保険金の支払事由に該当せずに保険期間満了となった場合、死亡・高度障害保険金と同額の満期保険金を受け取ることができる。",
        "choice2": "変額保険（終身型）では、資産の運用実績に応じて死亡保険金額が変動するが、契約時に定めた保険金額（基本保険金額）は保証される。",
        "choice3": "外貨建て個人年金保険では、円換算支払特約を付加することで、契約時点の為替レートで円換算した年金を受け取ることができる。",
        "choice4": "ヒューマン・ヴァリュー特約を付加した場合、当該特約の死亡保険金受取人は法人となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1312,
        "shikenId": 22,
        "parentNo": 1,
        "no": 13,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "個人年金保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "保証期間付終身年金では、被保険者の性別以外の契約条件が同一である場合、保険料は男性の方が女性よりも高くなる。",
        "choice2": "確定年金では、年金受取期間中に被保険者が死亡した場合、死亡保険金受取人が契約時に定められた基本年金額の受取総額から既に支払われた分を除いた未払い分を受け取ることができる。",
        "choice3": "確定年金では、年金に替えて一時金で受け取ることもできるが、一時金で受け取る場合の受取額は、年金形式で受け取る場合の受取総額よりも少なくなる。",
        "choice4": "生存保障重視型の個人年金保険では、他の契約条件が同一で生存保障重視型ではない個人年金保険と比較して、保険料払込期間中の死亡給付金や解約返戻金の額が低く設定され、将来受け取る年金額が高く設定されている。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1313,
        "shikenId": 22,
        "parentNo": 1,
        "no": 14,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "生命保険の税金に関する次の記述のうち、最も適切なものはどれか。なお、各選択肢において、ほかに必要とされる要件等はすべて満たしているものとする。",
        "choice1": "2011年以前に契約した終身保険（旧制度の対象）の生命保険料が10万円、2012年以降に契約した終身保険（新制度の対象）の生命保険料が８万円である場合、その年の一般の生命保険料控除は５万円である。",
        "choice2": "少額短期保険の保険料は、その保険契約が被保険者の死亡時に死亡保険金が支払われるものである場合、一般の生命保険料控除の対象となる。",
        "choice3": "契約者と被保険者が同一人である養老保険において、相続人でない者が受け取った死亡保険金は贈与税の課税対象になる。",
        "choice4": "契約者が夫、年金受取人が妻である個人年金保険において、妻が受け取る年金の年金受給権は、所得税における雑所得の課税対象となる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1314,
        "shikenId": 22,
        "parentNo": 1,
        "no": 15,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "契約者（＝保険料負担者）を法人とする生命保険契約の経理処理に関する次の記述のうち、最も不適切なものはどれか。なお、いずれの保険契約も保険料は年払いかつ全期払いで、2025年４月に締結したものとする。",
        "choice1": "被保険者が役員、死亡保険金受取人が法人で、最高解約返戻率が60％である定期保険（保険期間30年、年払保険料100万円）の支払保険料は、保険期間の前半４割相当期間においては、その40％相当額を資産に計上し、残額を損金の額に算入することができる。",
        "choice2": "被保険者が役員、死亡保険金受取人が法人である終身保険の支払保険料は、その全額を損金の額に算入することができる。",
        "choice3": "被保険者が従業員、給付金受取人が法人である解約返戻金のない医療保険の支払保険料は、その全額を損金の額に算入することができる。",
        "choice4": "被保険者が役員および従業員全員、死亡保険金受取人が被保険者の遺族、満期保険金受取人が法人である養老保険の支払保険料は、その２分の１相当額を資産に計上し、残額を損金の額に算入することができる。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1315,
        "shikenId": 22,
        "parentNo": 1,
        "no": 16,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "任意加入の自動車保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、記載のない特約については考慮しないものとする。",
        "choice1": "記名被保険者が被保険自動車を運転中に対人事故を起こし、法律上の損害賠償責任を負担する場合、自動車損害賠償責任保険等により補償される部分を除いた額が、対人賠償保険の補償の対象となる。",
        "choice2": "記名被保険者が被保険自動車を運転中に、ハンドル操作を誤って通行人が連れていたペットの犬に接触してケガをさせ、法律上の損害賠償責任を負った場合、対物賠償保険の補償の対象となる。",
        "choice3": "被保険自動車が豪雨による洪水で水没して被った損害は、一般条件の車両保険の補償の対象となる。",
        "choice4": "自動車保険のノンフリート等級別料率制度では、対人賠償保険や対物賠償保険の保険金が支払われる場合、１等級ダウン事故となる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1316,
        "shikenId": 22,
        "parentNo": 1,
        "no": 17,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "地震保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、記載のない特約については考慮しないものとする。",
        "choice1": "保険金額は、主契約である火災保険の保険金額の30％から50％の範囲内で設定し、その限度額は住宅建物が5,000万円、家財（生活用動産）が1,200万円である。",
        "choice2": "地震保険では、地震が発生した日の翌日から10日以上経過した後に生じた損害は、補償の対象とならない。",
        "choice3": "地震保険には、「建築年割引」 「免震建築物割引」 「耐震等級割引」 「耐震診断割引」の保険料割引制度があり、最大割引率は50％である。",
        "choice4": "地震保険は、火災保険の契約時だけでなく、火災保険の保険期間中に付帯することもできる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1317,
        "shikenId": 22,
        "parentNo": 1,
        "no": 18,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "法人を契約者（＝保険料負担者）とする損害保険に係る保険料等の経理処理に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "業務中の事故によりケガを負うリスクに備えて、すべての役員・従業員を被保険者および保険金受取人とする普通傷害保険に加入した場合、その支払った保険料の全額を損金の額に算入することができる。",
        "choice2": "従業員が法人の所有する自動車で対人事故を起こし、その相手方に保険会社から自動車保険の対人賠償保険の保険金が直接支払われた場合、法人は当該保険金相当額を益金の額に算入する。",
        "choice3": "法人が所有する業務用自動車が交通事故で全損となり、受け取った自動車保険の車両保険金で同一事業年度中に代替車両を取得した場合であっても、圧縮記帳は認められない。",
        "choice4": "火災により倉庫を焼失するリスクに備えて、保険期間５年の火災保険に加入し、５年分の保険料を一括で支払った場合、その事業年度に、支払った保険料の全額を損金の額に算入することができる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1318,
        "shikenId": 22,
        "parentNo": 1,
        "no": 19,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "第三分野の保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "人間ドックを受診して異常が発見され、医師の指示の下でその治療を目的として入院した場合、その入院は医療保険の入院給付金の支払対象となる。",
        "choice2": "更新型の医療保険では、保険期間中に入院給付金を受け取った場合、保険契約を更新することができない。",
        "choice3": "限定告知型の医療保険は、他の契約条件が同一で、限定告知型ではない一般の医療保険と比較した場合、保険料は割安となる。",
        "choice4": "先進医療特約で先進医療給付金の支払対象とされている先進医療は、契約時点において厚生労働大臣によって定められているものである。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1319,
        "shikenId": 22,
        "parentNo": 1,
        "no": 20,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "法人の生命保険および損害保険等の活用に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "従業員の自助努力による死亡保障の準備を支援するために、従業員に団体信用生命保険の契約を勧めた。",
        "choice2": "建設業を営む事業者が、業務中の事故で従業員が負傷して労働者災害補償保険（政府労災保険）の対象とならなかった場合に備えて、労働災害総合保険（法定外補償）を契約した。",
        "choice3": "金属製品製造業を営む事業者が、工場内に設置した機械設備が火災により損害を被るリスクに備えて、機械保険を契約した。",
        "choice4": "食品製造業を営む事業者が、製造した食品が原因で食中毒を発生させ、法律上の損害賠償責任を負うリスクに備えて、生産物賠償責任保険（ＰＬ保険）を契約した。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1320,
        "shikenId": 22,
        "parentNo": 1,
        "no": 21,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "景気指標や為替相場および金利の変動要因等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "コンポジット・インデックス（ＣＩ）は、採用系列の各月の値を３ヵ月前と比べた変化の方向を合成して作成した指数であり、景気拡張の動きの各経済部門への波及度合いの測定を主な目的としている。",
        "choice2": "一般的に、デフレーション期には、実質ＧＤＰの方が名目ＧＤＰより低くなる傾向がある。",
        "choice3": "東証株価指数は、景気動向指数の一致系列に分類されている。",
        "choice4": "日本の物価が米国と比較して相対的に上昇することは、一般に円安米ドル高の要因となる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1321,
        "shikenId": 22,
        "parentNo": 1,
        "no": 22,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "銀行等の金融機関で取り扱う預金の一般的な商品性等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "スーパー定期預金は、預入期間が３年以上の場合、単利型と半年複利型があるが、半年複利型を利用することができるのは法人に限られる。",
        "choice2": "期日指定定期預金は、据置期間経過後から最長預入期日までの間で、金融機関が指定した日が満期日となる。",
        "choice3": "貯蓄預金は、給与、年金等の自動受取口座や公共料金等の自動振替口座に指定することができる。",
        "choice4": "オプション取引などのデリバティブを組み込んだ仕組預金には、金融機関の判断によって満期日が繰り上がるものがある。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1322,
        "shikenId": 22,
        "parentNo": 1,
        "no": 23,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "各種信託商品および運用手法に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "運用管理費用（信託報酬）は投資信託の銘柄ごとに定められており、一般に、インデックス型投資信託よりもアクティブ型投資信託の方が高い傾向がある。",
        "choice2": "株式投資信託の運用において、割高な銘柄の買建てと割安な銘柄の売建てをそれぞれ同程度の金額で行い、市場全体の変動に左右されない収益の確保を目指す手法を、マーケット・ニュートラル運用という。",
        "choice3": "上場投資信託（ＥＴＦ）および上場不動産投資信託（Ｊ－ＲＥＩＴ）を証券取引所の立会時間中に売買する場合、成行注文や指値注文が可能である。",
        "choice4": "遺言信託により遺言書を信託銀行等に預けた場合、手数料を支払うことで遺言書の内容を変更することができる。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1323,
        "shikenId": 22,
        "parentNo": 1,
        "no": 24,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "下記＜資料＞の債券を取得日から４年後に売却した場合における所有期間利回り（単利・年率）を計算しなさい。なお、手数料や税金等については考慮しないものとし、計算結果については小数点以下第４位を四捨五入すること。<br><br><img src=\"/img/question/2508fp2/g24.png\" class=\"question-img_gakka\" />",
        "choice1": "0.441％ ",
        "choice2": "0.445％",
        "choice3": "0.446％",
        "choice4": "0.448％",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1324,
        "shikenId": 22,
        "parentNo": 1,
        "no": 25,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "債券のデュレーションに関する次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><br><img src=\"/img/question/2508fp2/g25.png\" class=\"question-img_gakka\" />",
        "choice1": "（ア）短く （イ）と等しくなる",
        "choice2": "（ア）長く （イ）よりも短くなる",
        "choice3": "（ア）短く （イ）よりも短くなる",
        "choice4": "（ア）長く （イ）と等しくなる",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1325,
        "shikenId": 22,
        "parentNo": 1,
        "no": 26,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "株式投資に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "証券取引所の立会取引における上場株式の売買注文では、成行注文より指値注文が優先される。",
        "choice2": "ＪＰＸ日経インデックス400は、プライム市場、スタンダード市場、グロース市場を主市場とする普通株式の中から、ＲＯＥや営業利益等の指標等により選定された400銘柄を対象として算出される。",
        "choice3": "グロース市場に上場している銘柄であっても、プライム市場における新規上場基準と同様の基準を満たせば、所定の手続きにより、プライム市場に市場区分を変更することができる。",
        "choice4": "金融商品取引法等によれば、原則として、株式の信用取引を行う際の委託保証金の額は30万円以上で、かつ、株式の約定金額に100分の30を乗じた金額以上でなければならないとされている。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1326,
        "shikenId": 22,
        "parentNo": 1,
        "no": 27,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "外貨建て預金に関する次の記述の空欄（ア）～（エ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><br><img src=\"/img/question/2508fp2/g27.png\" class=\"question-img_gakka\" />",
        "choice1": "（ア）ＴＴＳ （イ）5.78 （ウ）下落 （エ）一時",
        "choice2": "（ア）ＴＴＳ （イ）7.33 （ウ）上昇 （エ）一時",
        "choice3": "（ア）ＴＴＢ （イ）5.78 （ウ）上昇 （エ）雑",
        "choice4": "（ア）ＴＴＢ （イ）7.33 （ウ）下落 （エ）雑",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1327,
        "shikenId": 22,
        "parentNo": 1,
        "no": 28,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "ポートフォリオ理論に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "ポートフォリオの期待収益率は、組み入れた各資産の期待収益率を単純平均した値となる。",
        "choice2": "異なる２資産からなるポートフォリオにおいて、２資産間の相関係数が－１である場合、ポートフォリオを組成することによる分散投資の効果（リスクの低減）は得られない。",
        "choice3": "ポートフォリオのリスクのうち、分散投資によって消去可能なリスクをシステマティック・リスクという。 ",
        "choice4": "同一期間における収益率が同じ２つのファンドをシャープ・レシオで比較する場合、収益率の標準偏差の値が小さいファンドの方が、収益率の標準偏差の値が大きいファンドよりも当該期間において効率的に運用されていたと評価することができる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1328,
        "shikenId": 22,
        "parentNo": 1,
        "no": 29,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "ＮＩＳＡに関する下表の空欄（ア）～（エ）にあてはまる数値の組み合わせとして、最も適切なものはどれか。なお、問題の都合上、一部を「＊＊＊」としている。<br><br><img src=\"/img/question/2508fp2/g29.png\" class=\"question-img_gakka\" />",
        "choice1": "（ア）18 （イ） 80 （ウ）20年 （エ）1,800",
        "choice2": "（ア）18 （イ）120 （ウ）無制限 （エ）1,800",
        "choice3": "（ア）20 （イ） 80 （ウ）無制限 （エ）2,000",
        "choice4": "（ア）20 （イ）120 （ウ）20年 （エ）2,000",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1329,
        "shikenId": 22,
        "parentNo": 1,
        "no": 30,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "金融商品の取引等に係る各種法令や制度に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、「金融サービスの提供及び利用環境の整備等に関する法律」を金融サービス提供法という。",
        "choice1": "預金保険制度において、国内にある銀行の国内支店に預け入れている決済用預金は、1,000万円とその利息までが保護される。",
        "choice2": "金融機関同士が合併した場合、合併存続金融機関において、預金保険制度による保護の対象となる預金の額は、合併後１年間に限り、全額保護される預金を除き、預金者１人当たり1,300万円とその利息等となる。",
        "choice3": "消費者契約法では、事業者の不適切な行為によって、消費者が誤認や困惑をし、それによって消費者契約の申込みまたはその承諾の意思表示をした場合、消費者は、当該契約によって生じた損害について賠償を請求することができるとされている。",
        "choice4": "金融サービス提供法では、金融商品販売業者等は、業として行う金融商品の販売等に係る勧誘をしようとするときは、原則として、あらかじめ勧誘方針を策定して公表することが義務付けられている。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1330,
        "shikenId": 22,
        "parentNo": 1,
        "no": 31,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "わが国の税制に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "法人税は直接税に該当し、消費税は間接税に該当する。",
        "choice2": "所得税の各種所得の金額の計算上、収入金額には、原則として、その年において収入すべきことが確定した金額から、未収入の金額を控除した額を計上する。",
        "choice3": "所得税における非永住者以外の居住者の課税所得には、日本国内で生じた所得だけでなく、日本国外で生じた所得も含まれる。",
        "choice4": "相続税では、納税者本人の申告により納付すべき税額が確定し、この確定した税額を納付する申告納税制度が採用されている。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1331,
        "shikenId": 22,
        "parentNo": 1,
        "no": 32,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税における各種所得に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "会社員が住宅購入のために勤務先から無利息で金銭を借り入れたことにより生じた経済的利益は、給与所得となる。",
        "choice2": "個人による不動産の貸付けが事業的規模である場合、その賃貸収入による所得は、不動産所得に該当する。",
        "choice3": "退職一時金を受け取った退職者が、「退職所得の受給に関する申告書」を提出している場合、所得税および復興特別所得税として、退職一時金の支給額の20.42％が源泉徴収される。",
        "choice4": "専業主婦が金地金を売却したことによる所得は、原則として、譲渡所得として総合課税の対象となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1332,
        "shikenId": 22,
        "parentNo": 1,
        "no": 33,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "Ａさんの当年分の所得の金額が以下のとおりであった場合の所得税における総所得金額として、最も適切なものはどれか。なお、▲が付された所得の金額は、その所得に損失が発生していることを意味するものとする。<br><br><img src=\"/img/question/2508fp2/g33.png\" class=\"question-img_gakka\" />",
        "choice1": "410万円",
        "choice2": "510万円",
        "choice3": "560万円",
        "choice4": "660万円",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1333,
        "shikenId": 22,
        "parentNo": 1,
        "no": 34,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税における各種所得控除に関する次の記述のうち、最も不適切なものはどれか。なお、各選択肢において、ほかに必要とされる要件等はすべて満たしているものとする。",
        "choice1": "納税者との婚姻の届出をしていない、いわゆる内縁関係にあると認められる者でも、納税者が加入している健康保険の被扶養者となっている場合は、控除対象配偶者に該当する。",
        "choice2": "夫と離婚した後に婚姻をしていない納税者は、納税者と事実上婚姻関係と同様の事情にあると認められる一定の者がいる場合、寡婦控除の適用を受けることができない。",
        "choice3": "控除対象扶養親族のうち、その年の12月31日現在の年齢が19歳以上23歳未満の者は、特定定扶養親族に該当する。",
        "choice4": "納税者が有する生活に必要な資産について、災害、盗難または横領によって一定の損失が生じた場合、雑損控除の適用を受けることができる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1334,
        "shikenId": 22,
        "parentNo": 1,
        "no": 35,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税における配当控除に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "内国法人から支払を受ける上場株式の配当で、確定申告において総合課税または申告分離課税を選択した配当所得については、配当控除の適用を受けることができる。",
        "choice2": "内国法人から支払を受ける非上場株式の配当に係る配当所得は、配当控除の適用を受けることができない。",
        "choice3": "総所得金額の計算にあたって配当所得の金額と他の所得の金額を損益通算した場合、配当控除の控除額を計算する際の配当所得の金額は、損益通算する前の配当所得の金額によることとなる。",
        "choice4": "配当控除の控除額を計算する際の配当所得の金額は、株式等を取得するために要した負債の利子がある場合、配当金額から当該負債の利子の額を控除する前の金額である。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1335,
        "shikenId": 22,
        "parentNo": 1,
        "no": 36,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税の申告と納付等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "年の中途で死亡した者のその年分の所得税について確定申告を要する場合、その相続人は、原則として、相続の開始があったことを知った日の翌日から６ヵ月以内に、当該所得税について確定申告書を提出しなければならない。",
        "choice2": "年間の給与収入の金額が2,000万円を超える給与所得者は、年末調整の対象とならないため、確定申告を行わなければならない。",
        "choice3": "給与所得者が、医療費控除の適用を受けることにより、給与から源泉徴収された税金の還付を受けようとする場合、納税地の所轄税務署長に確定申告書を提出する必要がある。",
        "choice4": "老齢基礎年金および老齢厚生年金を合計で年額350万円受給し、それ以外の所得が原稿料に係る雑所得の金額20万円のみである者は、確定申告を行う必要はない。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1336,
        "shikenId": 22,
        "parentNo": 1,
        "no": 37,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "法人税に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "法人税の納税地に異動があった場合、原則として、異動後の納税地の所轄税務署長にその旨を届け出なければならない。",
        "choice2": "新設法人が設立事業年度から青色申告の適用を受けようとする場合は、設立から３ヵ月を経過した日と事業年度終了日のいずれか早い日の前日までに、「青色申告の承認申請書」を納税地の所轄税務署長に提出し、その承認を受けなければならない。",
        "choice3": "期末資本金の額等が１億円以下の一定の中小法人に対する法人税の税率は、所得金額が年間10億円以下である場合、所得金額のうち年800万円超の部分については23.2％、800万円以下の部分については15％が適用される。",
        "choice4": "取得価格10万円未満または使用可能期間が１年未満の減価償却資産については、原則として、事業の用に供した事業年度において、その取得価額の全額を損金に算入することができる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1337,
        "shikenId": 22,
        "parentNo": 1,
        "no": 38,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "消費税に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "消費税の課税期間に係る基準期間は、個人事業者についてはその年の前々年である。",
        "choice2": "簡易課税制度の適用を受けることができる事業者は、消費税の課税期間に係る基準期間における課税売上高が5,000万円以下の事業者である。",
        "choice3": "消費税の課税事業者である個人事業者は、原則として、消費税の確定申告書を課税期間の翌年３月31日までに納税地の所轄税務署長に提出しなければならない。",
        "choice4": "消費税の免税事業者が「消費税課税事業者選択届出書」を提出して消費税の課税事業者となったときは、事業を廃止した場合を除き、原則として３年間は消費税の免税事業者に戻ることができない。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1338,
        "shikenId": 22,
        "parentNo": 1,
        "no": 39,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "会社と役員間の取引に係る所得税・法人税に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "役員が所有する土地を適正な時価の２分の１未満の価額で会社に譲渡した場合、その役員は、適正な時価の２分の１に相当する金額により当該土地を譲渡したものとして譲渡所得の計算を行う。",
        "choice2": "役員が会社の所有する社宅に無償で居住している場合、原則として、通常の賃貸料相当額が、その役員の給与所得の収入金額に算入される。",
        "choice3": "会社が役員に対して無利息で金銭の貸付けを行った場合、原則として、通常収受すべき利息に相当する金額が、その会社の所得金額の計算上、益金の額に算入される。",
        "choice4": "会社が役員からの借入金について債務免除を受けた場合、その債務免除を受けた金額が、その会社の所得金額の計算上、益金の額に算入される。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1339,
        "shikenId": 22,
        "parentNo": 1,
        "no": 40,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "財務諸表に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "損益計算書は、企業の資金の調達源泉とその用途を示したものである。",
        "choice2": "損益計算書において、経常利益の額は、売上総利益の額から販売費及び一般管理費の額を差し引いた額である。",
        "choice3": "貸借対照表において、純資産の部の合計額がマイナスになることはない。",
        "choice4": "「短期借入金の減少」 「配当金の支給」はいずれも財務活動によるキャッシュ・フローが減少する要因になる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1340,
        "shikenId": 22,
        "parentNo": 1,
        "no": 41,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産の鑑定評価の手法や登記に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "不動産の価格を求める鑑定評価の基本的な手法は、原価法、取引事例比較法および収益還元法に大別され、鑑定評価に当たっては、対象不動産に係る市場の特性等を考慮し、これらのうち最も適した１つの手法に限定して適用することとされている。",
        "choice2": "原価法は、市場において発生した取引事例を価格判定の基礎とする手法であり、その適用に当たっては多数の取引事例を収集する必要がある。",
        "choice3": "不動産の登記記録は、当該不動産の所在地である市区町村の役所や役場に備えられている。",
        "choice4": "抵当権の登記の登記事項は、不動産の登記記録の権利部乙区に記録される。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1341,
        "shikenId": 22,
        "parentNo": 1,
        "no": 42,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "宅地建物取引業法に関する次の記述のうち、最も不適切なものはどれか。なお、買主は宅地建物取引業者ではないものとする。",
        "choice1": "宅地建物取引業者が、自ら売主となる宅地の売買契約の締結に際して手付を受領したときは、その手付がいかなる性質のものであっても、買主が契約の履行に着手する前であれば、当該宅地建物取引業者はその倍額を現実に提供して、契約の解除をすることができる。",
        "choice2": "宅地建物取引業者は、自ら売主となる宅地の売買契約の締結に際して、代金の額の10分の２を超える額の手付を受領することができない。",
        "choice3": "専任媒介契約の有効期間は、３ヵ月を超えることができず、これより長い期間を定めたときは、当該媒介契約は無効となる。",
        "choice4": "宅地建物取引業者は、宅地建物取引士をして、宅地または建物の売買契約の締結前に、買主に重要事項説明書の交付および説明をしなければならない。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1342,
        "shikenId": 22,
        "parentNo": 1,
        "no": 43,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産売買の契約に係る民法の規定に関する次の記述のうち、最も不適切なものはどれか。なお、特約については考慮しないものとする。",
        "choice1": "同一の不動産について二重に売買契約が締結された場合、譲受人相互間においては、売買契約の締結の先後にかかわらず、原則として、所有権移転登記を先にした者が当該不動産の所有者となる。",
        "choice2": "不動産が共有されている場合に、各共有者が、自己の有している持分を第三者に譲渡するときは、他の共有者の同意を得る必要はない。",
        "choice3": "売買の目的物である建物が、その売買契約の締結から当該建物の引渡しまでの間に、地震により全壊した場合、買主は、売主に対して建物代金の支払いを拒むことができる。",
        "choice4": "売主が種類または品質に関して契約の内容に適合しない目的物を買主に引き渡した場合において、買主がその不適合を知った時から１年以内にその旨を売主に通知しないときは、売主が引渡しの時にその不適合を知っていたとしても、買主は、その不適合を理由として契約の解除をすることができない。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1343,
        "shikenId": 22,
        "parentNo": 1,
        "no": 44,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産の賃貸借に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "賃借人が適法に土地を転貸し、その後、賃貸人が賃借人との間の賃貸借を合意により解除した場合、その解除の当時、賃借人の債務不履行による解除権を有していたとしても、その合意解除をもって、転借人に対抗することはできない。",
        "choice2": "賃借人は、建物の引渡しを受けた後の通常の使用および収益によって生じた建物の損耗ならびに経年変化については、賃貸借が終了したときに原状に復する義務を負わない。",
        "choice3": "建物の賃借人は、賃貸借の目的となっている建物の改良のために工事費用を支出した場合、賃借人は、賃貸借の終了の時に当該建物の価値の増加が現存するときは、賃借人の選択に従い、その支出した費用金額又は増加した価額を償還させることができる。",
        "choice4": "建物の賃貸借期間中に、賃借人から敷金を受け取っている賃貸人が建物を譲渡し、賃貸人たる地位が建物の譲受人に移転した場合、その敷金の返還に係る債務は、建物の譲受人に承継される。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1344,
        "shikenId": 22,
        "parentNo": 1,
        "no": 45,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "借地借家法に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、同法第22条の借地権を一般定期借地権といい、第22条から第24条の定期借地権等以外の借地権を普通借地権という。",
        "choice1": "普通借地権の存続期間は30年とされており、契約でこれより長い期間を定めることはできない。",
        "choice2": "普通借地権の存続期間が満了する場合において、借地権者が契約の更新を請求し、借地権設定者に更新を拒絶する正当の事由がないときは、借地上に建物があるかどうかにかかわらず、従前の契約と同一の条件で契約を更新したものとみなされる。",
        "choice3": "一般定期借地権において、契約の更新および建物の築造による存続期間の延長がなく、建物等の買取りの請求をしないこととする旨を定める特約は、公正証書によってしなければならない。",
        "choice4": "一般定期借地権の存続期間は、50年以上としなければならない。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1345,
        "shikenId": 22,
        "parentNo": 1,
        "no": 46,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "都市計画法に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "すべての都市計画区域において、都市計画に市街化区域と市街化調整区域の区域区分を定めなければならない。",
        "choice2": "市街化調整区域は、すでに市街地を形成している区域およびおおむね10年以内に優先的かつ計画的に市街化を図るべき区域とされている。",
        "choice3": "市街化調整区域内において、農業を営む者の居住の用に供する建築物の建築を目的として行う開発行為は、開発許可を受ける必要がある。",
        "choice4": "開発許可を受けた開発区域内の土地においては、開発工事完了の公告があるまでの間は、原則として、建築物を建築することができない。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1346,
        "shikenId": 22,
        "parentNo": 1,
        "no": 47,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "都市計画区域および準都市計画区域内における建築基準法の規定に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "建築基準法第42条第２項により道路境界線とみなされる線と道路との間の敷地の部分（セットバック部分）は、建築物を建築することができず、建蔽率および容積率を算定する際の敷地面積に算入することもできない。",
        "choice2": "都市計画区域内において、用途地域が定められている区域については、防火地域または準防火地域のいずれかを定めなければならない。",
        "choice3": "敷地の前面道路の幅員が12ｍ未満である建築物の容積率は、原則として、「都市計画で定められた容積率」と「前面道路の幅員に一定の数値を乗じて得たもの」とのいずれか低い方が上限となる。",
        "choice4": "建築物の高さに係る隣地斜線制限は、第一種低層住居専用地域、第二種低層住居専用地域および田園住居地域には適用されない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1347,
        "shikenId": 22,
        "parentNo": 1,
        "no": 48,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "建物の区分所有等に関する法律に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "管理者は、少なくとも毎年１回、集会を招集しなければならない。",
        "choice2": "集会の決議は、原則として、当該決議後に区分所有権を譲り受けた者に対して、その効力を有しない。",
        "choice3": "区分所有者は、敷地利用権が数人で有する所有権である場合、規約に別段の定めがない限り、敷地利用権を専有部分と分離して処分することができない。",
        "choice4": "専有部分が数人の共有に属するときは、共有者は、議決権を行使すべき者１人を定めなければならない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1348,
        "shikenId": 22,
        "parentNo": 1,
        "no": 49,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産に係る各種税金に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "特定遺贈により相続人以外の者が取得した場合は、当該取得に対して不動産取得税が課される。",
        "choice2": "一定の要件を満たす戸建て住宅（認定長期優良住宅を除く）を新築した場合、不動産取得税の課税標準の算定に当たっては、１戸につき最高1,000万円を価格から控除することができる。 ",
        "choice3": "所有権移転登記に係る登録免許税の税率は、登記原因が贈与による場合と相続による場合とでは異なる。",
        "choice4": "都市計画税の税率は各地方自治体の条例で定められるが、制限税率である0.3％を超えることはできない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1349,
        "shikenId": 22,
        "parentNo": 1,
        "no": 50,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産の有効活用の手法の一般的な特徴に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "事業受託方式は、土地の有効活用の企画、建設会社の選定や当該土地上に建設された建物の管理・運営等をデベロッパーに任せ、建設資金の調達や返済は土地所有者が行う方式である。",
        "choice2": "等価交換方式における全部譲渡方式は、土地所有者がいったん土地の全部をデベロッパーに譲渡し、その対価としてその土地上にデベロッパーが建設した建物およびその土地の一部を譲り受ける方式である。",
        "choice3": "定期借地権方式では、土地所有者が自己の土地上に建設される建物の所有名義人となり、当該土地と建物を一定期間貸し付けることにより地代・賃料収入を得ることができる。",
        "choice4": "建設協力金方式は、土地所有者が建設する建物を貸し付ける予定のテナント等から、建設費相当額の全部または一部を借り受けて建物を建設する方式である。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1350,
        "shikenId": 22,
        "parentNo": 1,
        "no": 51,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "民法上の贈与に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "書面によらない贈与は、その履行の終わった部分についても、各当事者が解除をすることができる。",
        "choice2": "死因贈与では、民法の遺贈に関する規定が準用され、贈与者の一方的な意思表示により成立し、贈与者の死亡によってその効力を生じる。",
        "choice3": "負担付贈与とは、贈与者が受贈者に対して一定の債務を負担させることを条件とする贈与をいい、その受贈者の負担により利益を受ける者は贈与者に限られない。",
        "choice4": "離婚による財産分与により財産を取得した場合には、その価額が婚姻中の夫婦の協力によって得た財産の額等の事情を考慮して社会通念上相当な範囲内であったとしても、その取得した財産は、原則として贈与により取得したものとみなされ、贈与税の課税対象となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1351,
        "shikenId": 22,
        "parentNo": 1,
        "no": 52,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "贈与税の計算に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "子が同一年中に父母のそれぞれから贈与を受けた場合、同年分の子の暦年課税に係る贈与税額の計算上、贈与税の課税価格から控除する基礎控除額は、220万円である。",
        "choice2": "相続時精算課税に係る贈与税額の計算上、2024年１月１日以後に贈与により取得した財産については、贈与税の課税価格から各年基礎控除額を控除することができる。",
        "choice3": "相続時精算課税制度の適用を受けた贈与財産に係る贈与税額の計算上、適用される税率は、一律25％である。",
        "choice4": "贈与税の配偶者控除を受けるためには、贈与者である配偶者との婚姻期間が贈与を受けた日が属する年の１月１日時点において20年以上でなければならない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1352,
        "shikenId": 22,
        "parentNo": 1,
        "no": 53,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "贈与税の申告と納付に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "贈与税の申告書は、原則として、贈与を受けた年の翌年２月１日から３月15日までの間に、贈与者の納税地の所轄税務署長に提出しなければならない。",
        "choice2": "国税電子申告・納税システム（ｅ－Ｔａｘ）は、贈与税の申告に対応している。",
        "choice3": "贈与税の納付について認められる延納期間は、最長10年である。",
        "choice4": "贈与税の納付について、延納によっても納付することが困難とする事由がある場合、その納付を困難とする金額を限度として物納を申請することができる。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1353,
        "shikenId": 22,
        "parentNo": 1,
        "no": 54,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "親族等に係る民法の規定に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "親族の範囲は、６親等内の血族、配偶者、３親等内の姻族である。",
        "choice2": "兄弟姉妹の子（甥や姪）は、３親等の血族である。",
        "choice3": "相続人が被相続人の子である場合、実子と養子の法定相続分は同じであるが、嫡出でない子の法定相続分は、嫡出子の法定相続分の２分の１である。",
        "choice4": "父母の一方のみを同じくする兄弟姉妹の法定相続分は、父母の双方を同じくする兄弟姉妹の法定相続分の２分の１である。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1354,
        "shikenId": 22,
        "parentNo": 1,
        "no": 55,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "遺言に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "遺言は、満18歳以上の者でなければすることができない。",
        "choice2": "遺言によって認知をすることができる。",
        "choice3": "公正証書遺言を作成した遺言者は、その遺言を自筆証書による遺言によって撤回することができる。",
        "choice4": "遺言者が、公証役場にて公正証書遺言を作成する際に、信託銀行の従業員は、欠格事由に該当しない限り、証人になることができる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1355,
        "shikenId": 22,
        "parentNo": 1,
        "no": 56,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "相続税の計算に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "遺産に係る基礎控除額の計算上、被相続人に実子がいる場合は、法定相続人の数に含めることができる普通養子の数は、１人までである。",
        "choice2": "遺産に係る基礎控除額の計算上、法定相続人の数は、相続人が相続の放棄をした場合には、その放棄がなかったものとした場合における相続人の数である。",
        "choice3": "遺産に係る基礎控除額は「5,000万円＋600万円×法定相続人の数」の算式により計算した金額である。",
        "choice4": "死亡保険金受取人が相続の放棄をした場合、死亡保険金を受け取ることはできるが、相続税額の計算上、死亡保険金の非課税金額の規定の適用を受けることはできない。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1356,
        "shikenId": 22,
        "parentNo": 1,
        "no": 57,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "相続税の申告と納付に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "相続税の申告書の提出は、原則として、相続の開始があったことを知った日の翌日から６ヵ月以内にしなければならない。",
        "choice2": "相続人となるべき被相続人の子がすでに死亡しているため、その死亡した子を代襲して相続人となった被相続人の孫は、相続税額の２割加算の対象者とならない。",
        "choice3": "「配偶者に対する相続税額の軽減」の適用を受けることにより納付すべき相続税額が０（ゼロ）となる場合、相続税の申告書を提出する必要はない。",
        "choice4": "相続により土地を取得した相続人が、その相続に係る相続税について延納を申請し、担保を必要とする場合、相続人が相続開始以前から所有していた財産および第三者の財産は延納の担保として提供することができない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1357,
        "shikenId": 22,
        "parentNo": 1,
        "no": 58,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "相続税における財産評価に関する次の記述のうち、最も適切なものはどれか。なお、評価の対象となる株式は、取引相場のない株式であり、特定の評価会社の株式には該当しないものとする。",
        "choice1": "宅地の評価において、倍率方式は、固定資産税評価額に国税局長が一定の地域ごとに定める倍率を乗じて計算した金額によって評価する方式である。",
        "choice2": "会社規模が小会社である会社において、中心的な同族株主が取得した株式の価額は、原則として、類似業種比準方式によって評価する。",
        "choice3": "類似業種比準価額を計算する場合の類似業種の株価は、課税時期の属する月以前３ヵ月間の各月の類似業種の株価のうち最も低いものとするが、納税義務者の選択により、類似業種の前年平均株価または課税時期の属する月以前５年間の平均株価によることができる。",
        "choice4": "外貨預金の邦貨換算は、原則として、取引金融機関が公表する課税時期における最終の対顧客直物電信売相場（ＴＴＳ）による。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1358,
        "shikenId": 22,
        "parentNo": 1,
        "no": 59,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "「小規模宅地等についての相続税の課税価格の計算の特例」（以下、「本特例」という）に関する次の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、宅地等の適用面積の調整は考慮しないものとする。なお、問題の都合上一部を＊＊＊としている。<br><br><img src=\"/img/question/2508fp2/g59.png\" class=\"question-img_gakka\" />",
        "choice1": "（ア）400㎡ （イ）80％ （ウ）200㎡",
        "choice2": "（ア）400㎡ （イ）50％ （ウ）330㎡",
        "choice3": "（ア）330㎡ （イ）80％ （ウ）330㎡",
        "choice4": "（ア）330㎡ （イ）50％ （ウ）200㎡",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1359,
        "shikenId": 22,
        "parentNo": 1,
        "no": 60,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "非上場企業の事業承継対策等に関する次の記述のうち、最も不適切なものはどれか。なお、中小企業における経営の承継の円滑化に関する法律における「遺留分に関する民法の特例」は、以下「本特例」という。",
        "choice1": "本特例は、上場企業および非上場企業のいずれの株式も対象となる。",
        "choice2": "本特例の適用を受けることにより、会社事業後継者が旧代表者から贈与により取得した自社株式について、その価額を、遺留分を算定するための財産の価額に算入しないことができる。",
        "choice3": "Ｍ＆Ａにより、株式会社の取締役が保有する当該株式会社の株式を買収会社に譲渡した場合、譲渡所得の金額の計算上、その収入金額は、原則として、取引当事者間の契約により決定された譲渡金額である。",
        "choice4": "退任する経営者への役員退職金の原資の準備する方法として、契約者（＝保険料負担者）および死亡保険金受取人を法人、被保険者を経営者とする終身保険などの生命保険に加入することが考えられる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1360,
        "shikenId": 22,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "Ａさんが、原則として65歳から受給することができる老齢基礎年金および老齢厚生年金の年金額（2025年度価額）を計算した次の〈計算の手順〉の空欄①～④に入る最も適切な数値を答えなさい。計算にあたっては、《設例》の〈Ａさんとその家族に関する資料〉および下記の〈資料〉に基づくこと。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/2508fp2/1360_1.png'>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "",
        "answer": "777986,330504,260,330764",
        "score": "1,1,1,1",
        "image": "2508_1360.png"
    },
    {
        "id": 1361,
        "shikenId": 22,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、公的年金制度等の各種取扱いについて説明した。Ｍさんが説明した次の記述①～③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/2508fp2/1360_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2",
        "score": "1,1,1",
        "image": "2508_1360.png"
    },
    {
        "id": 1362,
        "shikenId": 22,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 2,
        "inputType": 7,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、国民年金基金および小規模企業共済制度について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/2508fp2/1360_3.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ハ,ト,チ",
        "score": "1,1,1",
        "image": "2508_1360.png"
    },
    {
        "id": 1363,
        "shikenId": 22,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんと長男Ｃさんに対して、株式取引のルール等について説明した。Ｍさんが説明した次の記述①～③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/2508fp2/1363_1.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,1",
        "score": "1,1,1",
        "image": "2508_1363.png"
    },
    {
        "id": 1364,
        "shikenId": 22,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "Ｍさんは、Ａさんと長男Ｃさんに対して、《設例》の〈Ｘ社株式およびＹ社株式の情報〉〈Ｘ社およびＹ社の財務データ〉に基づき、株式投資の主な投資指標について説明した。Ｍさんが説明した以下の文章の空欄①～④に入る最も適切な数値を答えなさい。〈答〉は、表示単位の小数点以下第３位を四捨五入し、小数点以下第２位までを答えること。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/2508fp2/1363_2.png'>",
        "choice1": "倍",
        "choice2": "％",
        "choice3": "％",
        "choice4": "％",
        "choice5": "",
        "answer": "25.00,62.50,2.50,6.25",
        "score": "1,1,1,1",
        "image": "2508_1363.png"
    },
    {
        "id": 1365,
        "shikenId": 22,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんと長男Ｃさんに対して、ＮＩＳＡについて説明した。Ｍさんが説明した次の記述①～③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/2508fp2/1363_3.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,1",
        "score": "1,1,1",
        "image": "2508_1363.png"
    },
    {
        "id": 1366,
        "shikenId": 22,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "ＡさんがＸ社から受け取った退職金に係る退職所得の金額を計算した下記の計算式の空欄①～④に入る最も適切な数値を答えなさい。なお、Ａさんは、これ以外に退職手当等の収入はないものとする。また、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/2508fp2/1366_1.png'>",
        "choice1": "万円",
        "choice2": "年",
        "choice3": "万円",
        "choice4": "万円",
        "choice5": "",
        "answer": "70,38,2060,370",
        "score": "1,1,1,1",
        "image": "2508_1366.png"
    },
    {
        "id": 1367,
        "shikenId": 22,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税の課税に関する次の記述①～③について、適切なものには○印を、不適切なものには×印を選択しなさい。<br><br><img class='question-img' src='/img/question/2508fp2/1366_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,1",
        "score": "1,1,1",
        "image": "2508_1366.png"
    },
    {
        "id": 1368,
        "shikenId": 22,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "Ａさんの2025年分の所得金額について、次の①、②を答えなさい。なお、①の計算上、Ａさんが所得金額調整控除の適用対象者に該当している場合、所得金額調整控除額を控除すること。また、〈答〉は万円単位とすること。<br><br><img class='question-img' src='/img/question/2508fp2/1366_3.png'>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "700,720",
        "score": "1,2",
        "image": "2508_1366.png"
    },
    {
        "id": 1369,
        "shikenId": 22,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "甲土地上に耐火建築物を建築する場合における次の①、②を答えなさい。〈答〉は㎡単位とすること。<br><br>① 建蔽率の上限となる建築面積<br>② 容積率の上限となる延べ面積",
        "choice1": "㎡",
        "choice2": "㎡",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "320,960",
        "score": "2,2",
        "image": "2508_1369.png"
    },
    {
        "id": 1370,
        "shikenId": 22,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "甲土地に関する次の記述①～③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/2508fp2/1369_2.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2",
        "score": "1,1,1",
        "image": "2508_1369.png"
    },
    {
        "id": 1371,
        "shikenId": 22,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 2,
        "inputType": 7,
        "question1": "",
        "question2": "借地借家法の事業用定期借地権等に係る借地契約に関する以下の文章の空欄①〜③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/2508fp2/1369_3.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "イ,ホ,ト",
        "score": "1,1,1",
        "image": "2508_1369.png"
    },
    {
        "id": 1372,
        "shikenId": 22,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんの相続に関する次の記述①～④について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/2508fp2/1372_1.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1,1",
        "score": "1,1,1,1",
        "image": "2508_1372.png"
    },
    {
        "id": 1373,
        "shikenId": 22,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 2,
        "inputType": 7,
        "question1": "",
        "question2": "「直系尊属から住宅取得等資金の贈与を受けた場合の贈与税の非課税」（以下、「本特例」という）に関する以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br><img class='question-img' src='/img/question/2508fp2/1372_2.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ホ,ロ,ト",
        "score": "1,1,1",
        "image": "2508_1372.png"
    },
    {
        "id": 1374,
        "shikenId": 22,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "Ａさんの相続が現時点で開始した場合における相続税の総額を試算した下記の表の空欄①～③に入る最も適切な数値を答えなさい。なお、課税遺産総額（相続税の課税価格の合計額－遺産に係る基礎控除額）は３億2,000万円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/2508fp2/1372_3.png'>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "answer": "4800,1700,8100",
        "score": "1,1,1",
        "image": "2508_1372.png"
    },
    {
        "id": 1375,
        "shikenId": 22,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "Ａさんが、原則として65歳から受給することができる老齢基礎年金および老齢厚生年金の年金額（2025年度価額）を計算した次の＜計算の手順＞の空欄①～④に入る最も適切な数値を答えなさい。計算にあたっては≪設例≫の＜Ａさんとその家族に関する資料＞および下記の＜資料＞に基づくこと。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/2508fp2/1375_1.png'>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "",
        "answer": "831700,1236709,59532,1296241",
        "score": "1,1,1,1",
        "image": "2508_1375.png"
    },
    {
        "id": 1376,
        "shikenId": 22,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、老後の年金収入を増やす方法として確定拠出年金の個人型年金（以下、「個人型年金」という）について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/2508fp2/1375_2.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ロ,ヘ,リ",
        "score": "1,1,1",
        "image": "2508_1375.png"
    },
    {
        "id": 1377,
        "shikenId": 22,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、各種のアドバイスをした。Ｍさんがアドバイスした次の記述①～③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/2508fp2/1375_3.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1",
        "score": "1,1,1",
        "image": "2508_1375.png"
    },
    {
        "id": 1378,
        "shikenId": 22,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、下記の＜前提＞においてＡさんが死亡した場合、妻Ｂさんが受給することができる公的年金制度からの遺族給付について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br><img class='question-img' src='/img/question/2508fp2/1378_1.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ロ,ヘ,リ",
        "score": "1,1,1",
        "image": "2508_1378.png"
    },
    {
        "id": 1379,
        "shikenId": 22,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、必要保障額およびＡさんが提案を受けた生命保険の保障金額について説明した。Ｍさんが説明した以下の文章の空欄①、②に入る最も適切な数値を答えなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/2508fp2/1378_2.png'>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "4524,5000",
        "score": "2,1",
        "image": "2508_1378.png"
    },
    {
        "id": 1380,
        "shikenId": 22,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、Ａさんが提案を受けた生命保険の保障内容および課税関係について説明した。Ｍさんが説明した次の記述①～④について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/2508fp2/1378_3.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2,1",
        "score": "1,1,1,1",
        "image": "2508_1378.png"
    },
    {
        "id": 1381,
        "shikenId": 22,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "仮に、Ｘ社がＡさんに役員退職金5,000万円を支給した場合、Ａさんが受け取る役員退職金について、次の①、②を答えなさい。＜答＞は万円単位とすること。なお、Ａさんの役員在任期間（勤続年数）は21年３カ月とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。<br><br>① 退職所得控除額<br>② 退職所得の金額",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "940,2030",
        "score": "1,2",
        "image": "2508_1381.png"
    },
    {
        "id": 1382,
        "shikenId": 22,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "＜資料１＞の生命保険を現時点で解約した場合のＸ社の経理処理（仕訳）について、下記の＜条件＞を基に、空欄①～④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br><img class='question-img' src='/img/question/2508fp2/1381_2.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ニ,ハ,リ,ロ",
        "score": "1,1,1,1",
        "image": "2508_1381.png"
    },
    {
        "id": 1383,
        "shikenId": 22,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、長女Ｂさんに対して、＜資料２＞の生命保険について説明した。Ｍさんが説明した次の記述①～③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/2508fp2/1381_3.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,2",
        "score": "1,1,1",
        "image": "2508_1381.png"
    },
    {
        "id": 1384,
        "shikenId": 22,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税の課税等に関する次の記述①～③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/2508fp2/1384_1.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,1,1",
        "score": "1,1,1",
        "image": "2508_1384.png"
    },
    {
        "id": 1385,
        "shikenId": 22,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税における所得控除に関する以下の文章の空欄①～④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/2508fp2/1384_2.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ホ,ト,リ,イ",
        "score": "1,1,1,1",
        "image": "2508_1384.png"
    },
    {
        "id": 1386,
        "shikenId": 22,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "Ａさんの2025年分の所得税の算出税額を試算した下記の表の空欄①～③に入る最も適切な数値を答えなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/2508fp2/1384_3.png'>",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "",
        "choice5": "",
        "answer": "3160000,3560000,35000",
        "score": "1,1,1",
        "image": "2508_1384.png"
    },
    {
        "id": 1387,
        "shikenId": 22,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんの相続に関する次の記述①～④について、適切なものは○を、不適切なものは×を選択しなさい。<br><br><img class='question-img' src='/img/question/2508fp2/1387_1.png'>",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,1,1",
        "score": "1,1,1,1",
        "image": "2508_1387.png"
    },
    {
        "id": 1388,
        "shikenId": 22,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "Ａさんの相続に関する以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br><img class='question-img' src='/img/question/2508fp2/1387_2.png'>",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "イ,チ,ホ",
        "score": "1,1,1",
        "image": "2508_1387.png"
    },
    {
        "id": 1389,
        "shikenId": 22,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "現時点において、Ａさんの相続が開始した場合における相続税の総額を試算した下記の表の空欄①～③に入る最も適切な数値を答えなさい。なお、相続税の課税価格の合計額は３億8,000万円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br><img class='question-img' src='/img/question/2508fp2/1387_3.png'>",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "answer": "4800,1790,8520",
        "score": "1,1,1",
        "image": "2508_1387.png"
    },
    {
        "id": 1390,
        "shikenId": 22,
        "parentNo": 2,
        "no": 1,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/2508fp2/s1.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,2,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1391,
        "shikenId": 22,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/2508fp2/s2.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "2",
        "image": ""
    },
    {
        "id": 1392,
        "shikenId": 22,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/2508fp2/s3.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "2",
        "image": ""
    },
    {
        "id": 1393,
        "shikenId": 22,
        "parentNo": 2,
        "no": 4,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s4.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "％",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1.595",
        "score": "2",
        "image": ""
    },
    {
        "id": 1394,
        "shikenId": 22,
        "parentNo": 2,
        "no": 5,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s5.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "倍",
        "choice2": "％",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1.05,7.26",
        "score": "2,2",
        "image": ""
    },
    {
        "id": 1395,
        "shikenId": 22,
        "parentNo": 2,
        "no": 6,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/2508fp2/s6.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1396,
        "shikenId": 22,
        "parentNo": 2,
        "no": 7,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s7.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2867376",
        "score": "2",
        "image": ""
    },
    {
        "id": 1397,
        "shikenId": 22,
        "parentNo": 2,
        "no": 8,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s8.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "㎡",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "210",
        "score": "2",
        "image": ""
    },
    {
        "id": 1398,
        "shikenId": 22,
        "parentNo": 1,
        "no": 9,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/2508fp2/s9.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "2",
        "image": ""
    },
    {
        "id": 1399,
        "shikenId": 22,
        "parentNo": 2,
        "no": 10,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/2508fp2/s10.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1400,
        "shikenId": 22,
        "parentNo": 1,
        "no": 11,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/2508fp2/s11.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "2",
        "image": ""
    },
    {
        "id": 1401,
        "shikenId": 22,
        "parentNo": 1,
        "no": 12,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/2508fp2/s12.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "1",
        "score": "2",
        "image": ""
    },
    {
        "id": 1402,
        "shikenId": 22,
        "parentNo": 2,
        "no": 13,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s13.png\" class=\"question-img\" /><br><br><img src=\"/img/question/2508fp2/s13_2.png\" class=\"question-img\" /><br><img src=\"/img/question/2508fp2/s13_3.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "answer": "202,1068,3710",
        "score": "2,2,2",
        "image": ""
    },
    {
        "id": 1403,
        "shikenId": 22,
        "parentNo": 1,
        "no": 14,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/2508fp2/s14.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "2",
        "image": ""
    },
    {
        "id": 1404,
        "shikenId": 22,
        "parentNo": 2,
        "no": 15,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s15.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "86530",
        "score": "2",
        "image": ""
    },
    {
        "id": 1405,
        "shikenId": 22,
        "parentNo": 2,
        "no": 16,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/2508fp2/s16.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,1,2,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1406,
        "shikenId": 22,
        "parentNo": 2,
        "no": 17,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s17.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "17400",
        "score": "2",
        "image": ""
    },
    {
        "id": 1407,
        "shikenId": 22,
        "parentNo": 2,
        "no": 18,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s18.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "95",
        "score": "2",
        "image": ""
    },
    {
        "id": 1408,
        "shikenId": 22,
        "parentNo": 2,
        "no": 19,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s19.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "165",
        "score": "2",
        "image": ""
    },
    {
        "id": 1409,
        "shikenId": 22,
        "parentNo": 1,
        "no": 20,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/2508fp2/s20.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "2",
        "image": ""
    },
    {
        "id": 1410,
        "shikenId": 22,
        "parentNo": 2,
        "no": 21,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s21.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "490",
        "score": "2",
        "image": ""
    },
    {
        "id": 1411,
        "shikenId": 22,
        "parentNo": 2,
        "no": 22,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/2508fp2/s22.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,2,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1412,
        "shikenId": 22,
        "parentNo": 2,
        "no": 23,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/2508fp2/s23.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,1",
        "score": "1,1,1",
        "image": ""
    },
    {
        "id": 1413,
        "shikenId": 22,
        "parentNo": 2,
        "no": 24,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s24.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2800",
        "score": "2",
        "image": ""
    },
    {
        "id": 1414,
        "shikenId": 22,
        "parentNo": 2,
        "no": 25,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s25.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "338",
        "score": "2",
        "image": ""
    },
    {
        "id": 1415,
        "shikenId": 22,
        "parentNo": 1,
        "no": 26,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/2508fp2/s26.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "2",
        "image": ""
    },
    {
        "id": 1416,
        "shikenId": 22,
        "parentNo": 2,
        "no": 27,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/2508fp2/s27.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1417,
        "shikenId": 22,
        "parentNo": 2,
        "no": 28,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s28.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "336",
        "score": "2",
        "image": ""
    },
    {
        "id": 1418,
        "shikenId": 22,
        "parentNo": 2,
        "no": 29,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s29.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "568",
        "score": "2",
        "image": ""
    },
    {
        "id": 1419,
        "shikenId": 22,
        "parentNo": 1,
        "no": 30,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/2508fp2/s30.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1420,
        "shikenId": 22,
        "parentNo": 2,
        "no": 31,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s31.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "3249000",
        "score": "2",
        "image": ""
    },
    {
        "id": 1421,
        "shikenId": 22,
        "parentNo": 2,
        "no": 32,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s32.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "4024250",
        "score": "2",
        "image": ""
    },
    {
        "id": 1422,
        "shikenId": 22,
        "parentNo": 2,
        "no": 33,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s33.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "396000",
        "score": "2",
        "image": ""
    },
    {
        "id": 1423,
        "shikenId": 22,
        "parentNo": 2,
        "no": 34,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/2508fp2/s34.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "6430",
        "score": "1",
        "image": ""
    },
    {
        "id": 1424,
        "shikenId": 22,
        "parentNo": 1,
        "no": 35,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/2508fp2/s35.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "2",
        "image": ""
    },
    {
        "id": 1425,
        "shikenId": 22,
        "parentNo": 2,
        "no": 36,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/2508fp2/s36.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1426,
        "shikenId": 22,
        "parentNo": 1,
        "no": 37,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/2508fp2/s37.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "1",
        "score": "2",
        "image": ""
    },
    {
        "id": 1427,
        "shikenId": 22,
        "parentNo": 1,
        "no": 38,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/2508fp2/s38.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "2",
        "image": ""
    },
    {
        "id": 1428,
        "shikenId": 22,
        "parentNo": 1,
        "no": 39,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "<img src=\"/img/question/2508fp2/s39.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "2",
        "image": ""
    },
    {
        "id": 1429,
        "shikenId": 22,
        "parentNo": 2,
        "no": 40,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "<img src=\"/img/question/2508fp2/s40.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,2",
        "score": "1,1,1",
        "image": ""
    }
]